(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.gM.c0 === region.hU.c0)
	{
		return 'on line ' + region.gM.c0;
	}
	return 'on lines ' + region.gM.c0 + ' through ' + region.hU.c0;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.lY,
		impl.or,
		impl.nN,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		be: func(record.be),
		gO: record.gO,
		gn: record.gn
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.be;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.gO;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.gn) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.lY,
		impl.or,
		impl.nN,
		function(sendToApp, initialModel) {
			var view = impl.oA;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.lY,
		impl.or,
		impl.nN,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.gE && impl.gE(sendToApp)
			var view = impl.oA;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.hy);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.n$) && (_VirtualDom_doc.title = title = doc.n$);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.my;
	var onUrlRequest = impl.mz;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		gE: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.jf === next.jf
							&& curr.ib === next.ib
							&& curr.ja.a === next.ja.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		lY: function(flags)
		{
			return A3(impl.lY, flags, _Browser_getUrl(), key);
		},
		oA: impl.oA,
		or: impl.or,
		nN: impl.nN
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { lM: 'hidden', kS: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { lM: 'mozHidden', kS: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { lM: 'msHidden', kS: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { lM: 'webkitHidden', kS: 'webkitvisibilitychange' }
		: { lM: 'hidden', kS: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		jx: _Browser_getScene(),
		kh: {
			kn: _Browser_window.pageXOffset,
			ko: _Browser_window.pageYOffset,
			kk: _Browser_doc.documentElement.clientWidth,
			h7: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		kk: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		h7: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			jx: {
				kk: node.scrollWidth,
				h7: node.scrollHeight
			},
			kh: {
				kn: node.scrollLeft,
				ko: node.scrollTop,
				kk: node.clientWidth,
				h7: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			jx: _Browser_getScene(),
			kh: {
				kn: x,
				ko: y,
				kk: _Browser_doc.documentElement.clientWidth,
				h7: _Browser_doc.documentElement.clientHeight
			},
			lp: {
				kn: x + rect.left,
				ko: y + rect.top,
				kk: rect.width,
				h7: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.hY.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.hY.b, xhr)); });
		$elm$core$Maybe$isJust(request.j5) && _Http_track(router, xhr, request.j5.a);

		try {
			xhr.open(request.iK, request.kb, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.kb));
		}

		_Http_configureRequest(xhr, request);

		request.hy.a && xhr.setRequestHeader('Content-Type', request.hy.a);
		xhr.send(request.hy.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.h6; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.j_.a || 0;
	xhr.responseType = request.hY.d;
	xhr.withCredentials = request.kv;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		kb: xhr.responseURL,
		nG: xhr.status,
		nH: xhr.statusText,
		h6: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			nr: event.loaded,
			ay: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			m1: event.loaded,
			ay: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}
var $author$project$App$Messages$LinkClicked = function (a) {
	return {$: 1, a: a};
};
var $author$project$App$Messages$UrlChanged = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.B) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.G),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.G);
		} else {
			var treeLen = builder.B * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.K) : builder.K;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.B);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.G) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.G);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{K: nodeList, B: (len / $elm$core$Array$branchFactor) | 0, G: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {h3: fragment, ib: host, i6: path, ja: port_, jf: protocol, jg: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $author$project$App$AppBar$Model$Activity = 1;
var $author$project$App$Messages$ActivityMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$App$Messages$AppBarMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$App$Auth$Messages$AuthAttempt = {$: 0};
var $author$project$App$Messages$AuthMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$Dashboard = 1;
var $author$project$App$Messages$LandingMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$App$Messages$ReviewMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$App$Messages$SearchMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$App$Messages$SentenceMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Route$SignIn = 3;
var $author$project$Route$SignUp = 2;
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$App$Search$Messages$GotWordLinks = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.nG));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {jm: reqs, jO: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.j5;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.jm));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.jO)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					kv: r.kv,
					hy: r.hy,
					hY: A2(_Http_mapExpect, func, r.hY),
					h6: r.h6,
					iK: r.iK,
					j_: r.j_,
					j5: r.j5,
					kb: r.kb
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{kv: true, hy: r.hy, hY: r.hY, h6: r.h6, iK: r.iK, j_: r.j_, j5: r.j5, kb: r.kb}));
};
var $author$project$Api$urlPrefix = 'api';
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Models$Word$WordLink = F6(
	function (src, srcPos, dst, dstPos, rel, tags) {
		return {hS: dst, ll: dstPos, m4: rel, nC: src, nD: srcPos, nS: tags};
	});
var $author$project$Models$Word$Abbrev = 5;
var $author$project$Models$Word$Adj = 1;
var $author$project$Models$Word$Adv = 9;
var $author$project$Models$Word$Affix = 26;
var $author$project$Models$Word$Article = 20;
var $author$project$Models$Word$Character = 19;
var $author$project$Models$Word$Circumfix = 25;
var $author$project$Models$Word$Circumpos = 24;
var $author$project$Models$Word$Conj = 21;
var $author$project$Models$Word$Contraction = 14;
var $author$project$Models$Word$Det = 17;
var $author$project$Models$Word$Inf = 30;
var $author$project$Models$Word$Infix = 28;
var $author$project$Models$Word$Interfix = 22;
var $author$project$Models$Word$Intj = 12;
var $author$project$Models$Word$Name = 4;
var $author$project$Models$Word$Noun = 2;
var $author$project$Models$Word$Num = 11;
var $author$project$Models$Word$Particle = 18;
var $author$project$Models$Word$Phrase = 3;
var $author$project$Models$Word$Postp = 23;
var $author$project$Models$Word$Prefix = 7;
var $author$project$Models$Word$Prep = 8;
var $author$project$Models$Word$PrepPhrase = 10;
var $author$project$Models$Word$Pron = 16;
var $author$project$Models$Word$Proverb = 15;
var $author$project$Models$Word$Punct = 27;
var $author$project$Models$Word$Suffix = 13;
var $author$project$Models$Word$Symbol = 6;
var $author$project$Models$Word$Unknown = 29;
var $author$project$Models$Word$Verb = 0;
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Decoders$poSDecoder = function () {
	var toPoS = function (string) {
		switch (string) {
			case 'Verb':
				return $elm$json$Json$Decode$succeed(0);
			case 'Adj':
				return $elm$json$Json$Decode$succeed(1);
			case 'Noun':
				return $elm$json$Json$Decode$succeed(2);
			case 'Phrase':
				return $elm$json$Json$Decode$succeed(3);
			case 'Name':
				return $elm$json$Json$Decode$succeed(4);
			case 'Abbrev':
				return $elm$json$Json$Decode$succeed(5);
			case 'Symbol':
				return $elm$json$Json$Decode$succeed(6);
			case 'Prefix':
				return $elm$json$Json$Decode$succeed(7);
			case 'Prep':
				return $elm$json$Json$Decode$succeed(8);
			case 'Adv':
				return $elm$json$Json$Decode$succeed(9);
			case 'PrepPhrase':
				return $elm$json$Json$Decode$succeed(10);
			case 'Num':
				return $elm$json$Json$Decode$succeed(11);
			case 'Intj':
				return $elm$json$Json$Decode$succeed(12);
			case 'Suffix':
				return $elm$json$Json$Decode$succeed(13);
			case 'Contraction':
				return $elm$json$Json$Decode$succeed(14);
			case 'Proverb':
				return $elm$json$Json$Decode$succeed(15);
			case 'Pron':
				return $elm$json$Json$Decode$succeed(16);
			case 'Det':
				return $elm$json$Json$Decode$succeed(17);
			case 'Particle':
				return $elm$json$Json$Decode$succeed(18);
			case 'Character':
				return $elm$json$Json$Decode$succeed(19);
			case 'Article':
				return $elm$json$Json$Decode$succeed(20);
			case 'Conj':
				return $elm$json$Json$Decode$succeed(21);
			case 'Interfix':
				return $elm$json$Json$Decode$succeed(22);
			case 'Postp':
				return $elm$json$Json$Decode$succeed(23);
			case 'Circumpos':
				return $elm$json$Json$Decode$succeed(24);
			case 'Circumfix':
				return $elm$json$Json$Decode$succeed(25);
			case 'Affix':
				return $elm$json$Json$Decode$succeed(26);
			case 'Punct':
				return $elm$json$Json$Decode$succeed(27);
			case 'Infix':
				return $elm$json$Json$Decode$succeed(28);
			case 'Unknown':
				return $elm$json$Json$Decode$succeed(29);
			case 'Inf':
				return $elm$json$Json$Decode$succeed(30);
			default:
				return $elm$json$Json$Decode$fail('invalid pos variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toPoS, $elm$json$Json$Decode$string);
}();
var $author$project$Models$Word$Alt = 1;
var $author$project$Models$Word$Antonym = 3;
var $author$project$Models$Word$CompoundBase = 13;
var $author$project$Models$Word$CompoundPart = 12;
var $author$project$Models$Word$CoordinateTerm = 10;
var $author$project$Models$Word$Derived = 4;
var $author$project$Models$Word$Form = 0;
var $author$project$Models$Word$Holonym = 7;
var $author$project$Models$Word$Hypernym = 9;
var $author$project$Models$Word$Hyponym = 8;
var $author$project$Models$Word$Meronym = 6;
var $author$project$Models$Word$Related = 5;
var $author$project$Models$Word$Representative = 14;
var $author$project$Models$Word$Synonym = 2;
var $author$project$Models$Word$Translation = 11;
var $author$project$Decoders$relDecoder = function () {
	var toRelationship = function (string) {
		switch (string) {
			case 'Form':
				return $elm$json$Json$Decode$succeed(0);
			case 'Alt':
				return $elm$json$Json$Decode$succeed(1);
			case 'Synonym':
				return $elm$json$Json$Decode$succeed(2);
			case 'Antonym':
				return $elm$json$Json$Decode$succeed(3);
			case 'Derived':
				return $elm$json$Json$Decode$succeed(4);
			case 'Related':
				return $elm$json$Json$Decode$succeed(5);
			case 'Meronym':
				return $elm$json$Json$Decode$succeed(6);
			case 'Holonym':
				return $elm$json$Json$Decode$succeed(7);
			case 'Hyponym':
				return $elm$json$Json$Decode$succeed(8);
			case 'Hypernym':
				return $elm$json$Json$Decode$succeed(9);
			case 'CoordinateTerm':
				return $elm$json$Json$Decode$succeed(10);
			case 'Translation':
				return $elm$json$Json$Decode$succeed(11);
			case 'CompoundPart':
				return $elm$json$Json$Decode$succeed(12);
			case 'CompoundBase':
				return $elm$json$Json$Decode$succeed(13);
			case 'Representative':
				return $elm$json$Json$Decode$succeed(14);
			default:
				return $elm$json$Json$Decode$fail('invalid rel variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toRelationship, $elm$json$Json$Decode$string);
}();
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$field = _Json_decodeField;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Models$Word$Tag = function (gender) {
	return function (cases) {
		return function (countable) {
			return function (hasArticle) {
				return function (specificity) {
					return function (adjDegree) {
						return function (adjRole) {
							return function (strength) {
								return function (count) {
									return function (person) {
										return function (tense) {
											return function (aspect) {
												return function (modality) {
													return function (voice) {
														return function (clause) {
															return function (participle) {
																return function (aux_verb) {
																	return function (verb) {
																		return function (verbClass) {
																			return function (verbObject) {
																				return function (name_case) {
																					return function (morph) {
																						return {hj: adjDegree, ks: adjRole, kD: aspect, kG: aux_verb, hB: cases, kV: clause, k3: count, k4: countable, h4: gender, lK: hasArticle, mi: modality, iO: morph, mo: name_case, i5: participle, mK: person, nB: specificity, nK: strength, nV: tense, ou: verb, ov: verbClass, ow: verbObject, oB: voice};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Models$Word$Comparative = 1;
var $author$project$Models$Word$NotComparable = 3;
var $author$project$Models$Word$Positive = 0;
var $author$project$Models$Word$Superlative = 2;
var $author$project$Decoders$adjDegreeDecoder = function () {
	var toAdjDegree = function (string) {
		switch (string) {
			case 'Positive':
				return $elm$json$Json$Decode$succeed(0);
			case 'Comparative':
				return $elm$json$Json$Decode$succeed(1);
			case 'Superlative':
				return $elm$json$Json$Decode$succeed(2);
			case 'NotComparable':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('invalid adj-degree variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toAdjDegree, $elm$json$Json$Decode$string);
}();
var $author$project$Models$Word$NoPredicative = 1;
var $author$project$Models$Word$Predicative = 0;
var $author$project$Decoders$adjRoleDecoder = function () {
	var toAdjRole = function (string) {
		switch (string) {
			case 'Predicative':
				return $elm$json$Json$Decode$succeed(0);
			case 'NoPredicative':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('invalid adj-role variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toAdjRole, $elm$json$Json$Decode$string);
}();
var $author$project$Models$Word$Perfect = 1;
var $author$project$Models$Word$Simple = 0;
var $author$project$Decoders$aspectDecoder = function () {
	var toAspect = function (string) {
		switch (string) {
			case 'Simple':
				return $elm$json$Json$Decode$succeed(0);
			case 'Perfect':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('invalid aspect variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toAspect, $elm$json$Json$Decode$string);
}();
var $author$project$Models$Word$Haben = 1;
var $author$project$Models$Word$Sein = 0;
var $author$project$Decoders$auxVerbDecoder = function () {
	var toAuxVerb = function (string) {
		switch (string) {
			case 'sein':
				return $elm$json$Json$Decode$succeed(0);
			case 'haben':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('invalid aux-verb variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toAuxVerb, $elm$json$Json$Decode$string);
}();
var $author$project$Models$Word$Acc = 1;
var $author$project$Models$Word$Dat = 2;
var $author$project$Models$Word$Gen = 3;
var $author$project$Models$Word$Nom = 0;
var $author$project$Decoders$casesDecoder = function () {
	var toCases = function (string) {
		switch (string) {
			case 'Nom':
				return $elm$json$Json$Decode$succeed(0);
			case 'Acc':
				return $elm$json$Json$Decode$succeed(1);
			case 'Dat':
				return $elm$json$Json$Decode$succeed(2);
			case 'Gen':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('invalid cases variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toCases, $elm$json$Json$Decode$string);
}();
var $author$project$Models$Word$Main = 0;
var $author$project$Models$Word$Subordinate = 1;
var $author$project$Decoders$clauseDecoder = function () {
	var toClause = function (string) {
		switch (string) {
			case 'Main':
				return $elm$json$Json$Decode$succeed(0);
			case 'Subordinate':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('invalid clause variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toClause, $elm$json$Json$Decode$string);
}();
var $author$project$Models$Word$P = 1;
var $author$project$Models$Word$S = 0;
var $author$project$Models$Word$SP = 2;
var $author$project$Decoders$countDecoder = function () {
	var toCount = function (string) {
		switch (string) {
			case 'S':
				return $elm$json$Json$Decode$succeed(0);
			case 'P':
				return $elm$json$Json$Decode$succeed(1);
			case 'SP':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('invalid count variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toCount, $elm$json$Json$Decode$string);
}();
var $author$project$Models$Word$Countable = 0;
var $author$project$Models$Word$PluralNoramlly = 3;
var $author$project$Models$Word$PluralOnly = 2;
var $author$project$Models$Word$WithoutPlural = 1;
var $author$project$Decoders$countableDecoder = function () {
	var toCountable = function (string) {
		switch (string) {
			case 'Countable':
				return $elm$json$Json$Decode$succeed(0);
			case 'WithoutPlural':
				return $elm$json$Json$Decode$succeed(1);
			case 'PluralOnly':
				return $elm$json$Json$Decode$succeed(2);
			case 'PluralNoramlly':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('invalid countable variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toCountable, $elm$json$Json$Decode$string);
}();
var $author$project$Models$Word$F = 0;
var $author$project$Models$Word$FM = 3;
var $author$project$Models$Word$FMN = 6;
var $author$project$Models$Word$FN = 4;
var $author$project$Models$Word$M = 1;
var $author$project$Models$Word$MN = 5;
var $author$project$Models$Word$N = 2;
var $author$project$Decoders$genderDecoder = function () {
	var toGender = function (string) {
		switch (string) {
			case 'F':
				return $elm$json$Json$Decode$succeed(0);
			case 'M':
				return $elm$json$Json$Decode$succeed(1);
			case 'N':
				return $elm$json$Json$Decode$succeed(2);
			case 'FM':
				return $elm$json$Json$Decode$succeed(3);
			case 'FN':
				return $elm$json$Json$Decode$succeed(4);
			case 'MN':
				return $elm$json$Json$Decode$succeed(5);
			case 'FMN':
				return $elm$json$Json$Decode$succeed(6);
			default:
				return $elm$json$Json$Decode$fail('invalid gender variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toGender, $elm$json$Json$Decode$string);
}();
var $author$project$Models$Word$Includes = 4;
var $author$project$Models$Word$Negative = 3;
var $author$project$Models$Word$UsuallyWithout = 2;
var $author$project$Models$Word$With = 0;
var $author$project$Models$Word$Without = 1;
var $author$project$Decoders$hasArticleDecoder = function () {
	var toHasArticle = function (string) {
		switch (string) {
			case 'With':
				return $elm$json$Json$Decode$succeed(0);
			case 'Without':
				return $elm$json$Json$Decode$succeed(1);
			case 'UsuallyWithout':
				return $elm$json$Json$Decode$succeed(2);
			case 'Negative':
				return $elm$json$Json$Decode$succeed(3);
			case 'Includes':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('invalid has-article variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toHasArticle, $elm$json$Json$Decode$string);
}();
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$Models$Word$Imperative = 4;
var $author$project$Models$Word$Indicative = 0;
var $author$project$Models$Word$Subjunctive = 1;
var $author$project$Models$Word$SubjunctiveI = 2;
var $author$project$Models$Word$SubjunctiveII = 3;
var $author$project$Decoders$modalityDecoder = function () {
	var toModality = function (string) {
		switch (string) {
			case 'Indicative':
				return $elm$json$Json$Decode$succeed(0);
			case 'Subjunctive':
				return $elm$json$Json$Decode$succeed(1);
			case 'SubjunctiveI':
				return $elm$json$Json$Decode$succeed(2);
			case 'SubjunctiveII':
				return $elm$json$Json$Decode$succeed(3);
			case 'Imperative':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('invalid modality variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toModality, $elm$json$Json$Decode$string);
}();
var $author$project$Models$Word$Abbreviation = 2;
var $author$project$Models$Word$Adjectival = 5;
var $author$project$Models$Word$Agent = 8;
var $author$project$Models$Word$Alternative = 3;
var $author$project$Models$Word$Canonical = 1;
var $author$project$Models$Word$Diminutive = 7;
var $author$project$Models$Word$FormOf = 0;
var $author$project$Models$Word$FromVerb = 6;
var $author$project$Models$Word$Gerund = 9;
var $author$project$Models$Word$Indeclinable = 10;
var $author$project$Models$Word$NounFromVerb = 4;
var $author$project$Models$Word$Numeral = 11;
var $author$project$Decoders$morphDecoder = function () {
	var toMorph = function (string) {
		switch (string) {
			case 'FormOf':
				return $elm$json$Json$Decode$succeed(0);
			case 'Canonical':
				return $elm$json$Json$Decode$succeed(1);
			case 'Abbreviation':
				return $elm$json$Json$Decode$succeed(2);
			case 'Alternative':
				return $elm$json$Json$Decode$succeed(3);
			case 'NounFromVerb':
				return $elm$json$Json$Decode$succeed(4);
			case 'Adjectival':
				return $elm$json$Json$Decode$succeed(5);
			case 'FromVerb':
				return $elm$json$Json$Decode$succeed(6);
			case 'Diminutive':
				return $elm$json$Json$Decode$succeed(7);
			case 'Agent':
				return $elm$json$Json$Decode$succeed(8);
			case 'Gerund':
				return $elm$json$Json$Decode$succeed(9);
			case 'Indeclinable':
				return $elm$json$Json$Decode$succeed(10);
			case 'Numeral':
				return $elm$json$Json$Decode$succeed(11);
			default:
				return $elm$json$Json$Decode$fail('invalid morph variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toMorph, $elm$json$Json$Decode$string);
}();
var $author$project$Models$Word$Ablative = 0;
var $author$project$Models$Word$Vocative = 1;
var $author$project$Decoders$nameCaseDecoder = function () {
	var toNameCase = function (string) {
		switch (string) {
			case 'Ablative':
				return $elm$json$Json$Decode$succeed(0);
			case 'Vocative':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('invalid name-case variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toNameCase, $elm$json$Json$Decode$string);
}();
var $author$project$Models$Word$PGerundive = 3;
var $author$project$Models$Word$PParticiple = 2;
var $author$project$Models$Word$PPast = 1;
var $author$project$Models$Word$PPresent = 0;
var $author$project$Decoders$participleDecoder = function () {
	var toParticiple = function (string) {
		switch (string) {
			case 'Present':
				return $elm$json$Json$Decode$succeed(0);
			case 'Past':
				return $elm$json$Json$Decode$succeed(1);
			case 'Participle':
				return $elm$json$Json$Decode$succeed(2);
			case 'Gerundive':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('invalid participle variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toParticiple, $elm$json$Json$Decode$string);
}();
var $author$project$Models$Word$P1 = 0;
var $author$project$Models$Word$P2 = 1;
var $author$project$Models$Word$P3 = 2;
var $author$project$Decoders$personDecoder = function () {
	var toPerson = function (string) {
		switch (string) {
			case 'P1':
				return $elm$json$Json$Decode$succeed(0);
			case 'P2':
				return $elm$json$Json$Decode$succeed(1);
			case 'P3':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('invalid person variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toPerson, $elm$json$Json$Decode$string);
}();
var $author$project$Models$Word$Definite = 0;
var $author$project$Models$Word$Indefinite = 1;
var $author$project$Decoders$specificityDecoder = function () {
	var toSpecificity = function (string) {
		switch (string) {
			case 'Definite':
				return $elm$json$Json$Decode$succeed(0);
			case 'Indefinite':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('invalid specificity variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toSpecificity, $elm$json$Json$Decode$string);
}();
var $author$project$Models$Word$Both = 2;
var $author$project$Models$Word$Strong = 0;
var $author$project$Models$Word$Weak = 1;
var $author$project$Decoders$strengthDecoder = function () {
	var toStrength = function (string) {
		switch (string) {
			case 'Strong':
				return $elm$json$Json$Decode$succeed(0);
			case 'Weak':
				return $elm$json$Json$Decode$succeed(1);
			case 'Both':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('invalid strength variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toStrength, $elm$json$Json$Decode$string);
}();
var $author$project$Models$Word$Future = 2;
var $author$project$Models$Word$FutureI = 3;
var $author$project$Models$Word$FutureII = 4;
var $author$project$Models$Word$Past = 1;
var $author$project$Models$Word$Present = 0;
var $author$project$Decoders$tenseDecoder = function () {
	var toTense = function (string) {
		switch (string) {
			case 'Present':
				return $elm$json$Json$Decode$succeed(0);
			case 'Past':
				return $elm$json$Json$Decode$succeed(1);
			case 'Future':
				return $elm$json$Json$Decode$succeed(2);
			case 'FutureI':
				return $elm$json$Json$Decode$succeed(3);
			case 'FutureII':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('invalid tense variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toTense, $elm$json$Json$Decode$string);
}();
var $author$project$Models$Word$C1 = 0;
var $author$project$Models$Word$C2 = 1;
var $author$project$Models$Word$C3 = 2;
var $author$project$Models$Word$C4 = 3;
var $author$project$Models$Word$C5 = 4;
var $author$project$Models$Word$C6 = 5;
var $author$project$Models$Word$C7 = 6;
var $author$project$Decoders$verbClassDecoder = function () {
	var toVerbClass = function (string) {
		switch (string) {
			case 'C1':
				return $elm$json$Json$Decode$succeed(0);
			case 'C2':
				return $elm$json$Json$Decode$succeed(1);
			case 'C3':
				return $elm$json$Json$Decode$succeed(2);
			case 'C4':
				return $elm$json$Json$Decode$succeed(3);
			case 'C5':
				return $elm$json$Json$Decode$succeed(4);
			case 'C6':
				return $elm$json$Json$Decode$succeed(5);
			case 'C7':
				return $elm$json$Json$Decode$succeed(6);
			default:
				return $elm$json$Json$Decode$fail('invalid verb-class variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toVerbClass, $elm$json$Json$Decode$string);
}();
var $author$project$Models$Word$Auxiliary = 0;
var $author$project$Models$Word$Impersonal = 1;
var $author$project$Models$Word$Infinitive = 2;
var $author$project$Models$Word$StatalReflexive = 4;
var $author$project$Models$Word$ZuInfinitive = 3;
var $author$project$Decoders$verbDecoder = function () {
	var toVerb = function (string) {
		switch (string) {
			case 'Auxiliary':
				return $elm$json$Json$Decode$succeed(0);
			case 'Impersonal':
				return $elm$json$Json$Decode$succeed(1);
			case 'Infinitive':
				return $elm$json$Json$Decode$succeed(2);
			case 'ZuInfinitive':
				return $elm$json$Json$Decode$succeed(3);
			case 'StatalReflexive':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('invalid verb variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toVerb, $elm$json$Json$Decode$string);
}();
var $author$project$Models$Word$Ditransitive = 2;
var $author$project$Models$Word$Intransitive = 1;
var $author$project$Models$Word$Reflexive = 3;
var $author$project$Models$Word$Transitive = 0;
var $author$project$Decoders$verbObjectDecoder = function () {
	var toVerbObject = function (string) {
		switch (string) {
			case 'Transitive':
				return $elm$json$Json$Decode$succeed(0);
			case 'Intransitive':
				return $elm$json$Json$Decode$succeed(1);
			case 'Ditransitive':
				return $elm$json$Json$Decode$succeed(2);
			case 'Reflexive':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('invalid verb-object variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toVerbObject, $elm$json$Json$Decode$string);
}();
var $author$project$Models$Word$Active = 0;
var $author$project$Models$Word$Passive = 1;
var $author$project$Models$Word$ProcessualPassive = 2;
var $author$project$Models$Word$StatalPassive = 3;
var $author$project$Decoders$voiceDecoder = function () {
	var toVoice = function (string) {
		switch (string) {
			case 'Active':
				return $elm$json$Json$Decode$succeed(0);
			case 'Passive':
				return $elm$json$Json$Decode$succeed(1);
			case 'ProcessualPassive':
				return $elm$json$Json$Decode$succeed(2);
			case 'StatalPassive':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('invalid voice variant');
		}
	};
	return A2($elm$json$Json$Decode$andThen, toVoice, $elm$json$Json$Decode$string);
}();
var $author$project$Decoders$tagDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'morph',
	$elm$json$Json$Decode$maybe($author$project$Decoders$morphDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name_case',
		$elm$json$Json$Decode$maybe($author$project$Decoders$nameCaseDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'verb_object',
			$elm$json$Json$Decode$maybe(
				$elm$json$Json$Decode$list($author$project$Decoders$verbObjectDecoder)),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'verb_class',
				$elm$json$Json$Decode$maybe($author$project$Decoders$verbClassDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'verb',
					$elm$json$Json$Decode$maybe(
						$elm$json$Json$Decode$list($author$project$Decoders$verbDecoder)),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'aux_verb',
						$elm$json$Json$Decode$maybe($author$project$Decoders$auxVerbDecoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'participle',
							$elm$json$Json$Decode$maybe($author$project$Decoders$participleDecoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'clause',
								$elm$json$Json$Decode$maybe($author$project$Decoders$clauseDecoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'voice',
									$elm$json$Json$Decode$maybe($author$project$Decoders$voiceDecoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'modality',
										$elm$json$Json$Decode$maybe($author$project$Decoders$modalityDecoder),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'aspect',
											$elm$json$Json$Decode$maybe($author$project$Decoders$aspectDecoder),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'tense',
												$elm$json$Json$Decode$maybe($author$project$Decoders$tenseDecoder),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'person',
													$elm$json$Json$Decode$maybe($author$project$Decoders$personDecoder),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'count',
														$elm$json$Json$Decode$maybe($author$project$Decoders$countDecoder),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'strength',
															$elm$json$Json$Decode$maybe($author$project$Decoders$strengthDecoder),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'adj_role',
																$elm$json$Json$Decode$maybe($author$project$Decoders$adjRoleDecoder),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'adj_degree',
																	$elm$json$Json$Decode$maybe($author$project$Decoders$adjDegreeDecoder),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'specificity',
																		$elm$json$Json$Decode$maybe($author$project$Decoders$specificityDecoder),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'has_article',
																			$elm$json$Json$Decode$maybe($author$project$Decoders$hasArticleDecoder),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'countable',
																				$elm$json$Json$Decode$maybe(
																					$elm$json$Json$Decode$list($author$project$Decoders$countableDecoder)),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'cases',
																					$elm$json$Json$Decode$maybe(
																						$elm$json$Json$Decode$list($author$project$Decoders$casesDecoder)),
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'gender',
																						$elm$json$Json$Decode$maybe($author$project$Decoders$genderDecoder),
																						$elm$json$Json$Decode$succeed($author$project$Models$Word$Tag)))))))))))))))))))))));
var $author$project$Models$Word$Word = F2(
	function (word, root) {
		return {ne: root, kl: word};
	});
var $author$project$Models$Word$Root = F2(
	function (word, pos) {
		return {mO: pos, kl: word};
	});
var $author$project$Decoders$rootDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'pos',
	$author$project$Decoders$poSDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'word',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Models$Word$Root)));
var $author$project$Decoders$wordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'root',
	$elm$json$Json$Decode$maybe($author$project$Decoders$rootDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'word',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Models$Word$Word)));
var $author$project$Decoders$wordLinkDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'tags',
	$elm$json$Json$Decode$list($author$project$Decoders$tagDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'rel',
		$author$project$Decoders$relDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'dst_pos',
			$author$project$Decoders$poSDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'dst',
				$author$project$Decoders$wordDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'src_pos',
					$author$project$Decoders$poSDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'src',
						$author$project$Decoders$wordDecoder,
						$elm$json$Json$Decode$succeed($author$project$Models$Word$WordLink)))))));
var $author$project$Decoders$wordLinksDecoder = $elm$json$Json$Decode$list($author$project$Decoders$wordLinkDecoder);
var $author$project$App$Search$Commands$getWordLinksForSrc = function (term) {
	return $elm$http$Http$riskyRequest(
		{
			hy: $elm$http$Http$emptyBody,
			hY: A2(
				$elm$http$Http$expectJson,
				$author$project$App$Search$Messages$GotWordLinks(term),
				$author$project$Decoders$wordLinksDecoder),
			h6: _List_Nil,
			iK: 'GET',
			j_: $elm$core$Maybe$Nothing,
			j5: $elm$core$Maybe$Nothing,
			kb: $author$project$Api$urlPrefix + ('/word/linked_to' + ('?searchTerm=' + term))
		});
};
var $author$project$App$Kaikki$Messages$GotEntities = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$App$Search$Messages$KaikkiMsg = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $author$project$Models$Kaikki$Entity = function (id) {
	return function (word) {
		return function (pos) {
			return function (lang) {
				return function (senses) {
					return function (sounds) {
						return function (categories) {
							return function (forms) {
								return function (translations) {
									return function (hypernyms) {
										return function (synonyms) {
											return function (derived) {
												return function (antonyms) {
													return function (coordinateTerms) {
														return function (hyponyms) {
															return function (related) {
																return function (expressions) {
																	return function (proverbs) {
																		return function (holonyms) {
																			return function (meronyms) {
																				return function (textFields) {
																					return {ho: antonyms, hC: categories, hI: coordinateTerms, li: derived, lA: expressions, ff: forms, ia: holonyms, ie: hypernyms, $8: hyponyms, fn: id, iv: lang, iJ: meronyms, mO: pos, mV: proverbs, m5: related, np: senses, nx: sounds, jR: synonyms, jT: textFields, om: translations, kl: word};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Models$Kaikki$Cat = F6(
	function (source, kind, name, parents, orig, langcode) {
		return {l5: kind, l7: langcode, mn: name, mB: orig, mI: parents, ny: source};
	});
var $author$project$Decoders$maybeString = $elm$json$Json$Decode$maybe($elm$json$Json$Decode$string);
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (path, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					return A2(
						$elm$json$Json$Decode$at,
						path,
						nullOr(valDecoder));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				_List_fromArray(
					[key]),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Decoders$strings = $elm$json$Json$Decode$list($elm$json$Json$Decode$string);
var $author$project$Decoders$kCatDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'langcode',
	$author$project$Decoders$maybeString,
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'orig',
		$author$project$Decoders$maybeString,
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'parents',
			$author$project$Decoders$strings,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'kind',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'source',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Models$Kaikki$Cat)))))));
var $author$project$Decoders$kCatsDecoder = $elm$json$Json$Decode$list($author$project$Decoders$kCatDecoder);
var $author$project$Models$Kaikki$Form = F3(
	function (form, tags, source) {
		return {dN: form, ny: source, nS: tags};
	});
var $author$project$Decoders$maybeStrings = $elm$json$Json$Decode$maybe($author$project$Decoders$strings);
var $author$project$Decoders$kFormDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'source',
	$author$project$Decoders$maybeString,
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'tags',
		$author$project$Decoders$maybeStrings,
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'form',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Models$Kaikki$Form))));
var $author$project$Decoders$kFormsDecoder = $elm$json$Json$Decode$list($author$project$Decoders$kFormDecoder);
var $author$project$Models$Kaikki$Linkage = function (word) {
	return function (senseId) {
		return function (tags) {
			return function (extra) {
				return function (topics) {
					return function (english) {
						return function (roman) {
							return function (sense) {
								return function (rawTags) {
									return function (urls) {
										return function (source) {
											return function (alt) {
												return function (taxonomic) {
													return function (note) {
														return {kx: alt, lu: english, lB: extra, iY: note, ek: rawTags, gz: roman, jG: sense, jH: senseId, ny: source, nS: tags, nT: taxonomic, j4: topics, ot: urls, kl: word};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Decoders$kLinkageDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'note',
	$author$project$Decoders$maybeString,
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'taxonomic',
		$author$project$Decoders$maybeString,
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'alt',
			$author$project$Decoders$maybeString,
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'source',
				$author$project$Decoders$maybeString,
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'urls',
					$author$project$Decoders$maybeStrings,
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'raw_tags',
						$author$project$Decoders$maybeStrings,
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'sense',
							$author$project$Decoders$maybeString,
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'roman',
								$author$project$Decoders$maybeString,
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'english',
									$author$project$Decoders$maybeString,
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'topics',
										$author$project$Decoders$maybeStrings,
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'extra',
											$author$project$Decoders$maybeString,
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'tags',
												$author$project$Decoders$maybeStrings,
												$elm$core$Maybe$Nothing,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'sense_id',
													$author$project$Decoders$maybeString,
													$elm$core$Maybe$Nothing,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'word',
														$elm$json$Json$Decode$string,
														$elm$json$Json$Decode$succeed($author$project$Models$Kaikki$Linkage)))))))))))))));
var $author$project$Decoders$kLinkagesDecoder = $elm$json$Json$Decode$list($author$project$Decoders$kLinkageDecoder);
var $author$project$Models$Kaikki$Sense = function (id) {
	return function (glosses) {
		return function (tags) {
			return function (formOf) {
				return function (links) {
					return function (categories) {
						return function (senseid) {
							return function (examples) {
								return function (rawGlosses) {
									return function (rawTags) {
										return function (topics) {
											return function (synonyms) {
												return function (related) {
													return function (derived) {
														return function (wikipedia) {
															return function (altOf) {
																return function (antonyms) {
																	return function (qualifier) {
																		return function (hypernyms) {
																			return function (coordinateTerms) {
																				return function (hyponyms) {
																					return function (meronyms) {
																						return function (holonyms) {
																							return function (wikidata) {
																								return {ky: altOf, ho: antonyms, hC: categories, hI: coordinateTerms, li: derived, ly: examples, lD: formOf, lF: glosses, ia: holonyms, ie: hypernyms, $8: hyponyms, fn: id, l8: links, iJ: meronyms, mY: qualifier, m$: rawGlosses, ek: rawTags, m5: related, no: senseid, jR: synonyms, nS: tags, j4: topics, oF: wikidata, oG: wikipedia};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Models$Kaikki$Example = function (text) {
	return function (rawRef) {
		return function (title) {
			return function (author) {
				return function (year) {
					return function (publisher) {
						return function (pages) {
							return function (place) {
								return function (isbn) {
									return function (url) {
										return function (accessdate) {
											return function (titleComplement) {
												return function (month) {
													return function (day) {
														return function (edition) {
															return function (collection) {
																return function (num) {
																	return function (typ) {
																		return function (english) {
																			return function (translator) {
																				return function (editor) {
																					return function (date) {
																						return function (comment) {
																							return function (ref) {
																								return function (volume) {
																									return function (translation) {
																										return function (roman) {
																											return {kr: accessdate, kF: author, kX: collection, k_: comment, dE: date, la: day, ln: edition, lo: editor, lu: english, l2: isbn, mj: month, mq: num, mH: pages, mL: place, mX: publisher, m0: rawRef, m3: ref, gz: roman, nW: text, n$: title, n0: titleComplement, ol: translation, on: translator, oo: typ, kb: url, oC: volume, oS: year};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Decoders$kExampleDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'roman',
	$author$project$Decoders$maybeString,
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'translation',
		$author$project$Decoders$maybeString,
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'volume',
			$author$project$Decoders$maybeString,
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'ref',
				$author$project$Decoders$maybeString,
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'comment',
					$author$project$Decoders$maybeString,
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'date',
						$author$project$Decoders$maybeString,
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'editor',
							$author$project$Decoders$maybeString,
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'translator',
								$author$project$Decoders$maybeString,
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'english',
									$author$project$Decoders$maybeString,
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'type',
										$author$project$Decoders$maybeString,
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'number',
											$author$project$Decoders$maybeString,
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'collection',
												$author$project$Decoders$maybeString,
												$elm$core$Maybe$Nothing,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'edition',
													$author$project$Decoders$maybeString,
													$elm$core$Maybe$Nothing,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'day',
														$author$project$Decoders$maybeString,
														$elm$core$Maybe$Nothing,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'month',
															$author$project$Decoders$maybeString,
															$elm$core$Maybe$Nothing,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'title_complement',
																$author$project$Decoders$maybeString,
																$elm$core$Maybe$Nothing,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'accessdate',
																	$author$project$Decoders$maybeString,
																	$elm$core$Maybe$Nothing,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'url',
																		$author$project$Decoders$maybeString,
																		$elm$core$Maybe$Nothing,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'isbn',
																			$author$project$Decoders$maybeString,
																			$elm$core$Maybe$Nothing,
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																				'place',
																				$author$project$Decoders$maybeString,
																				$elm$core$Maybe$Nothing,
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'pages',
																					$author$project$Decoders$maybeString,
																					$elm$core$Maybe$Nothing,
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'publisher',
																						$author$project$Decoders$maybeString,
																						$elm$core$Maybe$Nothing,
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'year',
																							$author$project$Decoders$maybeString,
																							$elm$core$Maybe$Nothing,
																							A4(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																								'author',
																								$author$project$Decoders$maybeString,
																								$elm$core$Maybe$Nothing,
																								A4(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																									'title',
																									$author$project$Decoders$maybeString,
																									$elm$core$Maybe$Nothing,
																									A4(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																										'raw_ref',
																										$author$project$Decoders$maybeString,
																										$elm$core$Maybe$Nothing,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'text',
																											$elm$json$Json$Decode$string,
																											$elm$json$Json$Decode$succeed($author$project$Models$Kaikki$Example))))))))))))))))))))))))))));
var $author$project$Decoders$kExamplesDecoder = $elm$json$Json$Decode$list($author$project$Decoders$kExampleDecoder);
var $author$project$Decoders$kSenseDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'wikidate',
	$author$project$Decoders$maybeStrings,
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'holonyms',
		$elm$json$Json$Decode$maybe($author$project$Decoders$kLinkagesDecoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'meronyms',
			$elm$json$Json$Decode$maybe($author$project$Decoders$kLinkagesDecoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'hyponyms',
				$elm$json$Json$Decode$maybe($author$project$Decoders$kLinkagesDecoder),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'coordinate_terms',
					$elm$json$Json$Decode$maybe($author$project$Decoders$kLinkagesDecoder),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'hypernyms',
						$elm$json$Json$Decode$maybe($author$project$Decoders$kLinkagesDecoder),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'qualifier',
							$author$project$Decoders$maybeString,
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'antonyms',
								$elm$json$Json$Decode$maybe($author$project$Decoders$kLinkagesDecoder),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'alt_of',
									$elm$json$Json$Decode$maybe($author$project$Decoders$kLinkagesDecoder),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'wikipedia',
										$author$project$Decoders$maybeStrings,
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'derived',
											$elm$json$Json$Decode$maybe($author$project$Decoders$kLinkagesDecoder),
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'related',
												$elm$json$Json$Decode$maybe($author$project$Decoders$kLinkagesDecoder),
												$elm$core$Maybe$Nothing,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'synonyms',
													$elm$json$Json$Decode$maybe($author$project$Decoders$kLinkagesDecoder),
													$elm$core$Maybe$Nothing,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'topics',
														$author$project$Decoders$maybeStrings,
														$elm$core$Maybe$Nothing,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'raw_tags',
															$author$project$Decoders$maybeStrings,
															$elm$core$Maybe$Nothing,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'raw_glosses',
																$author$project$Decoders$maybeStrings,
																$elm$core$Maybe$Nothing,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'examples',
																	$elm$json$Json$Decode$maybe($author$project$Decoders$kExamplesDecoder),
																	$elm$core$Maybe$Nothing,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'senseid',
																		$author$project$Decoders$maybeString,
																		$elm$core$Maybe$Nothing,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'categories',
																			$elm$json$Json$Decode$maybe($author$project$Decoders$kCatsDecoder),
																			$elm$core$Maybe$Nothing,
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																				'links',
																				$elm$json$Json$Decode$maybe(
																					$elm$json$Json$Decode$list($author$project$Decoders$strings)),
																				$elm$core$Maybe$Nothing,
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'form_of',
																					$elm$json$Json$Decode$maybe($author$project$Decoders$kLinkagesDecoder),
																					$elm$core$Maybe$Nothing,
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'tags',
																						$author$project$Decoders$maybeStrings,
																						$elm$core$Maybe$Nothing,
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'glosses',
																							$author$project$Decoders$maybeStrings,
																							$elm$core$Maybe$Nothing,
																							A4(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																								'id',
																								$author$project$Decoders$maybeString,
																								$elm$core$Maybe$Nothing,
																								$elm$json$Json$Decode$succeed($author$project$Models$Kaikki$Sense)))))))))))))))))))))))));
var $author$project$Decoders$kSensesDecoder = $elm$json$Json$Decode$list($author$project$Decoders$kSenseDecoder);
var $author$project$Models$Kaikki$Sound = function (audio) {
	return function (mp3Url) {
		return function (oggUrl) {
			return function (ipa) {
				return function (rhymes) {
					return function (wavUrl) {
						return function (rawTags) {
							return function (homophone) {
								return function (langCode) {
									return function (lang) {
										return function (ogaUrl) {
											return function (tags) {
												return function (note) {
													return function (other) {
														return function (text) {
															return {kE: audio, lQ: homophone, l0: ipa, iv: lang, iw: langCode, mk: mp3Url, iY: note, mv: ogaUrl, mw: oggUrl, mD: other, ek: rawTags, nd: rhymes, nS: tags, nW: text, oD: wavUrl};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Decoders$kSoundDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'text',
	$author$project$Decoders$maybeString,
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'other',
		$author$project$Decoders$maybeString,
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'note',
			$author$project$Decoders$maybeString,
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'tags',
				$author$project$Decoders$maybeStrings,
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'oga_url',
					$author$project$Decoders$maybeString,
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'lang',
						$author$project$Decoders$maybeString,
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'lang_code',
							$author$project$Decoders$maybeString,
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'homophone',
								$author$project$Decoders$maybeString,
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'raw_tags',
									$author$project$Decoders$maybeStrings,
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'wav_url',
										$author$project$Decoders$maybeString,
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'rhymes',
											$author$project$Decoders$maybeString,
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'ipa',
												$author$project$Decoders$maybeString,
												$elm$core$Maybe$Nothing,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'ogg_url',
													$author$project$Decoders$maybeString,
													$elm$core$Maybe$Nothing,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'mp3_url',
														$author$project$Decoders$maybeString,
														$elm$core$Maybe$Nothing,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'audio',
															$author$project$Decoders$maybeString,
															$elm$core$Maybe$Nothing,
															$elm$json$Json$Decode$succeed($author$project$Models$Kaikki$Sound))))))))))))))));
var $author$project$Decoders$kSoundsDecoder = $elm$json$Json$Decode$list($author$project$Decoders$kSoundDecoder);
var $author$project$Models$Kaikki$TextFields = F3(
	function (tags, hyphenation, etymologyText) {
		return {lx: etymologyText, lS: hyphenation, nS: tags};
	});
var $author$project$Decoders$kTextFieldsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'etymologyText',
	$author$project$Decoders$maybeString,
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'hyphenation',
		$author$project$Decoders$maybeStrings,
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'tags',
			$author$project$Decoders$maybeStrings,
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$Models$Kaikki$TextFields))));
var $author$project$Models$Kaikki$Translation = F9(
	function (word, lang, langCode, senseId, sense, tags, roman, rawTags, uncertain) {
		return {iv: lang, iw: langCode, ek: rawTags, gz: roman, jG: sense, jH: senseId, nS: tags, op: uncertain, kl: word};
	});
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$Decoders$maybeBool = $elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool);
var $author$project$Decoders$kTranslationDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'uncertain',
	$author$project$Decoders$maybeBool,
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'raw_tags',
		$author$project$Decoders$maybeStrings,
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'roman',
			$author$project$Decoders$maybeString,
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'tags',
				$author$project$Decoders$maybeStrings,
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'sense',
					$author$project$Decoders$maybeString,
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'sense_id',
						$author$project$Decoders$maybeString,
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'lange_code',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'lang',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'word',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Models$Kaikki$Translation))))))))));
var $author$project$Decoders$kTranslationsDecoder = $elm$json$Json$Decode$list($author$project$Decoders$kTranslationDecoder);
var $author$project$Decoders$kEntityDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'textFields',
	$elm$json$Json$Decode$maybe($author$project$Decoders$kTextFieldsDecoder),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'meronyms',
		$elm$json$Json$Decode$maybe($author$project$Decoders$kLinkagesDecoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'holonyms',
			$elm$json$Json$Decode$maybe($author$project$Decoders$kLinkagesDecoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'proverbs',
				$elm$json$Json$Decode$maybe($author$project$Decoders$kLinkagesDecoder),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'expressions',
					$elm$json$Json$Decode$maybe($author$project$Decoders$kLinkagesDecoder),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'related',
						$elm$json$Json$Decode$maybe($author$project$Decoders$kLinkagesDecoder),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'hyponyms',
							$elm$json$Json$Decode$maybe($author$project$Decoders$kLinkagesDecoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'coordinateTerms',
								$elm$json$Json$Decode$maybe($author$project$Decoders$kLinkagesDecoder),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'antonyms',
									$elm$json$Json$Decode$maybe($author$project$Decoders$kLinkagesDecoder),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'derived',
										$elm$json$Json$Decode$maybe($author$project$Decoders$kLinkagesDecoder),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'synonyms',
											$elm$json$Json$Decode$maybe($author$project$Decoders$kLinkagesDecoder),
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'hypernyms',
												$elm$json$Json$Decode$maybe($author$project$Decoders$kLinkagesDecoder),
												$elm$core$Maybe$Nothing,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'translations',
													$elm$json$Json$Decode$maybe($author$project$Decoders$kTranslationsDecoder),
													$elm$core$Maybe$Nothing,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'forms',
														$elm$json$Json$Decode$maybe($author$project$Decoders$kFormsDecoder),
														$elm$core$Maybe$Nothing,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'categories',
															$elm$json$Json$Decode$maybe($author$project$Decoders$kCatsDecoder),
															$elm$core$Maybe$Nothing,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'sounds',
																$elm$json$Json$Decode$maybe($author$project$Decoders$kSoundsDecoder),
																$elm$core$Maybe$Nothing,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'senses',
																	$elm$json$Json$Decode$maybe($author$project$Decoders$kSensesDecoder),
																	$elm$core$Maybe$Nothing,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'lang',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'pos',
																			$author$project$Decoders$strings,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'word',
																				$elm$json$Json$Decode$string,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'id',
																					$elm$json$Json$Decode$string,
																					$elm$json$Json$Decode$succeed($author$project$Models$Kaikki$Entity))))))))))))))))))))));
var $author$project$Decoders$kEntitiesDecoder = $elm$json$Json$Decode$list($author$project$Decoders$kEntityDecoder);
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Encoders$searchPayloadEncoder = function (payload) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'searchTerm',
				$elm$json$Json$Encode$string(payload.gC)),
				_Utils_Tuple2(
				'verified',
				$elm$json$Json$Encode$bool(payload.ox))
			]));
};
var $author$project$App$Search$Commands$lookupKaikki = F3(
	function (maybeTerms, term, verified) {
		return $elm$http$Http$riskyRequest(
			{
				hy: $elm$http$Http$jsonBody(
					$author$project$Encoders$searchPayloadEncoder(
						{gC: term, ox: verified})),
				hY: A2(
					$elm$http$Http$expectJson,
					function (x) {
						return $author$project$App$Search$Messages$KaikkiMsg(
							A2($author$project$App$Kaikki$Messages$GotEntities, maybeTerms, x));
					},
					$author$project$Decoders$kEntitiesDecoder),
				h6: _List_Nil,
				iK: 'POST',
				j_: $elm$core$Maybe$Nothing,
				j5: $elm$core$Maybe$Nothing,
				kb: $author$project$Api$urlPrefix + '/word/lookup'
			});
	});
var $author$project$App$Search$Update$kLookupAndWLinks = F3(
	function (mS, t, v) {
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3($author$project$App$Search$Commands$lookupKaikki, mS, t, v),
					$author$project$App$Search$Commands$getWordLinksForSrc(t)
				]));
	});
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $elm$core$Basics$not = _Basics_not;
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$App$Update$lookup = F4(
	function (model, mS, t, v) {
		var isNew = !A2(
			$elm$core$Set$member,
			t,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Set$empty,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Set$fromList,
					A2(
						$elm$core$Maybe$map,
						$elm$core$String$split(' ;'),
						model.jz.is.jC))));
		return isNew ? A2(
			$elm$core$Platform$Cmd$map,
			$author$project$App$Messages$SearchMsg,
			A3($author$project$App$Search$Update$kLookupAndWLinks, mS, t, v)) : $elm$core$Platform$Cmd$none;
	});
var $author$project$App$Auth$Messages$SignOutAttempted = function (a) {
	return {$: 8, a: a};
};
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectBytesResponse,
		toMsg,
		$elm$http$Http$resolve(
			function (_v0) {
				return $elm$core$Result$Ok(0);
			}));
};
var $author$project$App$Auth$Commands$signout = $elm$http$Http$riskyRequest(
	{
		hy: $elm$http$Http$emptyBody,
		hY: $elm$http$Http$expectWhatever($author$project$App$Auth$Messages$SignOutAttempted),
		h6: _List_Nil,
		iK: 'POST',
		j_: $elm$core$Maybe$Nothing,
		j5: $elm$core$Maybe$Nothing,
		kb: $author$project$Api$urlPrefix + '/auth/magic-link/signout'
	});
var $author$project$App$Update$appBarOtherCmds = F3(
	function (model, msg, aBModel) {
		var cmd = function (params) {
			if (!params.$) {
				var _v3 = params.a;
				var mS = _v3.a;
				var s = _v3.b;
				var b = _v3.c;
				return A4($author$project$App$Update$lookup, model, mS, s, b);
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		};
		_v0$3:
		while (true) {
			switch (msg.$) {
				case 4:
					switch (msg.a.$) {
						case 1:
							var _v1 = msg.a;
							return cmd(aBModel.jA.jB);
						case 2:
							return cmd(aBModel.jA.jB);
						default:
							break _v0$3;
					}
				case 3:
					return A2($elm$core$Platform$Cmd$map, $author$project$App$Messages$AuthMsg, $author$project$App$Auth$Commands$signout);
				default:
					break _v0$3;
			}
		}
		return $elm$core$Platform$Cmd$none;
	});
var $author$project$App$Sentence$Messages$GetSentence = {$: 0};
var $author$project$App$Review$Messages$GetTokens = {$: 0};
var $author$project$App$Activity$Messages$GotActivitySummary = function (a) {
	return {$: 0, a: a};
};
var $author$project$Models$Activity$ActivitySummary = function (summary) {
	return {nO: summary};
};
var $author$project$Models$Activity$DailyActivityCounts = F9(
	function (date, goalWords, goalSents, sentsCount, tokensExposedCount, tokensReviewedCount, tokensLookedupCount, tokensReviewableCount, tokensSentReadyCount) {
		return {dE: date, lG: goalSents, lH: goalWords, nv: sentsCount, oc: tokensExposedCount, oe: tokensLookedupCount, of: tokensReviewableCount, oh: tokensReviewedCount, oi: tokensSentReadyCount};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$Decoders$dailyActivityCountsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'tokens_sent_ready_count',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'tokens_reviewable_count',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'tokens_lookedup_count',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'tokens_reviewed_count',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'tokens_exposed_count',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'sents_count',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'goal_sents',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'goal_words',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'date',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Models$Activity$DailyActivityCounts))))))))));
var $author$project$Decoders$activitySummaryDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'summary',
	$elm$json$Json$Decode$list($author$project$Decoders$dailyActivityCountsDecoder),
	$elm$json$Json$Decode$succeed($author$project$Models$Activity$ActivitySummary));
var $author$project$App$Activity$Commands$getActivity = $elm$http$Http$riskyRequest(
	{
		hy: $elm$http$Http$emptyBody,
		hY: A2($elm$http$Http$expectJson, $author$project$App$Activity$Messages$GotActivitySummary, $author$project$Decoders$activitySummaryDecoder),
		h6: _List_Nil,
		iK: 'GET',
		j_: $elm$core$Maybe$Nothing,
		j5: $elm$core$Maybe$Nothing,
		kb: $author$project$Api$urlPrefix + '/activity'
	});
var $author$project$App$Messages$GotTodaysActivity = function (a) {
	return {$: 9, a: a};
};
var $author$project$App$Commands$getTodaysActivity = $elm$http$Http$riskyRequest(
	{
		hy: $elm$http$Http$emptyBody,
		hY: A2($elm$http$Http$expectJson, $author$project$App$Messages$GotTodaysActivity, $author$project$Decoders$activitySummaryDecoder),
		h6: _List_Nil,
		iK: 'GET',
		j_: $elm$core$Maybe$Nothing,
		j5: $elm$core$Maybe$Nothing,
		kb: $author$project$Api$urlPrefix + '/activity/today'
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$App$Review$Model$Idle = 0;
var $author$project$App$Review$Model$Loading = 1;
var $author$project$App$Review$Messages$SentenceCoreMsg = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$App$SentenceCore$Update$makeExposurePayload = function (_v0) {
	var sent = _v0.nr;
	var tokens = _v0.gW;
	return {
		ma: A2(
			$elm$core$List$map,
			function ($) {
				return $.n9;
			},
			A2(
				$elm$core$List$filter,
				function (t) {
					return t.g5;
				},
				$elm$core$Dict$values(tokens))),
		mE: A2(
			$elm$core$List$map,
			function ($) {
				return $.n9;
			},
			A2(
				$elm$core$List$filter,
				function (t) {
					return !t.g5;
				},
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.h8;
					},
					$elm$core$Dict$values(tokens)))),
		m9: A2(
			$elm$core$List$map,
			function ($) {
				return $.fn;
			},
			sent.na),
		ns: sent.fn,
		nz: sent.ny.fn
	};
};
var $author$project$App$Review$Messages$ActivityPosted = function (a) {
	return {$: 8, a: a};
};
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $author$project$Models$Activity$activityPayloadFromExposures = F2(
	function (maybeReviewedToken, expPayloads) {
		var tokensOther = $elm$core$Set$toList(
			$elm$core$Set$fromList(
				A2(
					$elm$core$List$concatMap,
					function ($) {
						return $.mE;
					},
					expPayloads)));
		var tokensLookedup = $elm$core$Set$toList(
			$elm$core$Set$fromList(
				A2(
					$elm$core$List$concatMap,
					function ($) {
						return $.ma;
					},
					expPayloads)));
		return {
			nt: $elm$core$Set$toList(
				$elm$core$Set$fromList(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.ns;
						},
						expPayloads))),
			ob: $elm$core$Set$toList(
				$elm$core$Set$fromList(
					A2($elm$core$List$append, tokensLookedup, tokensOther))),
			od: tokensLookedup,
			og: A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (t) {
						return _List_fromArray(
							[t]);
					},
					maybeReviewedToken))
		};
	});
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Encoders$strings = $elm$json$Json$Encode$list($elm$json$Json$Encode$string);
var $author$project$Encoders$activityPayloadEncoder = function (payload) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sentIds',
				$author$project$Encoders$strings(payload.nt)),
				_Utils_Tuple2(
				'tokensExposed',
				$author$project$Encoders$strings(payload.ob)),
				_Utils_Tuple2(
				'tokensReviewed',
				$author$project$Encoders$strings(payload.og)),
				_Utils_Tuple2(
				'tokensLookedup',
				$author$project$Encoders$strings(payload.od))
			]));
};
var $author$project$App$Activity$Commands$postActivity = F2(
	function (m, payload) {
		return $elm$http$Http$riskyRequest(
			{
				hy: $elm$http$Http$jsonBody(
					$author$project$Encoders$activityPayloadEncoder(payload)),
				hY: $elm$http$Http$expectWhatever(m),
				h6: _List_Nil,
				iK: 'POST',
				j_: $elm$core$Maybe$Nothing,
				j5: $elm$core$Maybe$Nothing,
				kb: $author$project$Api$urlPrefix + '/activity'
			});
	});
var $author$project$App$Review$Commands$postActivity = F2(
	function (maybeReviewedToken, payloads) {
		var activityPayload = A2($author$project$Models$Activity$activityPayloadFromExposures, maybeReviewedToken, payloads);
		return A2($author$project$App$Activity$Commands$postActivity, $author$project$App$Review$Messages$ActivityPosted, activityPayload);
	});
var $author$project$App$Review$Messages$ExposuresPosted = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Encoders$exposurePayloadEncoder = function (payload) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sentId',
				$elm$json$Json$Encode$string(payload.ns)),
				_Utils_Tuple2(
				'sourceId',
				$elm$json$Json$Encode$string(payload.nz)),
				_Utils_Tuple2(
				'reprGroupIds',
				$author$project$Encoders$strings(payload.m9)),
				_Utils_Tuple2(
				'lookedupTokens',
				$author$project$Encoders$strings(payload.ma)),
				_Utils_Tuple2(
				'otherTokens',
				$author$project$Encoders$strings(payload.mE))
			]));
};
var $author$project$Encoders$exposuresPayloadEncoder = function (payloads) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'vals',
				A2($elm$json$Json$Encode$list, $author$project$Encoders$exposurePayloadEncoder, payloads))
			]));
};
var $author$project$App$Review$Commands$postExposures = function (payloads) {
	var ids = $elm$core$Set$fromList(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.ns;
			},
			payloads));
	return $elm$http$Http$riskyRequest(
		{
			hy: $elm$http$Http$jsonBody(
				$author$project$Encoders$exposuresPayloadEncoder(payloads)),
			hY: $elm$http$Http$expectWhatever(
				$author$project$App$Review$Messages$ExposuresPosted(ids)),
			h6: _List_Nil,
			iK: 'POST',
			j_: $elm$core$Maybe$Nothing,
			j5: $elm$core$Maybe$Nothing,
			kb: $author$project$Api$urlPrefix + '/exposure/multi'
		});
};
var $author$project$App$Review$Messages$PostedReview = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Encoders$reviewPayloadEncoder = function (payload) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'token',
				$elm$json$Json$Encode$string(payload.n9))
			]));
};
var $author$project$App$Review$Commands$postReviewToken = function (payload) {
	return $elm$http$Http$riskyRequest(
		{
			hy: $elm$http$Http$jsonBody(
				$author$project$Encoders$reviewPayloadEncoder(payload)),
			hY: $elm$http$Http$expectWhatever(
				$author$project$App$Review$Messages$PostedReview(payload.n9)),
			h6: _List_Nil,
			iK: 'POST',
			j_: $elm$core$Maybe$Nothing,
			j5: $elm$core$Maybe$Nothing,
			kb: $author$project$Api$urlPrefix + '/review'
		});
};
var $author$project$App$Review$Update$cmdsFromCore = F2(
	function (model, maybeString) {
		var postReview = function (ms) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Cmd$none,
				A2(
					$elm$core$Maybe$map,
					function (t) {
						return $author$project$App$Review$Commands$postReviewToken(
							{n9: t});
					},
					ms));
		};
		var cmdForPayloads = function (ps) {
			return _List_fromArray(
				[
					$author$project$App$Review$Commands$postExposures(ps),
					postReview(maybeString),
					A2($author$project$App$Review$Commands$postActivity, maybeString, ps)
				]);
		};
		return $elm$core$Platform$Cmd$batch(
			cmdForPayloads(
				A2(
					$elm$core$List$map,
					$author$project$App$SentenceCore$Update$makeExposurePayload,
					$elm$core$Dict$values(model.nu))));
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $author$project$App$Review$Messages$GotTokens = function (a) {
	return {$: 1, a: a};
};
var $author$project$Models$Review$ReviewTokens = function (reviewTokens) {
	return {nc: reviewTokens};
};
var $author$project$Models$Review$ReviewToken = F3(
	function (token, word, streak) {
		return {nJ: streak, n9: token, kl: word};
	});
var $author$project$Decoders$reviewTokenDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'streak',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'word',
		$elm$json$Json$Decode$maybe($author$project$Decoders$wordDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'token',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Models$Review$ReviewToken))));
var $author$project$Decoders$reviewTokensDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'reviewable_tokens',
	$elm$json$Json$Decode$list($author$project$Decoders$reviewTokenDecoder),
	$elm$json$Json$Decode$succeed($author$project$Models$Review$ReviewTokens));
var $author$project$App$Review$Commands$getReviewTokens = $elm$http$Http$riskyRequest(
	{
		hy: $elm$http$Http$emptyBody,
		hY: A2($elm$http$Http$expectJson, $author$project$App$Review$Messages$GotTokens, $author$project$Decoders$reviewTokensDecoder),
		h6: _List_Nil,
		iK: 'GET',
		j_: $elm$core$Maybe$Nothing,
		j5: $elm$core$Maybe$Nothing,
		kb: $author$project$Api$urlPrefix + '/review'
	});
var $author$project$App$Review$Messages$GotUseCases = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Models$Review$TokenUseCases = F3(
	function (posGroup, freqSum, tokenPairs) {
		return {lE: freqSum, mP: posGroup, oa: tokenPairs};
	});
var $author$project$Models$Token$PoSGroup = F2(
	function (chld, prnt) {
		return {hF: chld, mU: prnt};
	});
var $author$project$Decoders$posGroupDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'prnt',
	$author$project$Decoders$poSDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'chld',
		$author$project$Decoders$poSDecoder,
		$elm$json$Json$Decode$succeed($author$project$Models$Token$PoSGroup)));
var $author$project$Models$Review$TokenPair = F6(
	function (id, chld, prnt, freq, reprGroup, sents) {
		return {hF: chld, aY: freq, fn: id, mU: prnt, m8: reprGroup, nu: sents};
	});
var $author$project$Models$Token$ReprGroup = F5(
	function (id, rank, chld, prnt, posGroup) {
		return {hF: chld, fn: id, mP: posGroup, mU: prnt, m_: rank};
	});
var $author$project$Decoders$reprGroupDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'pos_group',
	$author$project$Decoders$posGroupDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'prnt',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'chld',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rank',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Models$Token$ReprGroup))))));
var $author$project$Models$Sentence$Sent = F5(
	function (id, sent, source, tokens, reprGroups) {
		return {fn: id, na: reprGroups, nr: sent, ny: source, gW: tokens};
	});
var $author$project$Models$Sentence$Source = F2(
	function (id, source) {
		return {fn: id, ny: source};
	});
var $author$project$Decoders$srcDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'source',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Models$Sentence$Source)));
var $author$project$Models$Token$Token = F7(
	function (id, token, pos, repr, freq, freqSum, word) {
		return {aY: freq, lE: freqSum, fn: id, mO: pos, m7: repr, n9: token, kl: word};
	});
var $author$project$Decoders$tokenDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'word',
	$elm$json$Json$Decode$maybe($author$project$Decoders$wordDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'freq_sum',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'freq',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'repr',
				$elm$json$Json$Decode$maybe($author$project$Decoders$wordDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'pos',
					$author$project$Decoders$poSDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'token',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Models$Token$Token))))))));
var $author$project$Decoders$sentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'repr_groups',
	$elm$json$Json$Decode$list($author$project$Decoders$reprGroupDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'tokens',
		$elm$json$Json$Decode$list($author$project$Decoders$tokenDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'source',
			$author$project$Decoders$srcDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sent',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Models$Sentence$Sent))))));
var $author$project$Decoders$tokenPairDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'sents',
	$elm$json$Json$Decode$list($author$project$Decoders$sentDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'repr_group',
		$author$project$Decoders$reprGroupDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'freq',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'prnt',
				$author$project$Decoders$tokenDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'chld',
					$author$project$Decoders$tokenDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Models$Review$TokenPair)))))));
var $author$project$Decoders$tokenUseCasesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'token_pairs',
	$elm$json$Json$Decode$list($author$project$Decoders$tokenPairDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'freq_sum',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'pos_group',
			$author$project$Decoders$posGroupDecoder,
			$elm$json$Json$Decode$succeed($author$project$Models$Review$TokenUseCases))));
var $author$project$Decoders$tokenUseCasessDecoder = $elm$json$Json$Decode$list($author$project$Decoders$tokenUseCasesDecoder);
var $author$project$App$Review$Commands$getSentsForToken = function (token) {
	return $elm$http$Http$riskyRequest(
		{
			hy: $elm$http$Http$emptyBody,
			hY: A2(
				$elm$http$Http$expectJson,
				$author$project$App$Review$Messages$GotUseCases(token),
				$author$project$Decoders$tokenUseCasessDecoder),
			h6: _List_Nil,
			iK: 'GET',
			j_: $elm$core$Maybe$Nothing,
			j5: $elm$core$Maybe$Nothing,
			kb: $author$project$Api$urlPrefix + ('/review/use_cases?token=' + token)
		});
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Models$Word$poSToString = function (pos) {
	switch (pos) {
		case 0:
			return 'Verb';
		case 1:
			return 'Adj';
		case 2:
			return 'Noun';
		case 3:
			return 'Phrase';
		case 4:
			return 'Name';
		case 5:
			return 'Abbrev';
		case 6:
			return 'Symbol';
		case 7:
			return 'Prefix';
		case 8:
			return 'Prep';
		case 9:
			return 'Adv';
		case 10:
			return 'PrepPhrase';
		case 11:
			return 'Num';
		case 12:
			return 'Intj';
		case 13:
			return 'Suffix';
		case 14:
			return 'Contraction';
		case 15:
			return 'Proverb';
		case 16:
			return 'Pron';
		case 17:
			return 'Det';
		case 18:
			return 'Particle';
		case 19:
			return 'Character';
		case 20:
			return 'Article';
		case 21:
			return 'Conj';
		case 22:
			return 'Interfix';
		case 23:
			return 'Postp';
		case 24:
			return 'Circumpos';
		case 25:
			return 'Circumfix';
		case 26:
			return 'Affix';
		case 27:
			return 'Punct';
		case 28:
			return 'Infix';
		case 29:
			return 'Unknown';
		default:
			return 'Inf';
	}
};
var $author$project$Models$Review$groupByOther = F2(
	function (mainToken, pairs) {
		var getRootOrNot = function (_v1) {
			var token = _v1.n9;
			var word = _v1.kl;
			var pos = _v1.mO;
			var _default = A2(
				$elm$core$Maybe$withDefault,
				token,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.kl;
					},
					word));
			return A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(
					_default,
					$author$project$Models$Word$poSToString(pos)),
				A2(
					$elm$core$Maybe$map,
					function (r) {
						return _Utils_Tuple2(
							r.kl,
							$author$project$Models$Word$poSToString(r.mO));
					},
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.ne;
						},
						word)));
		};
		var getOther = function (_v0) {
			var chld = _v0.hF;
			var prnt = _v0.mU;
			return _Utils_eq(chld.n9, mainToken) ? prnt : chld;
		};
		var foldFnc = F2(
			function (t, dict) {
				var updateFnc = function (maybeItems) {
					return $elm$core$Maybe$Just(
						A2(
							$elm$core$Maybe$withDefault,
							_List_fromArray(
								[t]),
							A2(
								$elm$core$Maybe$map,
								function (ts) {
									return A2($elm$core$List$cons, t, ts);
								},
								maybeItems)));
				};
				var key = getRootOrNot(
					getOther(t));
				return A3($elm$core$Dict$update, key, updateFnc, dict);
			});
		return $elm$core$Dict$toList(
			A3($elm$core$List$foldr, foldFnc, $elm$core$Dict$empty, pairs));
	});
var $author$project$App$Review$Update$nextTokenUpdate = function (model) {
	var _v0 = function () {
		var _v1 = model.gW;
		if (_v1.b) {
			var tT = _v1.a;
			var ts = _v1.b;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(tT),
				ts);
		} else {
			return _Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil);
		}
	}();
	var thisToken = _v0.a;
	var tokens = _v0.b;
	return _Utils_update(
		model,
		{jW: thisToken, jX: $elm$core$Maybe$Nothing, gW: tokens, kc: _List_Nil});
};
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $author$project$Models$Sentence$makeShowToken = F3(
	function (token, highlightable, followedBySpace) {
		return {h1: followedBySpace, h8: highlightable, h9: false, n9: token, g5: false};
	});
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Set$foldl = F3(
	function (func, initialState, _v0) {
		var dict = _v0;
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (key, _v1, state) {
					return A2(func, key, state);
				}),
			initialState,
			dict);
	});
var $elm$core$Set$map = F2(
	function (func, set) {
		return $elm$core$Set$fromList(
			A3(
				$elm$core$Set$foldl,
				F2(
					function (x, xs) {
						return A2(
							$elm$core$List$cons,
							func(x),
							xs);
					}),
				_List_Nil,
				set));
	});
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $elm$core$String$fromList = _String_fromList;
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $author$project$Models$Sentence$symbolsAfter = $elm$core$Set$fromList(
	_List_fromArray(
		[',', '.', '!', '?', ':', ';', ')', ']', '}', '\"', '“']));
var $author$project$Models$Sentence$symbolsBefore = $elm$core$Set$fromList(
	_List_fromArray(
		['(', '[', '{', '\"', '„']));
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $author$project$Models$Sentence$processWord = function (s) {
	if ($elm$core$String$isEmpty(s)) {
		return _List_Nil;
	} else {
		var doSymbols = F2(
			function (symbols, _v0) {
				doSymbols:
				while (true) {
					var remainder = _v0.a;
					var puncts = _v0.b;
					if (remainder.b) {
						var c = remainder.a;
						var rs = remainder.b;
						if (A2($elm$core$Set$member, c, symbols)) {
							var $temp$symbols = symbols,
								$temp$_v0 = _Utils_Tuple2(
								rs,
								A2(
									$elm$core$List$append,
									puncts,
									_List_fromArray(
										[
											$elm$core$String$fromChar(c)
										])));
							symbols = $temp$symbols;
							_v0 = $temp$_v0;
							continue doSymbols;
						} else {
							return _Utils_Tuple2(remainder, puncts);
						}
					} else {
						return _Utils_Tuple2(remainder, puncts);
					}
				}
			});
		var _v2 = A3(
			$elm$core$Tuple$mapBoth,
			$elm$core$List$reverse,
			$elm$core$List$reverse,
			A2(
				doSymbols,
				$author$project$Models$Sentence$symbolsAfter,
				_Utils_Tuple2(
					$elm$core$List$reverse(
						$elm$core$String$toList(s)),
					_List_Nil)));
		var charsWithoutPunctsAfter = _v2.a;
		var punctsAfter = _v2.b;
		var _v3 = A2(
			doSymbols,
			$author$project$Models$Sentence$symbolsBefore,
			_Utils_Tuple2(charsWithoutPunctsAfter, _List_Nil));
		var charsWithoutPuncts = _v3.a;
		var punctsBefore = _v3.b;
		return $elm$core$List$concat(
			_List_fromArray(
				[
					punctsBefore,
					_List_fromArray(
					[
						$elm$core$String$fromList(charsWithoutPuncts)
					]),
					punctsAfter
				]));
	}
};
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$core$Set$union = F2(
	function (_v0, _v1) {
		var dict1 = _v0;
		var dict2 = _v1;
		return A2($elm$core$Dict$union, dict1, dict2);
	});
var $author$project$Models$Sentence$sentToShowTokens = function (s) {
	var symbols = A2(
		$elm$core$Set$map,
		$elm$core$String$fromChar,
		A2($elm$core$Set$union, $author$project$Models$Sentence$symbolsAfter, $author$project$Models$Sentence$symbolsBefore));
	var foldFn = F2(
		function (t, _v0) {
			var tokens = _v0.a;
			var followedBySpace = _v0.b;
			return (t === ' ') ? _Utils_Tuple2(tokens, true) : (A2($elm$core$Set$member, t, symbols) ? _Utils_Tuple2(
				A2(
					$elm$core$List$cons,
					A3($author$project$Models$Sentence$makeShowToken, t, false, followedBySpace),
					tokens),
				false) : _Utils_Tuple2(
				A2(
					$elm$core$List$cons,
					A3($author$project$Models$Sentence$makeShowToken, t, true, followedBySpace),
					tokens),
				false));
		});
	return $elm$core$Dict$fromList(
		A2(
			$elm$core$List$indexedMap,
			$elm$core$Tuple$pair,
			A3(
				$elm$core$List$foldr,
				foldFn,
				_Utils_Tuple2(_List_Nil, false),
				A2(
					$elm$core$List$concatMap,
					$author$project$Models$Sentence$processWord,
					A2(
						$elm$core$List$intersperse,
						' ',
						A2($elm$core$String$split, ' ', s)))).a));
};
var $author$project$App$SentenceCore$Model$init = function (sent) {
	return {
		h9: $elm$core$Maybe$Nothing,
		jD: $elm$core$Maybe$Nothing,
		nr: sent,
		gW: $author$project$Models$Sentence$sentToShowTokens(sent.nr)
	};
};
var $author$project$App$Review$Update$nextUseCaseUpdate = function (model) {
	var tokenPairsToSents = function (_v2) {
		var tPs = _v2.b;
		return $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (s) {
					return _Utils_Tuple2(
						s.fn,
						$author$project$App$SentenceCore$Model$init(s));
				},
				$elm$core$List$concat(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.nu;
						},
						tPs))));
	};
	var _v0 = function () {
		var _v1 = model.kc;
		if (_v1.b) {
			var tUc = _v1.a;
			var uCs = _v1.b;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(tUc),
				uCs);
		} else {
			return _Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil);
		}
	}();
	var thisUseCase = _v0.a;
	var useCases = _v0.b;
	return _Utils_update(
		model,
		{
			nu: A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Dict$empty,
				A2($elm$core$Maybe$map, tokenPairsToSents, thisUseCase)),
			jX: thisUseCase,
			kc: useCases
		});
};
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$core$List$sortBy = _List_sortBy;
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $author$project$Models$Review$shorten = function (list) {
	var sortFnc = function (_v9) {
		var tPs = _v9.b;
		return function (i) {
			return -i;
		}(
			$elm$core$List$sum(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.aY;
					},
					tPs)));
	};
	var nonEmptyFilterFnc = function (_v8) {
		var tPs = _v8.b;
		return $elm$core$List$length(tPs) > 0;
	};
	var freqSum = $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.aY;
			},
			$elm$core$List$concat(
				A2($elm$core$List$map, $elm$core$Tuple$second, list))));
	var freqFilterFnc = function (_v7) {
		var tPs = _v7.b;
		return function (i) {
			return (i / freqSum) >= 0.1;
		}(
			$elm$core$List$sum(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.aY;
					},
					tPs)));
	};
	var foldFnc = F2(
		function (_v5, _v6) {
			var k = _v5.a;
			var tPs = _v5.b;
			var idSet = _v6.a;
			var acc = _v6.b;
			var keep = F2(
				function (_v4, iS) {
					var sents = _v4.nu;
					var aux = function (id) {
						return (!A2($elm$core$Set$member, id, iS)) ? $elm$core$Maybe$Just(id) : $elm$core$Maybe$Nothing;
					};
					return A2(
						$elm$core$Maybe$andThen,
						aux,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.fn;
							},
							$elm$core$List$head(sents)));
				});
			var foldFoldFnc = F2(
				function (tp, _v3) {
					var s = _v3.a;
					var accAcc = _v3.b;
					var _v2 = _Utils_Tuple2(
						$elm$core$List$length(accAcc) < 3,
						A2(keep, tp, s));
					if (_v2.a && (!_v2.b.$)) {
						var i = _v2.b.a;
						return _Utils_Tuple2(
							A2($elm$core$Set$insert, i, s),
							A2(
								$elm$core$List$append,
								accAcc,
								_List_fromArray(
									[tp])));
					} else {
						return _Utils_Tuple2(s, accAcc);
					}
				});
			var _v0 = A3(
				$elm$core$List$foldl,
				foldFoldFnc,
				_Utils_Tuple2(idSet, _List_Nil),
				A2(
					$elm$core$List$sortBy,
					function (_v1) {
						var freq = _v1.aY;
						return -freq;
					},
					tPs));
			var idSetUpdated = _v0.a;
			var chosenTPs = _v0.b;
			return _Utils_eq(chosenTPs, _List_Nil) ? _Utils_Tuple2(idSet, acc) : _Utils_Tuple2(
				idSetUpdated,
				A2(
					$elm$core$List$append,
					acc,
					_List_fromArray(
						[
							_Utils_Tuple2(k, chosenTPs)
						])));
		});
	return A2(
		$elm$core$List$filter,
		nonEmptyFilterFnc,
		A3(
			$elm$core$List$foldl,
			foldFnc,
			_Utils_Tuple2($elm$core$Set$empty, _List_Nil),
			A2(
				$elm$core$List$filter,
				freqFilterFnc,
				A2($elm$core$List$sortBy, sortFnc, list))).b);
};
var $author$project$App$SentenceCore$Update$highlight = F3(
	function (tokens, h, ind) {
		var _v0 = A2($elm$core$Dict$get, ind, tokens);
		if (!_v0.$) {
			var t = _v0.a;
			var newVal = h ? _Utils_update(
				t,
				{h9: h, g5: true}) : _Utils_update(
				t,
				{h9: h});
			return A3($elm$core$Dict$insert, ind, newVal, tokens);
		} else {
			return tokens;
		}
	});
var $author$project$App$SentenceCore$Update$unhighlighten = F2(
	function (tokens, maybeInd) {
		return A2(
			$elm$core$Maybe$withDefault,
			tokens,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$App$SentenceCore$Update$highlight, tokens, false),
				maybeInd));
	});
var $author$project$App$SentenceCore$Update$updateModelForUnhighlight = function (model) {
	return _Utils_update(
		model,
		{
			h9: $elm$core$Maybe$Nothing,
			gW: A2($author$project$App$SentenceCore$Update$unhighlighten, model.gW, model.h9)
		});
};
var $author$project$App$Review$Update$unhighlight = function (model) {
	var mapDictPair = function (_v0) {
		var k = _v0.a;
		var v = _v0.b;
		return _Utils_Tuple2(
			k,
			$author$project$App$SentenceCore$Update$updateModelForUnhighlight(v));
	};
	return _Utils_update(
		model,
		{
			iE: $elm$core$Maybe$Nothing,
			nu: $elm$core$Dict$fromList(
				A2(
					$elm$core$List$map,
					mapDictPair,
					$elm$core$Dict$toList(model.nu)))
		});
};
var $author$project$App$SentenceCore$Update$isHighlightable = F2(
	function (tokens, ind) {
		var _v0 = A2($elm$core$Dict$get, ind, tokens);
		if (!_v0.$) {
			var t = _v0.a;
			return t.h8;
		} else {
			return false;
		}
	});
var $author$project$App$SentenceCore$Update$highlightAux = F3(
	function (tokens, maybeInd, ind) {
		if (A2($author$project$App$SentenceCore$Update$isHighlightable, tokens, ind)) {
			var unhighlighted = A2($author$project$App$SentenceCore$Update$unhighlighten, tokens, maybeInd);
			var getStrings = function (t) {
				return $elm$core$Set$toList(
					$elm$core$Set$fromList(
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									$elm$core$Maybe$Just(t.k0),
									t.dN,
									t.ne
								]))));
			};
			return _Utils_Tuple3(
				A3($author$project$App$SentenceCore$Update$highlight, unhighlighted, true, ind),
				$elm$core$Maybe$Just(ind),
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.n9;
					},
					A2($elm$core$Dict$get, ind, tokens)));
		} else {
			return _Utils_Tuple3(tokens, maybeInd, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$App$SentenceCore$Messages$ActivityPosted = function (a) {
	return {$: 3, a: a};
};
var $author$project$App$SentenceCore$Commands$postActivity = function (payload) {
	var activityPayload = A2(
		$author$project$Models$Activity$activityPayloadFromExposures,
		$elm$core$Maybe$Nothing,
		_List_fromArray(
			[payload]));
	return A2($author$project$App$Activity$Commands$postActivity, $author$project$App$SentenceCore$Messages$ActivityPosted, activityPayload);
};
var $author$project$App$SentenceCore$Messages$ExposurePosted = function (a) {
	return {$: 2, a: a};
};
var $author$project$App$SentenceCore$Commands$postExposure = function (payload) {
	return $elm$http$Http$riskyRequest(
		{
			hy: $elm$http$Http$jsonBody(
				$author$project$Encoders$exposurePayloadEncoder(payload)),
			hY: $elm$http$Http$expectWhatever($author$project$App$SentenceCore$Messages$ExposurePosted),
			h6: _List_Nil,
			iK: 'POST',
			j_: $elm$core$Maybe$Nothing,
			j5: $elm$core$Maybe$Nothing,
			kb: $author$project$Api$urlPrefix + '/exposure'
		});
};
var $author$project$App$SentenceCore$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var ind = msg.a;
				if (_Utils_eq(
					model.h9,
					$elm$core$Maybe$Just(ind))) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var _v1 = A3($author$project$App$SentenceCore$Update$highlightAux, model.gW, model.h9, ind);
					var tokens = _v1.a;
					var highlighted = _v1.b;
					var searchWord = _v1.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								h9: highlighted,
								jD: A2(
									$elm$core$Maybe$map,
									function (sw) {
										return _List_fromArray(
											[sw]);
									},
									searchWord),
								gW: tokens
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				var id = msg.a;
				var cmdForPayload = function (p) {
					return $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$App$SentenceCore$Commands$postExposure(p),
								$author$project$App$SentenceCore$Commands$postActivity(p)
							]));
				};
				return _Utils_Tuple2(
					model,
					_Utils_eq(id, model.nr.fn) ? cmdForPayload(
						$author$project$App$SentenceCore$Update$makeExposurePayload(model)) : $elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$App$Review$Update$updateUponSCMsg = F2(
	function (msg, model) {
		if (!msg.$) {
			return _Utils_update(
				model,
				{iE: $elm$core$Maybe$Nothing});
		} else {
			return model;
		}
	});
var $author$project$App$Review$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $author$project$App$Review$Commands$getReviewTokens);
			case 1:
				if (!msg.a.$) {
					var r = msg.a.a;
					var modelUpdated = $author$project$App$Review$Update$nextTokenUpdate(
						_Utils_update(
							model,
							{gW: r.nc}));
					if (_Utils_eq(modelUpdated.jW, $elm$core$Maybe$Nothing)) {
						return _Utils_Tuple2(modelUpdated, $elm$core$Platform$Cmd$none);
					} else {
						var _v1 = A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.n9;
							},
							modelUpdated.jW);
						if (!_v1.$) {
							var token = _v1.a;
							return _Utils_Tuple2(
								_Utils_update(
									modelUpdated,
									{gN: 1}),
								$author$project$App$Review$Commands$getSentsForToken(token));
						} else {
							return _Utils_Tuple2(modelUpdated, $elm$core$Platform$Cmd$none);
						}
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 2:
				if (!msg.b.$) {
					var t = msg.a;
					var s = msg.b.a;
					var thisT = A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.n9;
							},
							model.jW));
					return (!_Utils_eq(t, thisT)) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{gN: 0}),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						$author$project$App$Review$Update$nextUseCaseUpdate(
							_Utils_update(
								model,
								{
									gN: 0,
									kc: $author$project$Models$Review$shorten(
										A2(
											$author$project$Models$Review$groupByOther,
											thisT,
											$elm$core$List$concat(
												A2(
													$elm$core$List$map,
													function ($) {
														return $.oa;
													},
													s))))
								})),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{gN: 0}),
						$elm$core$Platform$Cmd$none);
				}
			case 3:
				var t = msg.a;
				var unhighlighted = $author$project$App$Review$Update$unhighlight(model);
				return _Utils_Tuple2(
					_Utils_update(
						unhighlighted,
						{
							iE: $elm$core$Maybe$Just(t)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				if (!msg.b.$) {
					var token = msg.a;
					var modelUpdated = $author$project$App$Review$Update$nextTokenUpdate(model);
					var _v2 = A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.n9;
						},
						modelUpdated.jW);
					if (!_v2.$) {
						var t = _v2.a;
						return _Utils_Tuple2(
							_Utils_update(
								modelUpdated,
								{gN: 1}),
							$author$project$App$Review$Commands$getSentsForToken(t));
					} else {
						return _Utils_Tuple2(modelUpdated, $elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 6:
				var id = msg.a;
				var sCMsg = msg.b;
				var updateById = F2(
					function (updatedM, _v5) {
						var i = _v5.a;
						var m = _v5.b;
						return _Utils_eq(i, id) ? _Utils_Tuple2(i, updatedM) : _Utils_Tuple2(
							i,
							$author$project$App$SentenceCore$Update$updateModelForUnhighlight(m));
					});
				var updateModel = function (uM) {
					return _Utils_update(
						model,
						{
							nu: $elm$core$Dict$fromList(
								A2(
									$elm$core$List$map,
									updateById(uM),
									$elm$core$Dict$toList(model.nu)))
						});
				};
				var _v3 = A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (_v4) {
							var m = _v4.a;
							var c = _v4.b;
							return _Utils_Tuple2(
								updateModel(m),
								c);
						},
						A2(
							$elm$core$Maybe$map,
							$author$project$App$SentenceCore$Update$update(sCMsg),
							A2($elm$core$Dict$get, id, model.nu))));
				var modelUpdated = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple2(
					A2($author$project$App$Review$Update$updateUponSCMsg, sCMsg, modelUpdated),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$App$Review$Messages$SentenceCoreMsg(id),
						cmd));
			case 4:
				var maybeString = msg.a;
				return _Utils_Tuple2(
					model,
					A2($author$project$App$Review$Update$cmdsFromCore, model, maybeString));
			case 7:
				if (!msg.b.$) {
					var ids = msg.a;
					var sentIds = $elm$core$Set$fromList(
						$elm$core$Dict$keys(model.nu));
					return _Utils_Tuple2(
						_Utils_eq(sentIds, ids) ? $author$project$App$Review$Update$nextUseCaseUpdate(model) : model,
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$App$Sentence$Model$Idle = 0;
var $author$project$App$Sentence$Model$Loading = 1;
var $author$project$App$Sentence$Messages$SentenceCoreMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$App$Sentence$Messages$GotSentence = function (a) {
	return {$: 1, a: a};
};
var $author$project$Models$Sentence$Sents = function (nextSents) {
	return {iU: nextSents};
};
var $author$project$Decoders$sentsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'next_sents',
	$elm$json$Json$Decode$list($author$project$Decoders$sentDecoder),
	$elm$json$Json$Decode$succeed($author$project$Models$Sentence$Sents));
var $author$project$App$Sentence$Commands$getSentences = $elm$http$Http$riskyRequest(
	{
		hy: $elm$http$Http$emptyBody,
		hY: A2($elm$http$Http$expectJson, $author$project$App$Sentence$Messages$GotSentence, $author$project$Decoders$sentsDecoder),
		h6: _List_Nil,
		iK: 'GET',
		j_: $elm$core$Maybe$Nothing,
		j5: $elm$core$Maybe$Nothing,
		kb: $author$project$Api$urlPrefix + '/sentence'
	});
var $author$project$App$Sentence$Commands$getTokenReviewSentences = $elm$http$Http$riskyRequest(
	{
		hy: $elm$http$Http$emptyBody,
		hY: A2($elm$http$Http$expectJson, $author$project$App$Sentence$Messages$GotSentence, $author$project$Decoders$sentsDecoder),
		h6: _List_Nil,
		iK: 'GET',
		j_: $elm$core$Maybe$Nothing,
		j5: $elm$core$Maybe$Nothing,
		kb: $author$project$Api$urlPrefix + '/sentence/token_review'
	});
var $author$project$App$Sentence$Update$getAllSentences = $elm$core$Platform$Cmd$batch(
	_List_fromArray(
		[$author$project$App$Sentence$Commands$getSentences, $author$project$App$Sentence$Commands$getTokenReviewSentences]));
var $author$project$App$Sentence$Update$modelUpdateWithGotSent = F2(
	function (model, _v0) {
		var nextSents = _v0.iU;
		var isNew = function (_v1) {
			var id = _v1.fn;
			return !A2($elm$core$Set$member, id, model.ih);
		};
		var newSents = A2($elm$core$List$filter, isNew, nextSents);
		return _Utils_update(
			model,
			{
				ih: A2(
					$elm$core$Set$union,
					model.ih,
					$elm$core$Set$fromList(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.fn;
							},
							newSents))),
				iU: _Utils_ap(model.iU, newSents)
			});
	});
var $author$project$App$Sentence$Update$nextSentUpdate = function (model) {
	var _v0 = function () {
		var _v1 = model.iU;
		if (_v1.b) {
			var tS = _v1.a;
			var nSs = _v1.b;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(tS),
				nSs);
		} else {
			return _Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil);
		}
	}();
	var thisSent = _v0.a;
	var nextSents = _v0.b;
	var modelNew = {
		ih: model.ih,
		iU: nextSents,
		gN: function () {
			var _v2 = _Utils_Tuple2(
				model.gN,
				_Utils_eq(model.iU, _List_Nil));
			if ((_v2.a === 1) && _v2.b) {
				var _v3 = _v2.a;
				return 1;
			} else {
				return 0;
			}
		}(),
		jV: A2($elm$core$Maybe$map, $author$project$App$SentenceCore$Model$init, thisSent)
	};
	return _Utils_Tuple2(
		modelNew,
		_Utils_eq(nextSents, _List_Nil));
};
var $author$project$App$Sentence$Update$updateUponCore = F2(
	function (msg, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		if ((msg.$ === 2) && (!msg.a.$)) {
			var _v2 = $author$project$App$Sentence$Update$nextSentUpdate(model);
			var modelUpdated = _v2.a;
			var getSents = _v2.b;
			return _Utils_Tuple2(
				modelUpdated,
				getSents ? $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[$author$project$App$Sentence$Update$getAllSentences, cmd])) : cmd);
		} else {
			return _Utils_Tuple2(model, cmd);
		}
	});
var $author$project$App$Sentence$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gN: 1}),
					$author$project$App$Sentence$Update$getAllSentences);
			case 1:
				if (!msg.a.$) {
					var s = msg.a.a;
					var modelU = A2($author$project$App$Sentence$Update$modelUpdateWithGotSent, model, s);
					var _v1 = _Utils_eq(model.jV, $elm$core$Maybe$Nothing) ? $author$project$App$Sentence$Update$nextSentUpdate(modelU) : _Utils_Tuple2(
						_Utils_update(
							modelU,
							{gN: 0}),
						false);
					var modelNew = _v1.a;
					return _Utils_Tuple2(modelNew, $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{gN: 0}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var sCMsg = msg.a;
				var _v2 = A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model.jV, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (_v3) {
							var m = _v3.a;
							var c = _v3.b;
							return _Utils_Tuple2(
								$elm$core$Maybe$Just(m),
								c);
						},
						A2(
							$elm$core$Maybe$map,
							$author$project$App$SentenceCore$Update$update(sCMsg),
							model.jV)));
				var sCModel = _v2.a;
				var sCCmd = _v2.b;
				return A2(
					$author$project$App$Sentence$Update$updateUponCore,
					sCMsg,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{jV: sCModel}),
						A2($elm$core$Platform$Cmd$map, $author$project$App$Sentence$Messages$SentenceCoreMsg, sCCmd)));
		}
	});
var $author$project$App$Update$authOther = F2(
	function (model, msg) {
		_v0$4:
		while (true) {
			switch (msg.$) {
				case 1:
					if (!msg.a.$) {
						var appBarModel = model.hp;
						var _v1 = A2($author$project$App$Sentence$Update$update, $author$project$App$Sentence$Messages$GetSentence, model.jI);
						var sentM = _v1.a;
						var sentC = _v1.b;
						var _v2 = A2($author$project$App$Review$Update$update, $author$project$App$Review$Messages$GetTokens, model.jq);
						var revM = _v2.a;
						var revC = _v2.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									hp: _Utils_update(
										appBarModel,
										{kd: model.hr.kd}),
									jq: revM,
									jI: sentM
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$App$Messages$SentenceMsg, sentC),
										(model.jt !== 1) ? A2($elm$browser$Browser$Navigation$pushUrl, model.it, '/dashboard') : $elm$core$Platform$Cmd$none,
										A2($elm$core$Platform$Cmd$map, $author$project$App$Messages$ReviewMsg, revC),
										A2($elm$core$Platform$Cmd$map, $author$project$App$Messages$ActivityMsg, $author$project$App$Activity$Commands$getActivity),
										$author$project$App$Commands$getTodaysActivity
									])));
					} else {
						return (model.jt === 1) ? _Utils_Tuple2(
							model,
							A2($elm$browser$Browser$Navigation$pushUrl, model.it, '/')) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 8:
					return (model.jt === 1) ? _Utils_Tuple2(
						model,
						A2($elm$browser$Browser$Navigation$pushUrl, model.it, '/')) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 3:
					if (!msg.a.$) {
						return _Utils_Tuple2(model, $author$project$App$Commands$getTodaysActivity);
					} else {
						break _v0$4;
					}
				default:
					break _v0$4;
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $avh4$elm_color$Color$RgbaSpace = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $avh4$elm_color$Color$black = A4($avh4$elm_color$Color$RgbaSpace, 0 / 255, 0 / 255, 0 / 255, 1.0);
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{K: nodeList, B: nodeListSize, G: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $avh4$elm_color$Color$fromRgba = function (components) {
	return A4($avh4$elm_color$Color$RgbaSpace, components.m2, components.lI, components.kL, components.kw);
};
var $author$project$Models$Ring$rgba255 = F4(
	function (r, g, b, a) {
		return $avh4$elm_color$Color$fromRgba(
			{kw: a, kL: b / 255, lI: g / 255, m2: r / 255});
	});
var $author$project$Models$Ring$colors = $elm$core$Array$fromList(
	_List_fromArray(
		[
			A4($author$project$Models$Ring$rgba255, 200, 220, 255, 0.5),
			A4($author$project$Models$Ring$rgba255, 0, 122, 255, 0.5),
			A4($author$project$Models$Ring$rgba255, 200, 240, 200, 0.5),
			A4($author$project$Models$Ring$rgba255, 52, 199, 89, 0.5),
			A4($author$project$Models$Ring$rgba255, 255, 255, 255, 0.7),
			A4($author$project$Models$Ring$rgba255, 13, 148, 136, 0)
		]));
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $author$project$Models$Ring$getColor = function (idx) {
	return A2(
		$elm$core$Maybe$withDefault,
		$avh4$elm_color$Color$black,
		A2($elm$core$Array$get, idx, $author$project$Models$Ring$colors));
};
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $author$project$Models$Ring$countsToAnnularPair = F2(
	function (classes, _v0) {
		var goalSents = _v0.lG;
		var sentsCount = _v0.nv;
		var tokensReviewableCount = _v0.of;
		var tokensReviewedCount = _v0.oh;
		var wordAnnular = {
			dv: _Utils_eq(classes, _List_Nil) ? $author$project$Models$Ring$getColor(2) : $author$project$Models$Ring$getColor(5),
			dL: _Utils_eq(classes, _List_Nil) ? $author$project$Models$Ring$getColor(3) : $author$project$Models$Ring$getColor(4),
			cm: 7.8,
			aL: A2($elm$core$Basics$min, 1.0, tokensReviewedCount / tokensReviewableCount)
		};
		var sentenceAnnular = {
			dv: _Utils_eq(classes, _List_Nil) ? $author$project$Models$Ring$getColor(0) : $author$project$Models$Ring$getColor(5),
			dL: _Utils_eq(classes, _List_Nil) ? $author$project$Models$Ring$getColor(1) : $author$project$Models$Ring$getColor(4),
			cm: 10,
			aL: A2($elm$core$Basics$min, 1.0, sentsCount / goalSents)
		};
		return _Utils_Tuple2(sentenceAnnular, wordAnnular);
	});
var $author$project$Models$Ring$stepCount = 50;
var $author$project$Models$Ring$interpolateAnnular = F2(
	function (s, e) {
		var mapFnc = function (i) {
			return _Utils_update(
				s,
				{aL: s.aL + (((e.aL - s.aL) / ($author$project$Models$Ring$stepCount - 1)) * i)});
		};
		return A2(
			$elm$core$List$map,
			mapFnc,
			A2($elm$core$List$range, 0, $author$project$Models$Ring$stepCount - 1));
	});
var $author$project$Models$Ring$interPolateAnnularPair = F2(
	function (_v0, _v1) {
		var a1S = _v0.a;
		var a2S = _v0.b;
		var a1E = _v1.a;
		var a2E = _v1.b;
		return A3(
			$elm$core$List$map2,
			$elm$core$Tuple$pair,
			A2($author$project$Models$Ring$interpolateAnnular, a1S, a1E),
			A2($author$project$Models$Ring$interpolateAnnular, a2S, a2E));
	});
var $author$project$Models$Ring$interPolateAnnularPairFromZero = function (_v0) {
	var a1E = _v0.a;
	var a2E = _v0.b;
	return A3(
		$elm$core$List$map2,
		$elm$core$Tuple$pair,
		A2(
			$author$project$Models$Ring$interpolateAnnular,
			_Utils_update(
				a1E,
				{aL: 0}),
			a1E),
		A2(
			$author$project$Models$Ring$interpolateAnnular,
			_Utils_update(
				a2E,
				{aL: 0}),
			a2E));
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm_community$typed_svg$TypedSvg$Core$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm_community$typed_svg$TypedSvg$Attributes$class = function (names) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'class',
		A2($elm$core$String$join, ' ', names));
};
var $author$project$Models$Ring$h = 20;
var $elm_community$typed_svg$TypedSvg$Types$Paint = function (a) {
	return {$: 0, a: a};
};
var $elm_community$typed_svg$TypedSvg$Types$Translate = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $elm$core$Basics$acos = _Basics_acos;
var $folkertdev$one_true_path_experiment$LowLevel$Command$EllipticalArc = function (a) {
	return {$: 3, a: a};
};
var $folkertdev$one_true_path_experiment$LowLevel$Command$arcTo = $folkertdev$one_true_path_experiment$LowLevel$Command$EllipticalArc;
var $folkertdev$svg_path_lowlevel$Path$LowLevel$LargestArc = 1;
var $folkertdev$one_true_path_experiment$LowLevel$Command$largestArc = 1;
var $folkertdev$svg_path_lowlevel$Path$LowLevel$SmallestArc = 0;
var $folkertdev$one_true_path_experiment$LowLevel$Command$smallestArc = 0;
var $gampleman$elm_visualization$Shape$Pie$boolToArc = function (b) {
	return b ? $folkertdev$one_true_path_experiment$LowLevel$Command$largestArc : $folkertdev$one_true_path_experiment$LowLevel$Command$smallestArc;
};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$Clockwise = 0;
var $folkertdev$one_true_path_experiment$LowLevel$Command$clockwise = 0;
var $folkertdev$svg_path_lowlevel$Path$LowLevel$CounterClockwise = 1;
var $folkertdev$one_true_path_experiment$LowLevel$Command$counterClockwise = 1;
var $gampleman$elm_visualization$Shape$Pie$boolToDirection = function (b) {
	return b ? $folkertdev$one_true_path_experiment$LowLevel$Command$counterClockwise : $folkertdev$one_true_path_experiment$LowLevel$Command$clockwise;
};
var $elm$core$Basics$cos = _Basics_cos;
var $folkertdev$one_true_path_experiment$SubPath$Empty = {$: 1};
var $folkertdev$one_true_path_experiment$SubPath$empty = $folkertdev$one_true_path_experiment$SubPath$Empty;
var $gampleman$elm_visualization$Shape$Pie$epsilon = 1.0e-12;
var $elm$core$Basics$truncate = _Basics_truncate;
var $gampleman$elm_visualization$Shape$Pie$mod = F2(
	function (a, b) {
		var frac = a / b;
		return (frac - (frac | 0)) * b;
	});
var $folkertdev$one_true_path_experiment$LowLevel$Command$MoveTo = $elm$core$Basics$identity;
var $folkertdev$one_true_path_experiment$LowLevel$Command$moveTo = $elm$core$Basics$identity;
var $elm$core$Basics$pi = _Basics_pi;
var $elm$core$Basics$sin = _Basics_sin;
var $folkertdev$one_true_path_experiment$SubPath$SubPath = function (a) {
	return {$: 0, a: a};
};
var $folkertdev$elm_deque$Deque$Deque = $elm$core$Basics$identity;
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $folkertdev$elm_deque$Internal$rebalance = function (deque) {
	var sizeF = deque.ae;
	var sizeR = deque.af;
	var front = deque.ap;
	var rear = deque.ar;
	var size1 = ((sizeF + sizeR) / 2) | 0;
	var size2 = (sizeF + sizeR) - size1;
	var balanceConstant = 4;
	if ((sizeF + sizeR) < 2) {
		return deque;
	} else {
		if (_Utils_cmp(sizeF, (balanceConstant * sizeR) + 1) > 0) {
			var newRear = _Utils_ap(
				rear,
				$elm$core$List$reverse(
					A2($elm$core$List$drop, size1, front)));
			var newFront = A2($elm$core$List$take, size1, front);
			return {ap: newFront, ar: newRear, ae: size1, af: size2};
		} else {
			if (_Utils_cmp(sizeR, (balanceConstant * sizeF) + 1) > 0) {
				var newRear = A2($elm$core$List$take, size1, rear);
				var newFront = _Utils_ap(
					front,
					$elm$core$List$reverse(
						A2($elm$core$List$drop, size1, rear)));
				return {ap: newFront, ar: newRear, ae: size1, af: size2};
			} else {
				return deque;
			}
		}
	}
};
var $folkertdev$elm_deque$Internal$fromList = function (list) {
	return $folkertdev$elm_deque$Internal$rebalance(
		{
			ap: list,
			ar: _List_Nil,
			ae: $elm$core$List$length(list),
			af: 0
		});
};
var $folkertdev$elm_deque$Deque$fromList = A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $folkertdev$elm_deque$Internal$fromList);
var $folkertdev$one_true_path_experiment$SubPath$with = F2(
	function (moveto, drawtos) {
		return $folkertdev$one_true_path_experiment$SubPath$SubPath(
			{
				hQ: $folkertdev$elm_deque$Deque$fromList(drawtos),
				iP: moveto
			});
	});
var $gampleman$elm_visualization$Shape$Pie$arc_ = F6(
	function (x, y, radius, a0, a1, ccw) {
		var r = $elm$core$Basics$abs(radius);
		if (!r) {
			return $folkertdev$one_true_path_experiment$SubPath$empty;
		} else {
			var tau = 2 * $elm$core$Basics$pi;
			var dy = r * $elm$core$Basics$sin(a0);
			var y0_ = y + dy;
			var dx = r * $elm$core$Basics$cos(a0);
			var x0_ = x + dx;
			var origin = $folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
				_Utils_Tuple2(x0_, y0_));
			var da = ccw ? (a0 - a1) : (a1 - a0);
			var cw = $gampleman$elm_visualization$Shape$Pie$boolToDirection(!ccw);
			if (_Utils_cmp(da, tau - $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) {
				return A2(
					$folkertdev$one_true_path_experiment$SubPath$with,
					origin,
					_List_fromArray(
						[
							$folkertdev$one_true_path_experiment$LowLevel$Command$arcTo(
							_List_fromArray(
								[
									{
									eL: $folkertdev$one_true_path_experiment$LowLevel$Command$largestArc,
									e6: cw,
									bl: _Utils_Tuple2(r, r),
									gQ: _Utils_Tuple2(x - dx, y - dy),
									a5: 0
								}
								])),
							$folkertdev$one_true_path_experiment$LowLevel$Command$arcTo(
							_List_fromArray(
								[
									{
									eL: $folkertdev$one_true_path_experiment$LowLevel$Command$largestArc,
									e6: cw,
									bl: _Utils_Tuple2(r, r),
									gQ: _Utils_Tuple2(x0_, y0_),
									a5: 0
								}
								]))
						]));
			} else {
				var da_ = (da < 0) ? (A2($gampleman$elm_visualization$Shape$Pie$mod, da, tau) + tau) : da;
				return A2(
					$folkertdev$one_true_path_experiment$SubPath$with,
					origin,
					_List_fromArray(
						[
							$folkertdev$one_true_path_experiment$LowLevel$Command$arcTo(
							_List_fromArray(
								[
									{
									eL: $gampleman$elm_visualization$Shape$Pie$boolToArc(
										_Utils_cmp(da_, $elm$core$Basics$pi) > -1),
									e6: cw,
									bl: _Utils_Tuple2(r, r),
									gQ: _Utils_Tuple2(
										x + (r * $elm$core$Basics$cos(a1)),
										y + (r * $elm$core$Basics$sin(a1))),
									a5: 0
								}
								]))
						]));
			}
		}
	});
var $elm$core$Basics$atan2 = _Basics_atan2;
var $folkertdev$one_true_path_experiment$LowLevel$Command$ClosePath = {$: 4};
var $folkertdev$one_true_path_experiment$LowLevel$Command$closePath = $folkertdev$one_true_path_experiment$LowLevel$Command$ClosePath;
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $folkertdev$elm_deque$Internal$empty = {ap: _List_Nil, ar: _List_Nil, ae: 0, af: 0};
var $folkertdev$elm_deque$Internal$popBack = function (deque) {
	var front = deque.ap;
	var rear = deque.ar;
	var _v0 = _Utils_Tuple2(front, rear);
	if (!_v0.b.b) {
		if (!_v0.a.b) {
			return _Utils_Tuple2($elm$core$Maybe$Nothing, $folkertdev$elm_deque$Internal$empty);
		} else {
			if (!_v0.a.b.b) {
				var _v1 = _v0.a;
				var x = _v1.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(x),
					$folkertdev$elm_deque$Internal$empty);
			} else {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $folkertdev$elm_deque$Internal$empty);
			}
		}
	} else {
		var _v2 = _v0.b;
		var r = _v2.a;
		var rs = _v2.b;
		return _Utils_Tuple2(
			$elm$core$Maybe$Just(r),
			$folkertdev$elm_deque$Internal$rebalance(
				{ap: deque.ap, ar: rs, ae: deque.ae, af: deque.af - 1}));
	}
};
var $folkertdev$elm_deque$Deque$unwrap = function (_v0) {
	var boundedDeque = _v0;
	return boundedDeque;
};
var $folkertdev$elm_deque$Deque$popBack = A2(
	$elm$core$Basics$composeL,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$Tuple$mapSecond($elm$core$Basics$identity),
		$folkertdev$elm_deque$Internal$popBack),
	$folkertdev$elm_deque$Deque$unwrap);
var $folkertdev$elm_deque$Deque$mapAbstract = F2(
	function (f, _v0) {
		var _abstract = _v0;
		return f(_abstract);
	});
var $folkertdev$elm_deque$Deque$pushBack = F2(
	function (elem, _v0) {
		var deque = _v0;
		return A2(
			$folkertdev$elm_deque$Deque$mapAbstract,
			$folkertdev$elm_deque$Internal$rebalance,
			{
				ap: deque.ap,
				ar: A2($elm$core$List$cons, elem, deque.ar),
				ae: deque.ae,
				af: deque.af + 1
			});
	});
var $folkertdev$one_true_path_experiment$SubPath$close = function (subpath) {
	if (subpath.$ === 1) {
		return $folkertdev$one_true_path_experiment$SubPath$Empty;
	} else {
		var moveto = subpath.a.iP;
		var drawtos = subpath.a.hQ;
		var _v1 = $folkertdev$elm_deque$Deque$popBack(drawtos);
		if ((!_v1.a.$) && (_v1.a.a.$ === 4)) {
			var _v2 = _v1.a.a;
			var preceding = _v1.b;
			return subpath;
		} else {
			return $folkertdev$one_true_path_experiment$SubPath$SubPath(
				{
					hQ: A2($folkertdev$elm_deque$Deque$pushBack, $folkertdev$one_true_path_experiment$LowLevel$Command$closePath, drawtos),
					iP: moveto
				});
		}
	}
};
var $folkertdev$one_true_path_experiment$SubPath$firstPoint = function (_v0) {
	var moveto = _v0.iP;
	var p = moveto;
	return p;
};
var $folkertdev$one_true_path_experiment$LowLevel$Command$LineTo = function (a) {
	return {$: 0, a: a};
};
var $folkertdev$one_true_path_experiment$LowLevel$Command$lineTo = $folkertdev$one_true_path_experiment$LowLevel$Command$LineTo;
var $folkertdev$one_true_path_experiment$SubPath$map2 = F3(
	function (f, sub1, sub2) {
		var _v0 = _Utils_Tuple2(sub1, sub2);
		if (_v0.a.$ === 1) {
			if (_v0.b.$ === 1) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return $folkertdev$one_true_path_experiment$SubPath$Empty;
			} else {
				var _v3 = _v0.a;
				var subpath = _v0.b;
				return subpath;
			}
		} else {
			if (_v0.b.$ === 1) {
				var subpath = _v0.a;
				var _v4 = _v0.b;
				return subpath;
			} else {
				var a = _v0.a.a;
				var b = _v0.b.a;
				return A2(f, a, b);
			}
		}
	});
var $folkertdev$one_true_path_experiment$SubPath$pushBack = F2(
	function (drawto, data) {
		return _Utils_update(
			data,
			{
				hQ: A2($folkertdev$elm_deque$Deque$pushBack, drawto, data.hQ)
			});
	});
var $folkertdev$elm_deque$Internal$length = function (deque) {
	return deque.ae + deque.af;
};
var $folkertdev$elm_deque$Internal$isEmpty = function (deque) {
	return !$folkertdev$elm_deque$Internal$length(deque);
};
var $folkertdev$elm_deque$Deque$isEmpty = A2($elm$core$Basics$composeL, $folkertdev$elm_deque$Internal$isEmpty, $folkertdev$elm_deque$Deque$unwrap);
var $folkertdev$elm_deque$Deque$append = F2(
	function (p, q) {
		var x = p;
		var y = q;
		return $folkertdev$elm_deque$Deque$isEmpty(p) ? q : ($folkertdev$elm_deque$Deque$isEmpty(q) ? p : {
			ap: _Utils_ap(
				x.ap,
				$elm$core$List$reverse(x.ar)),
			ar: $elm$core$List$reverse(
				_Utils_ap(
					y.ap,
					$elm$core$List$reverse(y.ar))),
			ae: x.ae + x.af,
			af: y.ae + y.af
		});
	});
var $folkertdev$one_true_path_experiment$SubPath$unsafeConcatenate = F2(
	function (a, b) {
		return _Utils_update(
			a,
			{
				hQ: A2($folkertdev$elm_deque$Deque$append, a.hQ, b.hQ)
			});
	});
var $folkertdev$one_true_path_experiment$SubPath$connect = function () {
	var helper = F2(
		function (right, left) {
			return $folkertdev$one_true_path_experiment$SubPath$SubPath(
				A2(
					$folkertdev$one_true_path_experiment$SubPath$unsafeConcatenate,
					A2(
						$folkertdev$one_true_path_experiment$SubPath$pushBack,
						$folkertdev$one_true_path_experiment$LowLevel$Command$lineTo(
							_List_fromArray(
								[
									$folkertdev$one_true_path_experiment$SubPath$firstPoint(right)
								])),
						left),
					right));
		});
	return $folkertdev$one_true_path_experiment$SubPath$map2(helper);
}();
var $elm$core$Basics$pow = _Basics_pow;
var $elm$core$Basics$sqrt = _Basics_sqrt;
var $gampleman$elm_visualization$Shape$Pie$cornerTangents = F7(
	function (x0, y0, x1, y1, r1, rc, cw) {
		var y01 = y0 - y1;
		var x01 = x0 - x1;
		var r = r1 - rc;
		var lo = (cw ? rc : (-rc)) / $elm$core$Basics$sqrt(
			A2($elm$core$Basics$pow, x01, 2) + A2($elm$core$Basics$pow, y01, 2));
		var ox = lo * y01;
		var x10 = x1 + ox;
		var x11 = x0 + ox;
		var x00 = (x11 + x10) / 2;
		var oy = (-lo) * x01;
		var y10 = y1 + oy;
		var y11 = y0 + oy;
		var y00 = (y11 + y10) / 2;
		var dy = y10 - y11;
		var dx = x10 - x11;
		var dd = (x11 * y10) - (x10 * y11);
		var d2 = A2($elm$core$Basics$pow, dx, 2) + A2($elm$core$Basics$pow, dy, 2);
		var d = ((dy < 0) ? (-1) : 1) * $elm$core$Basics$sqrt(
			A2(
				$elm$core$Basics$max,
				0,
				(A2($elm$core$Basics$pow, r, 2) * d2) - A2($elm$core$Basics$pow, dd, 2)));
		var cy1 = (((-dd) * dx) + (dy * d)) / d2;
		var dy1 = cy1 - y00;
		var cy0 = (((-dd) * dx) - (dy * d)) / d2;
		var dy0 = cy0 - y00;
		var cx1 = ((dd * dy) + (dx * d)) / d2;
		var dx1 = cx1 - x00;
		var cx0 = ((dd * dy) - (dx * d)) / d2;
		var dx0 = cx0 - x00;
		var _v0 = (_Utils_cmp(
			A2($elm$core$Basics$pow, dx0, 2) + A2($elm$core$Basics$pow, dy0, 2),
			A2($elm$core$Basics$pow, dx1, 2) + A2($elm$core$Basics$pow, dy1, 2)) > 0) ? _Utils_Tuple2(cx1, cy1) : _Utils_Tuple2(cx0, cy0);
		var fcx = _v0.a;
		var fxy = _v0.b;
		return {aa: fcx, ab: fxy, aA: -ox, a4: fcx * ((r1 / r) - 1), aB: -oy, a6: fxy * ((r1 / r) - 1)};
	});
var $gampleman$elm_visualization$Shape$Pie$intersect = F8(
	function (x0, y0, x1, y1, x2, y2, x3, y3) {
		var y32 = y3 - y2;
		var y10 = y1 - y0;
		var x32 = x3 - x2;
		var x10 = x1 - x0;
		var t = ((x32 * (y0 - y2)) - (y32 * (x0 - x2))) / ((y32 * x10) - (x32 * y10));
		return _Utils_Tuple2(x0 + (t * x10), y0 + (t * y10));
	});
var $folkertdev$elm_deque$Internal$foldl = F3(
	function (f, initial, deque) {
		return function (initial_) {
			return A3($elm$core$List$foldr, f, initial_, deque.ar);
		}(
			A3($elm$core$List$foldl, f, initial, deque.ap));
	});
var $folkertdev$elm_deque$Deque$foldl = F2(
	function (f, initial) {
		return A2(
			$elm$core$Basics$composeL,
			A2($folkertdev$elm_deque$Internal$foldl, f, initial),
			$folkertdev$elm_deque$Deque$unwrap);
	});
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $folkertdev$one_true_path_experiment$LowLevel$Command$updateCursorState = F2(
	function (drawto, state) {
		var noControlPoint = function (currentState) {
			return _Utils_update(
				currentState,
				{R: $elm$core$Maybe$Nothing});
		};
		var maybeUpdateCursor = function (coordinate) {
			return _Utils_update(
				state,
				{
					m: A2($elm$core$Maybe$withDefault, state.m, coordinate)
				});
		};
		var _v0 = state.m;
		var cursorX = _v0.a;
		var cursorY = _v0.b;
		switch (drawto.$) {
			case 0:
				var coordinates = drawto.a;
				return noControlPoint(
					maybeUpdateCursor(
						$elm_community$list_extra$List$Extra$last(coordinates)));
			case 1:
				var coordinates = drawto.a;
				var _v2 = $elm_community$list_extra$List$Extra$last(coordinates);
				if (_v2.$ === 1) {
					return state;
				} else {
					var _v3 = _v2.a;
					var control1 = _v3.a;
					var control2 = _v3.b;
					var target = _v3.c;
					return _Utils_update(
						state,
						{
							m: target,
							R: $elm$core$Maybe$Just(control2)
						});
				}
			case 2:
				var coordinates = drawto.a;
				var _v4 = $elm_community$list_extra$List$Extra$last(coordinates);
				if (_v4.$ === 1) {
					return state;
				} else {
					var _v5 = _v4.a;
					var control = _v5.a;
					var target = _v5.b;
					return _Utils_update(
						state,
						{
							m: target,
							R: $elm$core$Maybe$Just(control)
						});
				}
			case 3:
				var _arguments = drawto.a;
				return noControlPoint(
					maybeUpdateCursor(
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.gQ;
							},
							$elm_community$list_extra$List$Extra$last(_arguments))));
			default:
				return noControlPoint(state);
		}
	});
var $folkertdev$one_true_path_experiment$SubPath$finalCursorState = function (_v0) {
	var moveto = _v0.iP;
	var drawtos = _v0.hQ;
	var _v1 = moveto;
	var start = _v1;
	var initial = {m: start, R: $elm$core$Maybe$Nothing, gM: start};
	return A3($folkertdev$elm_deque$Deque$foldl, $folkertdev$one_true_path_experiment$LowLevel$Command$updateCursorState, initial, drawtos);
};
var $folkertdev$one_true_path_experiment$SubPath$finalPoint = A2(
	$elm$core$Basics$composeR,
	$folkertdev$one_true_path_experiment$SubPath$finalCursorState,
	function ($) {
		return $.m;
	});
var $ianmackenzie$elm_units$Quantity$Quantity = $elm$core$Basics$identity;
var $ianmackenzie$elm_units$Quantity$float = function (value) {
	return value;
};
var $ianmackenzie$elm_geometry$Geometry$Types$Vector2d = $elm$core$Basics$identity;
var $ianmackenzie$elm_geometry$Vector2d$xy = F2(
	function (_v0, _v1) {
		var x = _v0;
		var y = _v1;
		return {kn: x, ko: y};
	});
var $ianmackenzie$elm_geometry$Vector2d$fromTuple = F2(
	function (toQuantity, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return A2(
			$ianmackenzie$elm_geometry$Vector2d$xy,
			toQuantity(x),
			toQuantity(y));
	});
var $folkertdev$elm_deque$Internal$map = F2(
	function (f, deque) {
		return {
			ap: A2($elm$core$List$map, f, deque.ap),
			ar: A2($elm$core$List$map, f, deque.ar),
			ae: deque.ae,
			af: deque.af
		};
	});
var $folkertdev$elm_deque$Deque$map = function (f) {
	return $folkertdev$elm_deque$Deque$mapAbstract(
		$folkertdev$elm_deque$Internal$map(f));
};
var $folkertdev$one_true_path_experiment$LowLevel$Command$CurveTo = function (a) {
	return {$: 1, a: a};
};
var $folkertdev$one_true_path_experiment$LowLevel$Command$QuadraticBezierCurveTo = function (a) {
	return {$: 2, a: a};
};
var $folkertdev$one_true_path_experiment$LowLevel$Command$mapTuple2 = F2(
	function (f, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		return _Utils_Tuple2(
			f(a),
			f(b));
	});
var $folkertdev$one_true_path_experiment$LowLevel$Command$mapTuple3 = F2(
	function (f, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		var c = _v0.c;
		return _Utils_Tuple3(
			f(a),
			f(b),
			f(c));
	});
var $folkertdev$one_true_path_experiment$LowLevel$Command$mapCoordinateDrawTo = F2(
	function (f, drawto) {
		switch (drawto.$) {
			case 0:
				var coordinates = drawto.a;
				return $folkertdev$one_true_path_experiment$LowLevel$Command$LineTo(
					A2($elm$core$List$map, f, coordinates));
			case 1:
				var coordinates = drawto.a;
				return $folkertdev$one_true_path_experiment$LowLevel$Command$CurveTo(
					A2(
						$elm$core$List$map,
						$folkertdev$one_true_path_experiment$LowLevel$Command$mapTuple3(f),
						coordinates));
			case 2:
				var coordinates = drawto.a;
				return $folkertdev$one_true_path_experiment$LowLevel$Command$QuadraticBezierCurveTo(
					A2(
						$elm$core$List$map,
						$folkertdev$one_true_path_experiment$LowLevel$Command$mapTuple2(f),
						coordinates));
			case 3:
				var _arguments = drawto.a;
				return $folkertdev$one_true_path_experiment$LowLevel$Command$EllipticalArc(
					A2(
						$elm$core$List$map,
						function (argument) {
							return _Utils_update(
								argument,
								{
									gQ: f(argument.gQ)
								});
						},
						_arguments));
			default:
				return $folkertdev$one_true_path_experiment$LowLevel$Command$ClosePath;
		}
	});
var $folkertdev$one_true_path_experiment$SubPath$mapCoordinateInstructions = F2(
	function (f, _v0) {
		var moveto = _v0.iP;
		var drawtos = _v0.hQ;
		var coordinate = moveto;
		return {
			hQ: A2(
				$folkertdev$elm_deque$Deque$map,
				$folkertdev$one_true_path_experiment$LowLevel$Command$mapCoordinateDrawTo(f),
				drawtos),
			iP: f(coordinate)
		};
	});
var $ianmackenzie$elm_geometry$Vector2d$minus = F2(
	function (_v0, _v1) {
		var v2 = _v0;
		var v1 = _v1;
		return {kn: v1.kn - v2.kn, ko: v1.ko - v2.ko};
	});
var $ianmackenzie$elm_geometry$Vector2d$plus = F2(
	function (_v0, _v1) {
		var v2 = _v0;
		var v1 = _v1;
		return {kn: v1.kn + v2.kn, ko: v1.ko + v2.ko};
	});
var $ianmackenzie$elm_units$Quantity$toFloat = function (_v0) {
	var value = _v0;
	return value;
};
var $ianmackenzie$elm_geometry$Vector2d$xComponent = function (_v0) {
	var v = _v0;
	return v.kn;
};
var $ianmackenzie$elm_geometry$Vector2d$yComponent = function (_v0) {
	var v = _v0;
	return v.ko;
};
var $ianmackenzie$elm_geometry$Vector2d$toTuple = F2(
	function (fromQuantity, vector) {
		return _Utils_Tuple2(
			fromQuantity(
				$ianmackenzie$elm_geometry$Vector2d$xComponent(vector)),
			fromQuantity(
				$ianmackenzie$elm_geometry$Vector2d$yComponent(vector)));
	});
var $folkertdev$one_true_path_experiment$SubPath$continue = function () {
	var helper = F2(
		function (right, left) {
			var distance = A2(
				$ianmackenzie$elm_geometry$Vector2d$minus,
				A2(
					$ianmackenzie$elm_geometry$Vector2d$fromTuple,
					$ianmackenzie$elm_units$Quantity$float,
					$folkertdev$one_true_path_experiment$SubPath$firstPoint(right)),
				A2(
					$ianmackenzie$elm_geometry$Vector2d$fromTuple,
					$ianmackenzie$elm_units$Quantity$float,
					$folkertdev$one_true_path_experiment$SubPath$finalPoint(left)));
			var mapper = A2(
				$elm$core$Basics$composeL,
				A2(
					$elm$core$Basics$composeL,
					$ianmackenzie$elm_geometry$Vector2d$toTuple($ianmackenzie$elm_units$Quantity$toFloat),
					$ianmackenzie$elm_geometry$Vector2d$plus(distance)),
				$ianmackenzie$elm_geometry$Vector2d$fromTuple($ianmackenzie$elm_units$Quantity$float));
			return $folkertdev$one_true_path_experiment$SubPath$SubPath(
				A2(
					$folkertdev$one_true_path_experiment$SubPath$unsafeConcatenate,
					left,
					A2($folkertdev$one_true_path_experiment$SubPath$mapCoordinateInstructions, mapper, right)));
		});
	return $folkertdev$one_true_path_experiment$SubPath$map2(helper);
}();
var $gampleman$elm_visualization$Shape$Pie$makeArc = F6(
	function (x, y, radius, a0, a1, ccw) {
		return $folkertdev$one_true_path_experiment$SubPath$continue(
			A6($gampleman$elm_visualization$Shape$Pie$arc_, x, y, radius, a0, a1, ccw));
	});
var $elm$core$Basics$asin = _Basics_asin;
var $gampleman$elm_visualization$Shape$Pie$myAsin = function (x) {
	return (x >= 1) ? ($elm$core$Basics$pi / 2) : ((_Utils_cmp(x, -1) < 1) ? ((-$elm$core$Basics$pi) / 2) : $elm$core$Basics$asin(x));
};
var $gampleman$elm_visualization$Shape$Pie$arc = function (arcData) {
	var _v0 = (_Utils_cmp(arcData.lZ, arcData.cm) > 0) ? _Utils_Tuple2(arcData.cm, arcData.lZ) : _Utils_Tuple2(arcData.lZ, arcData.cm);
	var r0 = _v0.a;
	var r1 = _v0.b;
	if (_Utils_cmp(r1, $gampleman$elm_visualization$Shape$Pie$epsilon) < 1) {
		return _List_fromArray(
			[
				$folkertdev$one_true_path_experiment$SubPath$close(
				A2(
					$folkertdev$one_true_path_experiment$SubPath$with,
					$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
						_Utils_Tuple2(0, 0)),
					_List_Nil))
			]);
	} else {
		var a1 = arcData.lt - ($elm$core$Basics$pi / 2);
		var a0 = arcData.nF - ($elm$core$Basics$pi / 2);
		var cw = _Utils_cmp(a1, a0) > 0;
		var da = $elm$core$Basics$abs(a1 - a0);
		if (_Utils_cmp(da, (2 * $elm$core$Basics$pi) - $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) {
			var p = A7(
				$gampleman$elm_visualization$Shape$Pie$makeArc,
				0,
				0,
				r1,
				a0,
				a1,
				!cw,
				A2(
					$folkertdev$one_true_path_experiment$SubPath$with,
					$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
						_Utils_Tuple2(
							r1 * $elm$core$Basics$cos(a0),
							r1 * $elm$core$Basics$sin(a0))),
					_List_Nil));
			return (_Utils_cmp(r0, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) ? _List_fromArray(
				[
					p,
					$folkertdev$one_true_path_experiment$SubPath$close(
					A7(
						$gampleman$elm_visualization$Shape$Pie$makeArc,
						0,
						0,
						r0,
						a1,
						a0,
						cw,
						A2(
							$folkertdev$one_true_path_experiment$SubPath$with,
							$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
								_Utils_Tuple2(
									r0 * $elm$core$Basics$cos(a1),
									r0 * $elm$core$Basics$sin(a1))),
							_List_Nil)))
				]) : _List_fromArray(
				[
					$folkertdev$one_true_path_experiment$SubPath$close(p)
				]);
		} else {
			var rc = A2(
				$elm$core$Basics$min,
				$elm$core$Basics$abs(r1 - r0) / 2,
				arcData.k2);
			var ap = arcData.mF / 2;
			var rp = (_Utils_cmp(ap, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) ? ((arcData.mG > 0) ? arcData.mG : $elm$core$Basics$sqrt(
				A2($elm$core$Basics$pow, r0, 2) + A2($elm$core$Basics$pow, r1, 2))) : 0;
			var _v1 = function () {
				if (_Utils_cmp(rp, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) {
					var p1 = $gampleman$elm_visualization$Shape$Pie$myAsin(
						(rp / r1) * $elm$core$Basics$sin(ap));
					return (_Utils_cmp(da - (p1 * 2), $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) ? (cw ? _Utils_Tuple3(a0 + p1, a1 - p1, da - (p1 * 2)) : _Utils_Tuple3(a0 - p1, a1 + p1, da - (p1 * 2))) : _Utils_Tuple3((a0 + a1) / 2, (a0 + a1) / 2, 0);
				} else {
					return _Utils_Tuple3(a0, a1, da);
				}
			}();
			var a01 = _v1.a;
			var a11 = _v1.b;
			var da1 = _v1.c;
			var x01 = r1 * $elm$core$Basics$cos(a01);
			var y01 = r1 * $elm$core$Basics$sin(a01);
			var x11 = r1 * $elm$core$Basics$cos(a11);
			var y11 = r1 * $elm$core$Basics$sin(a11);
			var _v2 = function () {
				if (_Utils_cmp(rp, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) {
					var p0 = $gampleman$elm_visualization$Shape$Pie$myAsin(
						(rp / r0) * $elm$core$Basics$sin(ap));
					return (_Utils_cmp(da - (p0 * 2), $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) ? (cw ? _Utils_Tuple3(a0 + p0, a1 - p0, da - (p0 * 2)) : _Utils_Tuple3(a0 - p0, a1 + p0, da - (p0 * 2))) : _Utils_Tuple3((a0 + a1) / 2, (a0 + a1) / 2, 0);
				} else {
					return _Utils_Tuple3(a0, a1, da);
				}
			}();
			var a00 = _v2.a;
			var a10 = _v2.b;
			var da0 = _v2.c;
			var x00 = r0 * $elm$core$Basics$cos(a00);
			var y00 = r0 * $elm$core$Basics$sin(a00);
			var x10 = r0 * $elm$core$Basics$cos(a10);
			var y10 = r0 * $elm$core$Basics$sin(a10);
			var _v3 = (_Utils_cmp(da0, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) ? A8($gampleman$elm_visualization$Shape$Pie$intersect, x01, y01, x00, y00, x11, y11, x10, y10) : _Utils_Tuple2(x10, y10);
			var ocx = _v3.a;
			var ocy = _v3.b;
			var _v4 = _Utils_Tuple2(x11 - ocx, y11 - ocy);
			var bx = _v4.a;
			var by = _v4.b;
			var _v5 = _Utils_Tuple2(x01 - ocx, y01 - ocy);
			var ax = _v5.a;
			var ay = _v5.b;
			var _v6 = function () {
				if ((_Utils_cmp(rc, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) && (_Utils_cmp(da, $elm$core$Basics$pi) < 0)) {
					var lc = $elm$core$Basics$sqrt(
						A2($elm$core$Basics$pow, ocx, 2) + A2($elm$core$Basics$pow, ocy, 2));
					var kc = 1 / $elm$core$Basics$sin(
						$elm$core$Basics$acos(
							((ax * bx) + (ay * by)) / ($elm$core$Basics$sqrt(
								A2($elm$core$Basics$pow, ax, 2) + A2($elm$core$Basics$pow, ay, 2)) * $elm$core$Basics$sqrt(
								A2($elm$core$Basics$pow, bx, 2) + A2($elm$core$Basics$pow, by, 2)))) / 2);
					return _Utils_Tuple2(
						A2($elm$core$Basics$min, rc, (r0 - lc) / (kc - 1)),
						A2($elm$core$Basics$min, rc, (r1 - lc) / (kc + 1)));
				} else {
					return _Utils_Tuple2(rc, rc);
				}
			}();
			var rc0 = _v6.a;
			var rc1 = _v6.b;
			var outerRing = function () {
				if (_Utils_cmp(da1, $gampleman$elm_visualization$Shape$Pie$epsilon) < 1) {
					return A2(
						$folkertdev$one_true_path_experiment$SubPath$with,
						$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
							_Utils_Tuple2(x01, y01)),
						_List_Nil);
				} else {
					if (_Utils_cmp(rc1, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) {
						var t1 = A7($gampleman$elm_visualization$Shape$Pie$cornerTangents, x11, y11, x10, y10, r1, rc1, cw);
						var t0 = A7($gampleman$elm_visualization$Shape$Pie$cornerTangents, x00, y00, x01, y01, r1, rc1, cw);
						var p = A2(
							$folkertdev$one_true_path_experiment$SubPath$with,
							$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
								_Utils_Tuple2(t0.aa + t0.aA, t0.ab + t0.aB)),
							_List_Nil);
						return (_Utils_cmp(rc1, rc) < 0) ? A7(
							$gampleman$elm_visualization$Shape$Pie$makeArc,
							t0.aa,
							t0.ab,
							rc1,
							A2($elm$core$Basics$atan2, t0.aB, t0.aA),
							A2($elm$core$Basics$atan2, t1.aB, t1.aA),
							!cw,
							p) : A7(
							$gampleman$elm_visualization$Shape$Pie$makeArc,
							t1.aa,
							t1.ab,
							rc1,
							A2($elm$core$Basics$atan2, t1.a6, t1.a4),
							A2($elm$core$Basics$atan2, t1.aB, t1.aA),
							!cw,
							A7(
								$gampleman$elm_visualization$Shape$Pie$makeArc,
								0,
								0,
								r1,
								A2($elm$core$Basics$atan2, t0.ab + t0.a6, t0.aa + t0.a4),
								A2($elm$core$Basics$atan2, t1.ab + t1.a6, t1.aa + t1.a4),
								!cw,
								A7(
									$gampleman$elm_visualization$Shape$Pie$makeArc,
									t0.aa,
									t0.ab,
									rc1,
									A2($elm$core$Basics$atan2, t0.aB, t0.aA),
									A2($elm$core$Basics$atan2, t0.a6, t0.a4),
									!cw,
									p)));
					} else {
						return A7(
							$gampleman$elm_visualization$Shape$Pie$makeArc,
							0,
							0,
							r1,
							a01,
							a11,
							!cw,
							A2(
								$folkertdev$one_true_path_experiment$SubPath$with,
								$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
									_Utils_Tuple2(x01, y01)),
								_List_Nil));
					}
				}
			}();
			if ((_Utils_cmp(r0, $gampleman$elm_visualization$Shape$Pie$epsilon) < 1) || (_Utils_cmp(da0, $gampleman$elm_visualization$Shape$Pie$epsilon) < 1)) {
				return _List_fromArray(
					[
						$folkertdev$one_true_path_experiment$SubPath$close(
						A2(
							$folkertdev$one_true_path_experiment$SubPath$connect,
							A2(
								$folkertdev$one_true_path_experiment$SubPath$with,
								$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
									_Utils_Tuple2(x10, y10)),
								_List_Nil),
							outerRing))
					]);
			} else {
				if (_Utils_cmp(rc0, $gampleman$elm_visualization$Shape$Pie$epsilon) > 0) {
					var t1 = A7($gampleman$elm_visualization$Shape$Pie$cornerTangents, x01, y01, x00, y00, r0, -rc0, cw);
					var t0 = A7($gampleman$elm_visualization$Shape$Pie$cornerTangents, x10, y10, x11, y11, r0, -rc0, cw);
					var p = A2(
						$folkertdev$one_true_path_experiment$SubPath$connect,
						A2(
							$folkertdev$one_true_path_experiment$SubPath$with,
							$folkertdev$one_true_path_experiment$LowLevel$Command$moveTo(
								_Utils_Tuple2(t0.aa + t0.aA, t0.ab + t0.aB)),
							_List_Nil),
						outerRing);
					return (_Utils_cmp(rc0, rc) < 0) ? _List_fromArray(
						[
							$folkertdev$one_true_path_experiment$SubPath$close(
							A7(
								$gampleman$elm_visualization$Shape$Pie$makeArc,
								t0.aa,
								t0.ab,
								rc0,
								A2($elm$core$Basics$atan2, t0.aB, t0.aA),
								A2($elm$core$Basics$atan2, t1.aB, t1.aA),
								!cw,
								p))
						]) : _List_fromArray(
						[
							$folkertdev$one_true_path_experiment$SubPath$close(
							A7(
								$gampleman$elm_visualization$Shape$Pie$makeArc,
								t1.aa,
								t1.ab,
								rc0,
								A2($elm$core$Basics$atan2, t1.a6, t1.a4),
								A2($elm$core$Basics$atan2, t1.aB, t1.aA),
								!cw,
								A7(
									$gampleman$elm_visualization$Shape$Pie$makeArc,
									0,
									0,
									r0,
									A2($elm$core$Basics$atan2, t0.ab + t0.a6, t0.aa + t0.a4),
									A2($elm$core$Basics$atan2, t1.ab + t1.a6, t1.aa + t1.a4),
									cw,
									A7(
										$gampleman$elm_visualization$Shape$Pie$makeArc,
										t0.aa,
										t0.ab,
										rc0,
										A2($elm$core$Basics$atan2, t0.aB, t0.aA),
										A2($elm$core$Basics$atan2, t0.a6, t0.a4),
										!cw,
										p))))
						]);
				} else {
					return _List_fromArray(
						[
							$folkertdev$one_true_path_experiment$SubPath$close(
							A2(
								$folkertdev$one_true_path_experiment$SubPath$connect,
								A6($gampleman$elm_visualization$Shape$Pie$arc_, 0, 0, r0, a10, a00, cw),
								outerRing))
						]);
				}
			}
		}
	}
};
var $gampleman$elm_visualization$Shape$arc = $gampleman$elm_visualization$Shape$Pie$arc;
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $folkertdev$elm_deque$Deque$empty = $folkertdev$elm_deque$Internal$empty;
var $folkertdev$one_true_path_experiment$LowLevel$Command$merge = F2(
	function (instruction1, instruction2) {
		var _v0 = _Utils_Tuple2(instruction1, instruction2);
		_v0$5:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.b.$) {
						var p1 = _v0.a.a;
						var p2 = _v0.b.a;
						return $elm$core$Result$Ok(
							$folkertdev$one_true_path_experiment$LowLevel$Command$LineTo(
								_Utils_ap(p1, p2)));
					} else {
						break _v0$5;
					}
				case 1:
					if (_v0.b.$ === 1) {
						var p1 = _v0.a.a;
						var p2 = _v0.b.a;
						return $elm$core$Result$Ok(
							$folkertdev$one_true_path_experiment$LowLevel$Command$CurveTo(
								_Utils_ap(p1, p2)));
					} else {
						break _v0$5;
					}
				case 2:
					if (_v0.b.$ === 2) {
						var p1 = _v0.a.a;
						var p2 = _v0.b.a;
						return $elm$core$Result$Ok(
							$folkertdev$one_true_path_experiment$LowLevel$Command$QuadraticBezierCurveTo(
								_Utils_ap(p1, p2)));
					} else {
						break _v0$5;
					}
				case 3:
					if (_v0.b.$ === 3) {
						var p1 = _v0.a.a;
						var p2 = _v0.b.a;
						return $elm$core$Result$Ok(
							$folkertdev$one_true_path_experiment$LowLevel$Command$EllipticalArc(
								_Utils_ap(p1, p2)));
					} else {
						break _v0$5;
					}
				default:
					if (_v0.b.$ === 4) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return $elm$core$Result$Ok($folkertdev$one_true_path_experiment$LowLevel$Command$ClosePath);
					} else {
						break _v0$5;
					}
			}
		}
		return $elm$core$Result$Err(
			_Utils_Tuple2(instruction1, instruction2));
	});
var $folkertdev$elm_deque$Internal$toList = function (deque) {
	return _Utils_ap(
		deque.ap,
		$elm$core$List$reverse(deque.ar));
};
var $folkertdev$elm_deque$Deque$toList = A2($elm$core$Basics$composeL, $folkertdev$elm_deque$Internal$toList, $folkertdev$elm_deque$Deque$unwrap);
var $folkertdev$one_true_path_experiment$SubPath$compressHelper = function (drawtos) {
	var folder = F2(
		function (instruction, _v3) {
			var previous = _v3.a;
			var accum = _v3.b;
			var _v2 = A2($folkertdev$one_true_path_experiment$LowLevel$Command$merge, previous, instruction);
			if (!_v2.$) {
				var merged = _v2.a;
				return _Utils_Tuple2(merged, accum);
			} else {
				return _Utils_Tuple2(
					instruction,
					A2($elm$core$List$cons, previous, accum));
			}
		});
	var _v0 = $folkertdev$elm_deque$Deque$toList(drawtos);
	if (!_v0.b) {
		return $folkertdev$elm_deque$Deque$empty;
	} else {
		var first = _v0.a;
		var rest = _v0.b;
		return $folkertdev$elm_deque$Deque$fromList(
			$elm$core$List$reverse(
				function (_v1) {
					var a = _v1.a;
					var b = _v1.b;
					return A2($elm$core$List$cons, a, b);
				}(
					A3(
						$elm$core$List$foldl,
						folder,
						_Utils_Tuple2(first, _List_Nil),
						rest))));
	}
};
var $folkertdev$one_true_path_experiment$SubPath$compress = function (subpath) {
	if (subpath.$ === 1) {
		return $folkertdev$one_true_path_experiment$SubPath$Empty;
	} else {
		var data = subpath.a;
		return $folkertdev$one_true_path_experiment$SubPath$SubPath(
			_Utils_update(
				data,
				{
					hQ: $folkertdev$one_true_path_experiment$SubPath$compressHelper(data.hQ)
				}));
	}
};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$DecimalPlaces = $elm$core$Basics$identity;
var $folkertdev$svg_path_lowlevel$Path$LowLevel$decimalPlaces = $elm$core$Basics$identity;
var $folkertdev$one_true_path_experiment$SubPath$defaultConfig = {dF: $elm$core$Maybe$Nothing, d4: false};
var $folkertdev$one_true_path_experiment$SubPath$optionFolder = F2(
	function (option, config) {
		if (!option.$) {
			var n = option.a;
			return _Utils_update(
				config,
				{
					dF: $elm$core$Maybe$Just(n)
				});
		} else {
			return _Utils_update(
				config,
				{d4: true});
		}
	});
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$Absolute = 1;
var $folkertdev$svg_path_lowlevel$Path$LowLevel$ClosePath = {$: 8};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$CurveTo = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$EllipticalArc = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$LineTo = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$QuadraticBezierCurveTo = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $folkertdev$one_true_path_experiment$LowLevel$Command$toLowLevelDrawTo = function (drawto) {
	switch (drawto.$) {
		case 0:
			var coordinates = drawto.a;
			return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$LineTo, 1, coordinates);
		case 1:
			var coordinates = drawto.a;
			return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$CurveTo, 1, coordinates);
		case 2:
			var coordinates = drawto.a;
			return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$QuadraticBezierCurveTo, 1, coordinates);
		case 3:
			var _arguments = drawto.a;
			return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$EllipticalArc, 1, _arguments);
		default:
			return $folkertdev$svg_path_lowlevel$Path$LowLevel$ClosePath;
	}
};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$MoveTo = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $folkertdev$one_true_path_experiment$LowLevel$Command$toLowLevelMoveTo = function (_v0) {
	var target = _v0;
	return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$MoveTo, 1, target);
};
var $folkertdev$one_true_path_experiment$SubPath$toLowLevel = function (subpath) {
	if (subpath.$ === 1) {
		return $elm$core$Maybe$Nothing;
	} else {
		var moveto = subpath.a.iP;
		var drawtos = subpath.a.hQ;
		return $elm$core$Maybe$Just(
			{
				hQ: A2(
					$elm$core$List$map,
					$folkertdev$one_true_path_experiment$LowLevel$Command$toLowLevelDrawTo,
					$folkertdev$elm_deque$Deque$toList(drawtos)),
				iP: $folkertdev$one_true_path_experiment$LowLevel$Command$toLowLevelMoveTo(moveto)
			});
	}
};
var $elm$core$String$fromFloat = _String_fromNumber;
var $folkertdev$svg_path_lowlevel$Path$LowLevel$defaultConfig = {cW: $elm$core$String$fromFloat};
var $elm$core$Basics$round = _Basics_round;
var $folkertdev$svg_path_lowlevel$Path$LowLevel$roundTo = F2(
	function (n, value) {
		if (!n) {
			return $elm$core$String$fromInt(
				$elm$core$Basics$round(value));
		} else {
			var sign = (value < 0.0) ? '-' : '';
			var exp = A2($elm$core$Basics$pow, 10, n);
			var raised = $elm$core$Basics$abs(
				$elm$core$Basics$round(value * exp));
			var decimals = raised % exp;
			return (!decimals) ? _Utils_ap(
				sign,
				$elm$core$String$fromInt((raised / exp) | 0)) : (sign + ($elm$core$String$fromInt((raised / exp) | 0) + ('.' + $elm$core$String$fromInt(decimals))));
		}
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$optionFolder = F2(
	function (option, config) {
		var n = option;
		return _Utils_update(
			config,
			{
				cW: $folkertdev$svg_path_lowlevel$Path$LowLevel$roundTo(n)
			});
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$accumulateOptions = A2($elm$core$List$foldl, $folkertdev$svg_path_lowlevel$Path$LowLevel$optionFolder, $folkertdev$svg_path_lowlevel$Path$LowLevel$defaultConfig);
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$isEmpty = function (command) {
	switch (command.$) {
		case 0:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 1:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 2:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 3:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 4:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 5:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 6:
			var mode = command.a;
			var coordinates = command.b;
			return $elm$core$List$isEmpty(coordinates);
		case 7:
			var mode = command.a;
			var _arguments = command.b;
			return $elm$core$List$isEmpty(_arguments);
		default:
			return false;
	}
};
var $elm$core$Char$toLower = _Char_toLower;
var $elm$core$Char$toUpper = _Char_toUpper;
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter = F2(
	function (mode, character) {
		if (mode === 1) {
			return $elm$core$String$fromChar(
				$elm$core$Char$toUpper(character));
		} else {
			return $elm$core$String$fromChar(
				$elm$core$Char$toLower(character));
		}
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate = F2(
	function (config, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return config.cW(x) + (',' + config.cW(y));
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate2 = F2(
	function (config, _v0) {
		var c1 = _v0.a;
		var c2 = _v0.b;
		return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c1) + (' ' + A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c2));
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate3 = F2(
	function (config, _v0) {
		var c1 = _v0.a;
		var c2 = _v0.b;
		var c3 = _v0.c;
		return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c1) + (' ' + (A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c2) + (' ' + A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, c3))));
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$encodeFlags = function (_v0) {
	var arcFlag = _v0.a;
	var direction = _v0.b;
	var _v1 = _Utils_Tuple2(arcFlag, direction);
	if (_v1.a === 1) {
		if (!_v1.b) {
			var _v2 = _v1.a;
			var _v3 = _v1.b;
			return _Utils_Tuple2(1, 0);
		} else {
			var _v6 = _v1.a;
			var _v7 = _v1.b;
			return _Utils_Tuple2(1, 1);
		}
	} else {
		if (!_v1.b) {
			var _v4 = _v1.a;
			var _v5 = _v1.b;
			return _Utils_Tuple2(0, 0);
		} else {
			var _v8 = _v1.a;
			var _v9 = _v1.b;
			return _Utils_Tuple2(0, 1);
		}
	}
};
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyEllipticalArcArgument = F2(
	function (config, _v0) {
		var radii = _v0.bl;
		var xAxisRotate = _v0.a5;
		var arcFlag = _v0.eL;
		var direction = _v0.e6;
		var target = _v0.gQ;
		var _v1 = $folkertdev$svg_path_lowlevel$Path$LowLevel$encodeFlags(
			_Utils_Tuple2(arcFlag, direction));
		var arc = _v1.a;
		var sweep = _v1.b;
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, radii),
					$elm$core$String$fromFloat(xAxisRotate),
					$elm$core$String$fromInt(arc),
					$elm$core$String$fromInt(sweep),
					A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, target)
				]));
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyDrawTo = F2(
	function (config, command) {
		if ($folkertdev$svg_path_lowlevel$Path$LowLevel$isEmpty(command)) {
			return '';
		} else {
			switch (command.$) {
				case 0:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'L'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate(config),
								coordinates)));
				case 1:
					var mode = command.a;
					var coordinates = command.b;
					return $elm$core$List$isEmpty(coordinates) ? '' : _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'H'),
						A2(
							$elm$core$String$join,
							' ',
							A2($elm$core$List$map, $elm$core$String$fromFloat, coordinates)));
				case 2:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'V'),
						A2(
							$elm$core$String$join,
							' ',
							A2($elm$core$List$map, $elm$core$String$fromFloat, coordinates)));
				case 3:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'C'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate3(config),
								coordinates)));
				case 4:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'S'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate2(config),
								coordinates)));
				case 5:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'Q'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate2(config),
								coordinates)));
				case 6:
					var mode = command.a;
					var coordinates = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'T'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate(config),
								coordinates)));
				case 7:
					var mode = command.a;
					var _arguments = command.b;
					return _Utils_ap(
						A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCharacter, mode, 'A'),
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyEllipticalArcArgument(config),
								_arguments)));
				default:
					return 'Z';
			}
		}
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyMoveTo = F2(
	function (config, _v0) {
		var mode = _v0.a;
		var coordinate = _v0.b;
		if (mode === 1) {
			return 'M' + A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, coordinate);
		} else {
			return 'm' + A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyCoordinate, config, coordinate);
		}
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$toStringSubPath = F2(
	function (config, _v0) {
		var moveto = _v0.iP;
		var drawtos = _v0.hQ;
		return A2($folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyMoveTo, config, moveto) + (' ' + A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$folkertdev$svg_path_lowlevel$Path$LowLevel$stringifyDrawTo(config),
				drawtos)));
	});
var $folkertdev$svg_path_lowlevel$Path$LowLevel$toStringWith = F2(
	function (options, subpaths) {
		var config = $folkertdev$svg_path_lowlevel$Path$LowLevel$accumulateOptions(options);
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$folkertdev$svg_path_lowlevel$Path$LowLevel$toStringSubPath(config),
				subpaths));
	});
var $folkertdev$one_true_path_experiment$SubPath$toStringWith = F2(
	function (options, subpath) {
		var config = A3($elm$core$List$foldl, $folkertdev$one_true_path_experiment$SubPath$optionFolder, $folkertdev$one_true_path_experiment$SubPath$defaultConfig, options);
		var lowLevelOptions = function () {
			var _v0 = config.dF;
			if (_v0.$ === 1) {
				return _List_Nil;
			} else {
				var n = _v0.a;
				return _List_fromArray(
					[
						$folkertdev$svg_path_lowlevel$Path$LowLevel$decimalPlaces(n)
					]);
			}
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					$folkertdev$svg_path_lowlevel$Path$LowLevel$toStringWith(lowLevelOptions),
					$elm$core$List$singleton),
				$folkertdev$one_true_path_experiment$SubPath$toLowLevel(
					(config.d4 ? $folkertdev$one_true_path_experiment$SubPath$compress : $elm$core$Basics$identity)(subpath))));
	});
var $folkertdev$one_true_path_experiment$SubPath$toString = function (subpath) {
	return A2($folkertdev$one_true_path_experiment$SubPath$toStringWith, _List_Nil, subpath);
};
var $folkertdev$one_true_path_experiment$Path$toString = A2(
	$elm$core$Basics$composeL,
	$elm$core$String$join(' '),
	$elm$core$List$map($folkertdev$one_true_path_experiment$SubPath$toString));
var $folkertdev$one_true_path_experiment$Path$element = F2(
	function (path, attributes) {
		return A2(
			$elm$svg$Svg$path,
			A2(
				$elm$core$List$cons,
				$elm$svg$Svg$Attributes$d(
					$folkertdev$one_true_path_experiment$Path$toString(path)),
				attributes),
			_List_Nil);
	});
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $avh4$elm_color$Color$toCssString = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var roundTo = function (x) {
		return $elm$core$Basics$round(x * 1000) / 1000;
	};
	var pct = function (x) {
		return $elm$core$Basics$round(x * 10000) / 100;
	};
	return $elm$core$String$concat(
		_List_fromArray(
			[
				'rgba(',
				$elm$core$String$fromFloat(
				pct(r)),
				'%,',
				$elm$core$String$fromFloat(
				pct(g)),
				'%,',
				$elm$core$String$fromFloat(
				pct(b)),
				'%,',
				$elm$core$String$fromFloat(
				roundTo(a)),
				')'
			]));
};
var $elm_community$typed_svg$TypedSvg$TypesToStrings$paintToString = function (paint) {
	switch (paint.$) {
		case 0:
			var color = paint.a;
			return $avh4$elm_color$Color$toCssString(color);
		case 1:
			var string = paint.a;
			return $elm$core$String$concat(
				_List_fromArray(
					['var(' + (string + ')')]));
		case 2:
			var string = paint.a;
			return $elm$core$String$concat(
				_List_fromArray(
					['url(#', string, ')']));
		case 3:
			return 'context-fill';
		case 4:
			return 'context-stroke';
		default:
			return 'none';
	}
};
var $elm_community$typed_svg$TypedSvg$Attributes$fill = A2(
	$elm$core$Basics$composeL,
	$elm_community$typed_svg$TypedSvg$Core$attribute('fill'),
	$elm_community$typed_svg$TypedSvg$TypesToStrings$paintToString);
var $elm$virtual_dom$VirtualDom$nodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_nodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm_community$typed_svg$TypedSvg$Core$node = $elm$virtual_dom$VirtualDom$nodeNS('http://www.w3.org/2000/svg');
var $elm_community$typed_svg$TypedSvg$g = $elm_community$typed_svg$TypedSvg$Core$node('g');
var $elm_community$typed_svg$TypedSvg$TypesToStrings$transformToString = function (xform) {
	var tr = F2(
		function (name, args) {
			return $elm$core$String$concat(
				_List_fromArray(
					[
						name,
						'(',
						A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, $elm$core$String$fromFloat, args)),
						')'
					]));
		});
	switch (xform.$) {
		case 0:
			var a = xform.a;
			var b = xform.b;
			var c = xform.c;
			var d = xform.d;
			var e = xform.e;
			var f = xform.f;
			return A2(
				tr,
				'matrix',
				_List_fromArray(
					[a, b, c, d, e, f]));
		case 1:
			var a = xform.a;
			var x = xform.b;
			var y = xform.c;
			return A2(
				tr,
				'rotate',
				_List_fromArray(
					[a, x, y]));
		case 2:
			var x = xform.a;
			var y = xform.b;
			return A2(
				tr,
				'scale',
				_List_fromArray(
					[x, y]));
		case 3:
			var x = xform.a;
			return A2(
				tr,
				'skewX',
				_List_fromArray(
					[x]));
		case 4:
			var y = xform.a;
			return A2(
				tr,
				'skewY',
				_List_fromArray(
					[y]));
		default:
			var x = xform.a;
			var y = xform.b;
			return A2(
				tr,
				'translate',
				_List_fromArray(
					[x, y]));
	}
};
var $elm_community$typed_svg$TypedSvg$Attributes$transform = function (transforms) {
	return A2(
		$elm_community$typed_svg$TypedSvg$Core$attribute,
		'transform',
		A2(
			$elm$core$String$join,
			' ',
			A2($elm$core$List$map, $elm_community$typed_svg$TypedSvg$TypesToStrings$transformToString, transforms)));
};
var $author$project$Models$Ring$makeRing = F3(
	function (isFull, color, a) {
		var arc = {
			k2: 1,
			lt: (isFull ? 1 : a.aL) * 6.28319,
			lZ: a.cm - 2,
			cm: a.cm,
			mF: 0.03,
			mG: 0.1,
			nF: 0
		};
		var slice = A2(
			$folkertdev$one_true_path_experiment$Path$element,
			$gampleman$elm_visualization$Shape$arc(arc),
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$fill(
					$elm_community$typed_svg$TypedSvg$Types$Paint(color))
				]));
		return A2(
			$elm_community$typed_svg$TypedSvg$g,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$transform(
					_List_fromArray(
						[
							A2($elm_community$typed_svg$TypedSvg$Types$Translate, 10, 10)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$typed_svg$TypedSvg$g,
					_List_Nil,
					_List_fromArray(
						[slice]))
				]));
	});
var $author$project$Models$Ring$ringWithBg = function (a) {
	return _List_fromArray(
		[
			A3($author$project$Models$Ring$makeRing, false, a.dL, a),
			A3($author$project$Models$Ring$makeRing, true, a.dv, a)
		]);
};
var $elm_community$typed_svg$TypedSvg$svg = $elm_community$typed_svg$TypedSvg$Core$node('svg');
var $elm_community$typed_svg$TypedSvg$Attributes$viewBox = F4(
	function (minX, minY, vWidth, vHeight) {
		return A2(
			$elm_community$typed_svg$TypedSvg$Core$attribute,
			'viewBox',
			A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$map,
					$elm$core$String$fromFloat,
					_List_fromArray(
						[minX, minY, vWidth, vHeight]))));
	});
var $author$project$Models$Ring$w = 20;
var $author$project$Models$Ring$makeOne = F2(
	function (classes, _v0) {
		var sA = _v0.a;
		var wA = _v0.b;
		return A2(
			$elm_community$typed_svg$TypedSvg$svg,
			_List_fromArray(
				[
					$elm_community$typed_svg$TypedSvg$Attributes$class(classes),
					A4($elm_community$typed_svg$TypedSvg$Attributes$viewBox, 0, 0, $author$project$Models$Ring$w, $author$project$Models$Ring$h)
				]),
			$elm$core$List$concat(
				A2(
					$elm$core$List$map,
					$author$project$Models$Ring$ringWithBg,
					_List_fromArray(
						[sA, wA]))));
	});
var $author$project$Models$Ring$makeFrames = F3(
	function (classes, maybeBefore, current) {
		if (!maybeBefore.$) {
			var b = maybeBefore.a;
			return _Utils_eq(b, current) ? _List_fromArray(
				[
					A2(
					$author$project$Models$Ring$makeOne,
					classes,
					A2($author$project$Models$Ring$countsToAnnularPair, classes, current))
				]) : A2(
				$elm$core$List$map,
				$author$project$Models$Ring$makeOne(classes),
				A2(
					$author$project$Models$Ring$interPolateAnnularPair,
					A2($author$project$Models$Ring$countsToAnnularPair, classes, b),
					A2($author$project$Models$Ring$countsToAnnularPair, classes, current)));
		} else {
			return A2(
				$elm$core$List$map,
				$author$project$Models$Ring$makeOne(classes),
				$author$project$Models$Ring$interPolateAnnularPairFromZero(
					A2($author$project$Models$Ring$countsToAnnularPair, classes, current)));
		}
	});
var $author$project$App$Ring$Model$init = F2(
	function (classes, counts) {
		return {
			eT: $elm$core$Maybe$Nothing,
			eZ: classes,
			cL: counts,
			b9: 0,
			dO: A3($author$project$Models$Ring$makeFrames, classes, $elm$core$Maybe$Nothing, counts)
		};
	});
var $author$project$App$Auth$Model$LoggedIn = {$: 1};
var $author$project$App$Auth$Model$isLoggedIn = function (_v0) {
	var status = _v0.gN;
	return _Utils_eq(status, $author$project$App$Auth$Model$LoggedIn);
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$Route$Home = 0;
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {bB: frag, bL: params, br: unvisited, ke: value, bV: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.br;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.ke);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.ke);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.i6),
					$elm$url$Url$Parser$prepareQuery(url.jg),
					url.h3,
					$elm$core$Basics$identity)));
	});
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.bV;
		var unvisited = _v0.br;
		var params = _v0.bL;
		var frag = _v0.bB;
		var value = _v0.ke;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.bV;
			var unvisited = _v1.br;
			var params = _v1.bL;
			var frag = _v1.bB;
			var value = _v1.ke;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.bV;
		var unvisited = _v0.br;
		var params = _v0.bL;
		var frag = _v0.bB;
		var value = _v0.ke;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Route$parser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, 0, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			1,
			$elm$url$Url$Parser$s('dashboard')),
			A2(
			$elm$url$Url$Parser$map,
			3,
			$elm$url$Url$Parser$s('login')),
			A2(
			$elm$url$Url$Parser$map,
			2,
			$elm$url$Url$Parser$s('getstarted'))
		]));
var $author$project$Route$parse = function (url) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2($elm$url$Url$Parser$parse, $author$project$Route$parser, url));
};
var $author$project$App$SentenceCore$Update$highlightIsDifferent = F2(
	function (modelBefore, modelAfter) {
		return !_Utils_eq(modelBefore.h9, modelAfter.h9);
	});
var $author$project$App$Update$lookUpForSentenceCore = F2(
	function (model, _v0) {
		var searchWords = _v0.jD;
		var joinedSTs = A2(
			$elm$core$Maybe$map,
			$elm$core$String$join(' ;'),
			searchWords);
		var unifyLookup = function (st) {
			return A4($author$project$App$Update$lookup, model, joinedSTs, st, false);
		};
		return $elm$core$Platform$Cmd$batch(
			A2(
				$elm$core$List$map,
				unifyLookup,
				A2($elm$core$Maybe$withDefault, _List_Nil, searchWords)));
	});
var $author$project$App$Update$reviewOtherCmds = F4(
	function (model, msg, modelBefore, modelAfter) {
		_v0$2:
		while (true) {
			switch (msg.$) {
				case 3:
					var t = msg.a;
					return A4(
						$author$project$App$Update$lookup,
						model,
						$elm$core$Maybe$Just(t),
						t,
						false);
				case 6:
					if (!msg.b.$) {
						var id = msg.a;
						var _v1 = _Utils_Tuple2(
							A2($elm$core$Dict$get, id, modelBefore.nu),
							A2($elm$core$Dict$get, id, modelAfter.nu));
						var mSB = _v1.a;
						var mSA = _v1.b;
						var isDifferent = function () {
							var _v2 = _Utils_Tuple2(mSB, mSA);
							if ((!_v2.a.$) && (!_v2.b.$)) {
								var sB = _v2.a.a;
								var sA = _v2.b.a;
								return A2($author$project$App$SentenceCore$Update$highlightIsDifferent, sB, sA);
							} else {
								return false;
							}
						}();
						return isDifferent ? A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$Maybe$map,
								$author$project$App$Update$lookUpForSentenceCore(model),
								mSA)) : $elm$core$Platform$Cmd$none;
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return $elm$core$Platform$Cmd$none;
	});
var $author$project$App$Update$sentenceOtherCmds = F4(
	function (model, msg, modelBefore, modelAfter) {
		var isDifferent = function () {
			var _v1 = _Utils_Tuple2(modelBefore.jV, modelAfter.jV);
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var sB = _v1.a.a;
				var sA = _v1.b.a;
				return A2($author$project$App$SentenceCore$Update$highlightIsDifferent, sB, sA);
			} else {
				return false;
			}
		}();
		var _v0 = _Utils_Tuple2(msg, isDifferent);
		if (((_v0.a.$ === 2) && (!_v0.a.a.$)) && _v0.b) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Cmd$none,
				A2(
					$elm$core$Maybe$map,
					$author$project$App$Update$lookUpForSentenceCore(model),
					modelAfter.jV));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.jf;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.h3,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.jg,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.ja,
					_Utils_ap(http, url.ib)),
				url.i6)));
};
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $author$project$App$Activity$Update$getNavDates = F2(
	function (rings, currentDate) {
		var ordered = $elm$core$List$reverse(
			$elm$core$List$sort(
				$elm$core$Dict$keys(rings)));
		return _Utils_Tuple2(
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (d) {
						return _Utils_cmp(d, currentDate) < 0;
					},
					ordered)),
			$elm$core$List$head(
				$elm$core$List$reverse(
					A2(
						$elm$core$List$filter,
						function (d) {
							return _Utils_cmp(d, currentDate) > 0;
						},
						ordered))));
	});
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$App$Activity$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var summary = msg.a.a.nO;
					var rings = $elm$core$Dict$fromList(
						A2(
							$elm$core$List$map,
							function (d) {
								return _Utils_Tuple2(
									d.dE,
									_Utils_Tuple2(
										d,
										A2($author$project$App$Ring$Model$init, _List_Nil, d)));
							},
							summary));
					var currentDate = $elm$core$List$maximum(
						$elm$core$Dict$keys(rings));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hJ: currentDate,
								iR: A2(
									$elm$core$Maybe$withDefault,
									_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
									A2(
										$elm$core$Maybe$map,
										$author$project$App$Activity$Update$getNavDates(rings),
										currentDate)),
								js: rings
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 1:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 2:
				var d = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hJ: $elm$core$Maybe$Just(d),
							iR: A2($author$project$App$Activity$Update$getNavDates, model.js, d)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$App$AppBar$Messages$SearchBarMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$App$AppBar$Model$Home = 0;
var $author$project$App$AppBar$SearchBar$Model$Idle = {$: 0};
var $author$project$App$AppBar$SearchBar$Model$init = {fz: $elm$core$Maybe$Nothing, iI: false, jB: $elm$core$Maybe$Nothing, gC: '', gN: $author$project$App$AppBar$SearchBar$Model$Idle, jP: _List_Nil, jQ: 0};
var $author$project$App$AppBar$Model$init = {hR: false, io: $elm$core$Dict$empty, iH: false, iS: 0, jr: $elm$core$Maybe$Nothing, jA: $author$project$App$AppBar$SearchBar$Model$init, kd: $elm$core$Maybe$Nothing};
var $author$project$App$AppBar$SearchBar$Messages$GotFocus = function (a) {
	return {$: 6, a: a};
};
var $author$project$App$AppBar$SearchBar$Model$LoadingSearch = {$: 1};
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$App$AppBar$SearchBar$Messages$GotSuggestions = function (a) {
	return {$: 5, a: a};
};
var $author$project$Models$Search$SuggestionsResp = F2(
	function (count, suggestions) {
		return {k3: count, jP: suggestions};
	});
var $author$project$Models$Search$Suggestion = F3(
	function (word, pos, langs) {
		return {ix: langs, mO: pos, kl: word};
	});
var $author$project$Decoders$suggestionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'langs',
	$author$project$Decoders$strings,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'pos',
		$author$project$Decoders$strings,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'word',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Models$Search$Suggestion))));
var $author$project$Decoders$suggestionsDecoder = $elm$json$Json$Decode$list($author$project$Decoders$suggestionDecoder);
var $author$project$Decoders$suggestionsRespDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'suggestions',
	$author$project$Decoders$suggestionsDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'count',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Models$Search$SuggestionsResp)));
var $author$project$App$AppBar$SearchBar$Commands$getSuggestions = function (term) {
	return $elm$http$Http$riskyRequest(
		{
			hy: $elm$http$Http$emptyBody,
			hY: A2($elm$http$Http$expectJson, $author$project$App$AppBar$SearchBar$Messages$GotSuggestions, $author$project$Decoders$suggestionsRespDecoder),
			h6: _List_Nil,
			iK: 'GET',
			j_: $elm$core$Maybe$Nothing,
			j5: $elm$core$Maybe$Nothing,
			kb: $author$project$Api$urlPrefix + ('/word' + ('/suggestions' + ('?searchTerm=' + term)))
		});
};
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $emilianobovetti$edit_distance$EditDistance$last = function (list) {
	last:
	while (true) {
		if (list.b) {
			if (!list.b.b) {
				var value = list.a;
				return $elm$core$Maybe$Just(value);
			} else {
				var tail = list.b;
				var $temp$list = tail;
				list = $temp$list;
				continue last;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $emilianobovetti$edit_distance$EditDistance$min3 = F3(
	function (a, b, c) {
		var diff1 = a - b;
		var minAB = b + (diff1 & (diff1 >> 31));
		var diff2 = minAB - c;
		return c + (diff2 & (diff2 >> 31));
	});
var $emilianobovetti$edit_distance$EditDistance$patternLoop = F6(
	function (textHead, pattern, b0, b1, b2, prev) {
		if (pattern.b) {
			var patternHead = pattern.a;
			var patternTail = pattern.b;
			if (prev.b) {
				var prevHead = prev.a;
				var prevTail = prev.b;
				var b2_ = _Utils_eq(textHead, patternHead) ? b0 : (1 + A3($emilianobovetti$edit_distance$EditDistance$min3, b0, b1, b2));
				var b1_ = prevHead;
				var b0_ = b1;
				return A2(
					$elm$core$List$cons,
					b2_,
					A6($emilianobovetti$edit_distance$EditDistance$patternLoop, textHead, patternTail, b0_, b1_, b2_, prevTail));
			} else {
				return _Utils_eq(textHead, patternHead) ? _List_fromArray(
					[b0]) : _List_fromArray(
					[
						1 + A3($emilianobovetti$edit_distance$EditDistance$min3, b0, b1, b2)
					]);
			}
		} else {
			return _List_Nil;
		}
	});
var $emilianobovetti$edit_distance$EditDistance$initPatternLoop = F4(
	function (textHead, pattern, b0, prevCol) {
		if (prevCol.b) {
			var prevHead = prevCol.a;
			var prevTail = prevCol.b;
			return A6($emilianobovetti$edit_distance$EditDistance$patternLoop, textHead, pattern, b0, prevHead, b0 + 1, prevTail);
		} else {
			return _List_Nil;
		}
	});
var $emilianobovetti$edit_distance$EditDistance$textLoop = F4(
	function (text, pattern, idx, col) {
		textLoop:
		while (true) {
			if (!text.b) {
				return col;
			} else {
				var textHead = text.a;
				var textTail = text.b;
				var nextCol = A4($emilianobovetti$edit_distance$EditDistance$initPatternLoop, textHead, pattern, idx - 1, col);
				var $temp$text = textTail,
					$temp$pattern = pattern,
					$temp$idx = idx + 1,
					$temp$col = nextCol;
				text = $temp$text;
				pattern = $temp$pattern;
				idx = $temp$idx;
				col = $temp$col;
				continue textLoop;
			}
		}
	});
var $emilianobovetti$edit_distance$EditDistance$levenshtein = F2(
	function (text, pattern) {
		levenshtein:
		while (true) {
			var _v0 = _Utils_Tuple2(text, pattern);
			if (!_v0.a.b) {
				return $elm$core$List$length(pattern);
			} else {
				if (!_v0.b.b) {
					return $elm$core$List$length(text);
				} else {
					if (!_v0.a.b.b) {
						var _v1 = _v0.a;
						var textHead = _v1.a;
						return A2(
							$elm$core$List$any,
							$elm$core$Basics$eq(textHead),
							pattern) ? ($elm$core$List$length(pattern) - 1) : $elm$core$List$length(pattern);
					} else {
						if (!_v0.b.b.b) {
							var _v2 = _v0.b;
							var patternHead = _v2.a;
							return A2(
								$elm$core$List$any,
								$elm$core$Basics$eq(patternHead),
								text) ? ($elm$core$List$length(text) - 1) : $elm$core$List$length(text);
						} else {
							var _v3 = _v0.a;
							var textHead = _v3.a;
							var textTail = _v3.b;
							var _v4 = _v0.b;
							var patternHead = _v4.a;
							var patternTail = _v4.b;
							if (_Utils_eq(textHead, patternHead)) {
								var $temp$text = textTail,
									$temp$pattern = patternTail;
								text = $temp$text;
								pattern = $temp$pattern;
								continue levenshtein;
							} else {
								return A2(
									$elm$core$Maybe$withDefault,
									-1,
									$emilianobovetti$edit_distance$EditDistance$last(
										A4(
											$emilianobovetti$edit_distance$EditDistance$textLoop,
											text,
											pattern,
											1,
											A2(
												$elm$core$List$range,
												1,
												$elm$core$List$length(pattern)))));
							}
						}
					}
				}
			}
		}
	});
var $emilianobovetti$edit_distance$EditDistance$levenshteinOfStrings = F2(
	function (text, pattern) {
		return _Utils_eq(text, pattern) ? 0 : ((_Utils_cmp(
			$elm$core$String$length(pattern),
			$elm$core$String$length(text)) > 0) ? A2(
			$emilianobovetti$edit_distance$EditDistance$levenshtein,
			$elm$core$String$toList(pattern),
			$elm$core$String$toList(text)) : A2(
			$emilianobovetti$edit_distance$EditDistance$levenshtein,
			$elm$core$String$toList(text),
			$elm$core$String$toList(pattern)));
	});
var $author$project$App$AppBar$SearchBar$Update$orderSuggestions = F2(
	function (sTerm, sugs) {
		var by = function (_v0) {
			var word = _v0.kl;
			return _Utils_Tuple2(
				A2($emilianobovetti$edit_distance$EditDistance$levenshteinOfStrings, sTerm, word),
				word);
		};
		return A2($elm$core$List$sortBy, by, sugs);
	});
var $elm$core$String$trim = _String_trim;
var $author$project$App$AppBar$SearchBar$Update$update = F2(
	function (msg, model) {
		var searchTerm = model.gC;
		var suggestions = model.jP;
		switch (msg.$) {
			case 0:
				var sT = msg.a;
				var trimmedTerm = $elm$core$String$trim(sT);
				var modelUpdated = _Utils_update(
					model,
					{gC: sT});
				return ($elm$core$String$length(trimmedTerm) > 2) ? _Utils_Tuple2(
					modelUpdated,
					$author$project$App$AppBar$SearchBar$Commands$getSuggestions(trimmedTerm)) : (($elm$core$String$length(trimmedTerm) < 2) ? _Utils_Tuple2(
					_Utils_update(
						modelUpdated,
						{iI: false}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(modelUpdated, $elm$core$Platform$Cmd$none));
			case 1:
				var trimmedT = $elm$core$String$trim(searchTerm);
				if ($elm$core$String$length(trimmedT) > 0) {
					var isInSuggestions = function () {
						var filterFn = function (s) {
							return _Utils_eq(s.kl, searchTerm);
						};
						return A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								function (_v1) {
									return true;
								},
								$elm$core$List$head(
									A2($elm$core$List$filter, filterFn, suggestions))));
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								fz: $elm$core$Maybe$Just(model.gC),
								iI: false,
								jB: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										$elm$core$Maybe$Just(trimmedT),
										trimmedT,
										isInSuggestions)),
								gN: $author$project$App$AppBar$SearchBar$Model$LoadingSearch
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 2:
				var sT = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fz: $elm$core$Maybe$Just(model.gC),
							iI: false,
							jB: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(sT),
									sT,
									true)),
							gC: sT,
							gN: $author$project$App$AppBar$SearchBar$Model$LoadingSearch
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gC: ''}),
					A2(
						$elm$core$Task$attempt,
						$author$project$App$AppBar$SearchBar$Messages$GotFocus,
						$elm$browser$Browser$Dom$focus('search')));
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{iI: false}),
					$elm$core$Platform$Cmd$none);
			case 5:
				if (!msg.a.$) {
					var sr = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iI: $elm$core$List$length(sr.jP) > 0,
								jP: A2($author$project$App$AppBar$SearchBar$Update$orderSuggestions, model.gC, sr.jP),
								jQ: sr.k3
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$App$AppBar$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var nav = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hR: model.hR ? false : model.hR,
							iH: model.iH ? false : model.iH,
							iS: nav
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{iH: !model.iH}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hR: !model.hR}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2($author$project$App$AppBar$Model$init, $elm$core$Platform$Cmd$none);
			case 4:
				var searchBarMsg = msg.a;
				var _v1 = A2($author$project$App$AppBar$SearchBar$Update$update, searchBarMsg, model.jA);
				var searchBarModel = _v1.a;
				var searchBarCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{jA: searchBarModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$App$AppBar$Messages$SearchBarMsg, searchBarCmd));
			case 5:
				var nMsg = msg.a;
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				var rMsg = msg.a;
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Models$Auth$EditGoal = function (a) {
	return {$: 3, a: a};
};
var $author$project$Models$Auth$EditName = function (a) {
	return {$: 2, a: a};
};
var $author$project$App$Auth$Model$ToSubmit = {$: 0};
var $author$project$Models$Auth$SignIn = function (a) {
	return {$: 1, a: a};
};
var $author$project$Models$Auth$SignUp = function (a) {
	return {$: 0, a: a};
};
var $author$project$App$Auth$Model$initForm = function (isToSignUp) {
	var authPayload = {ls: '', mW: 'builtin::local_magic_link'};
	return _Utils_Tuple2(
		isToSignUp ? $author$project$Models$Auth$SignUp(authPayload) : $author$project$Models$Auth$SignIn(authPayload),
		$author$project$App$Auth$Model$ToSubmit);
};
var $author$project$Models$Auth$userToGoalPayload = function (maybeUser) {
	var toPayload = function (_v0) {
		var words = _v0.oH;
		var sents = _v0.nu;
		return {
			nu: $elm$core$String$fromInt(sents),
			oH: $elm$core$String$fromInt(words)
		};
	};
	var _default = {nu: '100', oH: '20'};
	return A2(
		$elm$core$Maybe$withDefault,
		_default,
		A2(
			$elm$core$Maybe$map,
			toPayload,
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.k6;
				},
				maybeUser)));
};
var $author$project$Models$Auth$userToNamePayload = function (maybeUser) {
	var fnc = function (_v0) {
		var email = _v0.ls;
		var name = _v0.mn;
		return {
			ls: email,
			mn: A2($elm$core$Maybe$withDefault, '', name)
		};
	};
	var _default = {ls: '', mn: ''};
	return A2(
		$elm$core$Maybe$withDefault,
		_default,
		A2($elm$core$Maybe$map, fnc, maybeUser));
};
var $author$project$App$Auth$Model$formByRoute = F2(
	function (model, route) {
		var _v0 = _Utils_Tuple2(route, model.go);
		_v0$0:
		while (true) {
			_v0$1:
			while (true) {
				if (!_v0.b) {
					switch (_v0.a) {
						case 3:
							break _v0$0;
						case 2:
							break _v0$1;
						default:
							var _v3 = _v0.b;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$author$project$Models$Auth$EditName(
										$author$project$Models$Auth$userToNamePayload(model.kd)),
									$author$project$App$Auth$Model$ToSubmit));
					}
				} else {
					switch (_v0.a) {
						case 3:
							break _v0$0;
						case 2:
							break _v0$1;
						default:
							var _v4 = _v0.b;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$author$project$Models$Auth$EditGoal(
										$author$project$Models$Auth$userToGoalPayload(model.kd)),
									$author$project$App$Auth$Model$ToSubmit));
					}
				}
			}
			var _v2 = _v0.a;
			return $elm$core$Maybe$Just(
				$author$project$App$Auth$Model$initForm(true));
		}
		var _v1 = _v0.a;
		return $elm$core$Maybe$Just(
			$author$project$App$Auth$Model$initForm(false));
	});
var $author$project$App$Auth$Model$update = F2(
	function (model, route) {
		return _Utils_update(
			model,
			{
				dN: A2($author$project$App$Auth$Model$formByRoute, model, route)
			});
	});
var $author$project$App$Auth$Model$Authing = {$: 0};
var $author$project$App$Auth$Model$EmailSent = {$: 3};
var $author$project$App$Auth$Model$LoggedOut = {$: 2};
var $author$project$App$Auth$Model$Submitted = function (a) {
	return {$: 1, a: a};
};
var $author$project$App$Auth$Messages$GotAuthResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Models$Auth$User = F3(
	function (email, name, dailyGoal) {
		return {k6: dailyGoal, ls: email, mn: name};
	});
var $author$project$Models$Auth$DailyGoal = F2(
	function (sents, words) {
		return {nu: sents, oH: words};
	});
var $author$project$Decoders$dailyGoalDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'words',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sents',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Models$Auth$DailyGoal)));
var $author$project$Decoders$userDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'daily_goal',
	$elm$json$Json$Decode$maybe($author$project$Decoders$dailyGoalDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'email',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Models$Auth$User))));
var $author$project$App$Auth$Commands$getUser = $elm$http$Http$riskyRequest(
	{
		hy: $elm$http$Http$emptyBody,
		hY: A2($elm$http$Http$expectJson, $author$project$App$Auth$Messages$GotAuthResponse, $author$project$Decoders$userDecoder),
		h6: _List_Nil,
		iK: 'GET',
		j_: $elm$core$Maybe$Nothing,
		j5: $elm$core$Maybe$Nothing,
		kb: $author$project$Api$urlPrefix + '/user'
	});
var $author$project$App$Auth$Messages$GoalPut = function (a) {
	return {$: 3, a: a};
};
var $author$project$Encoders$dailyGoalPayloadEncoder = function (_v0) {
	var words = _v0.oH;
	var sents = _v0.nu;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'words',
				$elm$json$Json$Encode$string(words)),
				_Utils_Tuple2(
				'sents',
				$elm$json$Json$Encode$string(sents))
			]));
};
var $author$project$App$Auth$Commands$putGoal = function (payload) {
	return $elm$http$Http$riskyRequest(
		{
			hy: $elm$http$Http$jsonBody(
				$author$project$Encoders$dailyGoalPayloadEncoder(payload)),
			hY: A2($elm$http$Http$expectJson, $author$project$App$Auth$Messages$GoalPut, $author$project$Decoders$dailyGoalDecoder),
			h6: _List_Nil,
			iK: 'PUT',
			j_: $elm$core$Maybe$Nothing,
			j5: $elm$core$Maybe$Nothing,
			kb: $author$project$Api$urlPrefix + '/user/goal'
		});
};
var $author$project$App$Auth$Messages$NamePut = function (a) {
	return {$: 2, a: a};
};
var $author$project$Encoders$namePayloadEncoder = function (_v0) {
	var name = _v0.mn;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(name))
			]));
};
var $author$project$App$Auth$Commands$putName = function (payload) {
	return $elm$http$Http$riskyRequest(
		{
			hy: $elm$http$Http$jsonBody(
				$author$project$Encoders$namePayloadEncoder(payload)),
			hY: A2($elm$http$Http$expectJson, $author$project$App$Auth$Messages$NamePut, $author$project$Decoders$userDecoder),
			h6: _List_Nil,
			iK: 'PUT',
			j_: $elm$core$Maybe$Nothing,
			j5: $elm$core$Maybe$Nothing,
			kb: $author$project$Api$urlPrefix + '/user'
		});
};
var $author$project$App$Auth$Messages$SignInAttempted = function (a) {
	return {$: 6, a: a};
};
var $author$project$Encoders$authPayloadEncoder = function (_v0) {
	var email = _v0.ls;
	var provider = _v0.mW;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(email)),
				_Utils_Tuple2(
				'provider',
				$elm$json$Json$Encode$string(provider))
			]));
};
var $author$project$App$Auth$Commands$signin = function (payload) {
	return $elm$http$Http$riskyRequest(
		{
			hy: $elm$http$Http$jsonBody(
				$author$project$Encoders$authPayloadEncoder(payload)),
			hY: $elm$http$Http$expectWhatever($author$project$App$Auth$Messages$SignInAttempted),
			h6: _List_Nil,
			iK: 'POST',
			j_: $elm$core$Maybe$Nothing,
			j5: $elm$core$Maybe$Nothing,
			kb: $author$project$Api$urlPrefix + '/auth/magic-link/send'
		});
};
var $author$project$App$Auth$Messages$SignUpAttempted = function (a) {
	return {$: 7, a: a};
};
var $author$project$App$Auth$Commands$signup = function (payload) {
	return $elm$http$Http$riskyRequest(
		{
			hy: $elm$http$Http$jsonBody(
				$author$project$Encoders$authPayloadEncoder(payload)),
			hY: $elm$http$Http$expectWhatever($author$project$App$Auth$Messages$SignUpAttempted),
			h6: _List_Nil,
			iK: 'POST',
			j_: $elm$core$Maybe$Nothing,
			j5: $elm$core$Maybe$Nothing,
			kb: $author$project$Api$urlPrefix + '/auth/magic-link/signup'
		});
};
var $author$project$App$Auth$Update$submit = function (_v0) {
	var form = _v0.a;
	switch (form.$) {
		case 0:
			var f = form.a;
			return $author$project$App$Auth$Commands$signup(f);
		case 1:
			var f = form.a;
			return $author$project$App$Auth$Commands$signin(f);
		case 2:
			var f = form.a;
			return $author$project$App$Auth$Commands$putName(f);
		default:
			var f = form.a;
			return $author$project$App$Auth$Commands$putGoal(f);
	}
};
var $author$project$App$Auth$Update$updateField = F4(
	function (model, field, val, _v0) {
		var form = _v0.a;
		var _v1 = _Utils_Tuple2(field, form);
		_v1$5:
		while (true) {
			switch (_v1.a) {
				case 0:
					switch (_v1.b.$) {
						case 0:
							var _v2 = _v1.a;
							var f = _v1.b.a;
							return _Utils_update(
								model,
								{
									dN: $elm$core$Maybe$Just(
										_Utils_Tuple2(
											$author$project$Models$Auth$SignUp(
												_Utils_update(
													f,
													{ls: val})),
											$author$project$App$Auth$Model$ToSubmit))
								});
						case 1:
							var _v3 = _v1.a;
							var f = _v1.b.a;
							return _Utils_update(
								model,
								{
									dN: $elm$core$Maybe$Just(
										_Utils_Tuple2(
											$author$project$Models$Auth$SignIn(
												_Utils_update(
													f,
													{ls: val})),
											$author$project$App$Auth$Model$ToSubmit))
								});
						default:
							break _v1$5;
					}
				case 1:
					if (_v1.b.$ === 2) {
						var _v4 = _v1.a;
						var f = _v1.b.a;
						return _Utils_update(
							model,
							{
								dN: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$author$project$Models$Auth$EditName(
											_Utils_update(
												f,
												{mn: val})),
										$author$project$App$Auth$Model$ToSubmit))
							});
					} else {
						break _v1$5;
					}
				case 2:
					if (_v1.b.$ === 3) {
						var _v5 = _v1.a;
						var f = _v1.b.a;
						return _Utils_update(
							model,
							{
								dN: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$author$project$Models$Auth$EditGoal(
											_Utils_update(
												f,
												{oH: val})),
										$author$project$App$Auth$Model$ToSubmit))
							});
					} else {
						break _v1$5;
					}
				default:
					if (_v1.b.$ === 3) {
						var _v6 = _v1.a;
						var f = _v1.b.a;
						return _Utils_update(
							model,
							{
								dN: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$author$project$Models$Auth$EditGoal(
											_Utils_update(
												f,
												{nu: val})),
										$author$project$App$Auth$Model$ToSubmit))
							});
					} else {
						break _v1$5;
					}
			}
		}
		return model;
	});
var $author$project$App$Auth$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gN: $author$project$App$Auth$Model$Authing}),
					$author$project$App$Auth$Commands$getUser);
			case 1:
				if (!msg.a.$) {
					var user = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								gN: $author$project$App$Auth$Model$LoggedIn,
								kd: $elm$core$Maybe$Just(user)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{gN: $author$project$App$Auth$Model$LoggedOut}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				if (!msg.a.$) {
					var user = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								kd: $elm$core$Maybe$Just(user)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 3:
				if (!msg.a.$) {
					var dG = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								kd: A2(
									$elm$core$Maybe$map,
									function (u) {
										return _Utils_update(
											u,
											{
												k6: $elm$core$Maybe$Just(dG)
											});
									},
									model.kd)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 4:
				var f = msg.a;
				var v = msg.b;
				return _Utils_Tuple2(
					A2(
						$elm$core$Maybe$withDefault,
						model,
						A2(
							$elm$core$Maybe$map,
							A3($author$project$App$Auth$Update$updateField, model, f, v),
							model.dN)),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2($elm$core$Maybe$map, $author$project$App$Auth$Update$submit, model.dN)));
			case 6:
				if (msg.a.$ === 1) {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dN: function () {
									var _v1 = model.dN;
									if (!_v1.$) {
										var _v2 = _v1.a;
										var f = _v2.a;
										return $elm$core$Maybe$Just(
											_Utils_Tuple2(
												f,
												$author$project$App$Auth$Model$Submitted(
													$elm$core$Maybe$Just(e))));
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}()
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dN: function () {
									var _v3 = model.dN;
									if (!_v3.$) {
										var _v4 = _v3.a;
										var f = _v4.a;
										return $elm$core$Maybe$Just(
											_Utils_Tuple2(
												f,
												$author$project$App$Auth$Model$Submitted($elm$core$Maybe$Nothing)));
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}(),
								gN: $author$project$App$Auth$Model$EmailSent
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 7:
				if (msg.a.$ === 1) {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dN: function () {
									var _v5 = model.dN;
									if (!_v5.$) {
										var _v6 = _v5.a;
										var f = _v6.a;
										return $elm$core$Maybe$Just(
											_Utils_Tuple2(
												f,
												$author$project$App$Auth$Model$Submitted(
													$elm$core$Maybe$Just(e))));
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}()
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dN: function () {
									var _v7 = model.dN;
									if (!_v7.$) {
										var _v8 = _v7.a;
										var f = _v8.a;
										return $elm$core$Maybe$Just(
											_Utils_Tuple2(
												f,
												$author$project$App$Auth$Model$Submitted($elm$core$Maybe$Nothing)));
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}(),
								gN: $author$project$App$Auth$Model$EmailSent
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gN: $author$project$App$Auth$Model$LoggedOut}),
					$elm$core$Platform$Cmd$none);
			default:
				var pS = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dN: $elm$core$Maybe$Just(
								function () {
									if (!pS) {
										return _Utils_Tuple2(
											$author$project$Models$Auth$EditName(
												$author$project$Models$Auth$userToNamePayload(model.kd)),
											$author$project$App$Auth$Model$ToSubmit);
									} else {
										return _Utils_Tuple2(
											$author$project$Models$Auth$EditGoal(
												$author$project$Models$Auth$userToGoalPayload(model.kd)),
											$author$project$App$Auth$Model$ToSubmit);
									}
								}()),
							go: pS
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Route$defaultUrl = A6($elm$url$Url$Url, 1, 'nimoza.com', $elm$core$Maybe$Nothing, '', $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
var $author$project$Route$toString = function (route) {
	switch (route) {
		case 0:
			return '/';
		case 1:
			return '/dashboard';
		case 3:
			return '/login';
		default:
			return '/getstarted';
	}
};
var $author$project$Route$toUrl = function (route) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Route$defaultUrl,
		$elm$url$Url$fromString(
			$author$project$Route$toString(route)));
};
var $author$project$App$Landing$Update$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var menu = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{iH: menu}),
				$elm$core$Platform$Cmd$none,
				$elm$core$Maybe$Nothing);
		} else {
			var route = msg.a;
			return _Utils_Tuple3(
				model,
				$elm$core$Platform$Cmd$none,
				$elm$core$Maybe$Just(
					$author$project$App$Messages$LinkClicked(
						$elm$browser$Browser$Internal(
							$author$project$Route$toUrl(route)))));
		}
	});
var $author$project$App$Search$Update$kaikkiIsRenewed = F2(
	function (model, kModel) {
		return !_Utils_eq(model.is.jC, kModel.jC);
	});
var $author$project$Util$startsWithUppercase = function (str) {
	var _v0 = $elm$core$String$uncons(str);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var firstChar = _v1.a;
		return $elm$core$Char$isUpper(firstChar);
	} else {
		return false;
	}
};
var $author$project$Util$uncapitalize = function (s) {
	var toLower = function (c) {
		switch (c) {
			case 'Ä':
				return 'ä';
			case 'Ö':
				return 'ö';
			case 'Ü':
				return 'ü';
			case 'ẞ':
				return 'ß';
			case 'É':
				return 'é';
			case 'È':
				return 'è';
			case 'À':
				return 'à';
			case 'Ç':
				return 'ç';
			default:
				return $elm$core$Char$toLower(c);
		}
	};
	var _v0 = $elm$core$String$toList(s);
	if (_v0.b) {
		var firstC = _v0.a;
		var otherCs = _v0.b;
		return $elm$core$String$fromList(
			A2(
				$elm$core$List$cons,
				toLower(firstC),
				otherCs));
	} else {
		return '';
	}
};
var $author$project$App$Search$Update$kaikkiOtherCmds = function (msg) {
	var searchTermParts = function (mS) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$String$split('-'),
			mS);
	};
	var searchTermHasDash = function (mS) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$contains('-'),
				mS));
	};
	var partsToCmd = F2(
		function (mS, parts) {
			return A2(
				$elm$core$List$map,
				function (p) {
					return A3(
						$author$project$App$Search$Update$kLookupAndWLinks,
						$elm$core$Maybe$Just(
							A2($elm$core$String$join, ';', parts)),
						p,
						false);
				},
				parts);
		});
	var isCapped = function (mS) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Util$startsWithUppercase, mS));
	};
	var cappedToCmd = function (mS) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Maybe$map,
				function (t) {
					return A3(
						$author$project$App$Search$Update$kLookupAndWLinks,
						$elm$core$Maybe$Just(t),
						t,
						false);
				},
				A2($elm$core$Maybe$map, $author$project$Util$uncapitalize, mS)));
	};
	if ((!msg.$) && (!msg.b.$)) {
		var maybeString = msg.a;
		var ents = msg.b.a;
		return (!$elm$core$List$length(ents)) ? (searchTermHasDash(maybeString) ? $elm$core$Platform$Cmd$batch(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					partsToCmd(maybeString),
					searchTermParts(maybeString)))) : (isCapped(maybeString) ? cappedToCmd(maybeString) : $elm$core$Platform$Cmd$none)) : $elm$core$Platform$Cmd$none;
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Models$Word$tagIsFeminine = function (_v0) {
	var gender = _v0.h4;
	return _Utils_eq(
		gender,
		$elm$core$Maybe$Just(0));
};
var $author$project$Models$Word$tagIsMorph = function (_v0) {
	var morph = _v0.iO;
	return !_Utils_eq(morph, $elm$core$Maybe$Nothing);
};
var $author$project$Models$Word$tagIsParticiple = function (_v0) {
	var participle = _v0.i5;
	return !_Utils_eq(participle, $elm$core$Maybe$Nothing);
};
var $author$project$Models$Word$tagIsPlural = function (_v0) {
	var count = _v0.k3;
	return _Utils_eq(
		count,
		$elm$core$Maybe$Just(1));
};
var $author$project$Models$Word$tagWithAdjDegree = function (_v0) {
	var adjDegree = _v0.hj;
	return _Utils_eq(
		adjDegree,
		$elm$core$Maybe$Just(2)) || _Utils_eq(
		adjDegree,
		$elm$core$Maybe$Just(1));
};
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Models$Word$tagWithNonNomCases = function (_v0) {
	var cases = _v0.hB;
	var cond = function (ls) {
		return A2(
			$elm$core$List$any,
			function (c) {
				return A2($elm$core$List$member, c, ls);
			},
			_List_fromArray(
				[1, 2, 3]));
	};
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, cond, cases));
};
var $author$project$App$Search$Update$lookupKaikkiForWordLink = F2(
	function (sT, wls) {
		var trivialFilterFnc = function (_v11) {
			var dst = _v11.hS;
			var src = _v11.nC;
			return !_Utils_eq(dst.kl, src.kl);
		};
		var nounCond = function (t) {
			return A2(
				$elm$core$List$any,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$author$project$Models$Word$tagIsPlural(t),
						$author$project$Models$Word$tagIsFeminine(t),
						$author$project$Models$Word$tagWithNonNomCases(t)
					]));
		};
		var doLookup = function (t) {
			return (!_Utils_eq(t, sT)) ? A3(
				$author$project$App$Search$Commands$lookupKaikki,
				$elm$core$Maybe$Just(sT),
				t,
				false) : $elm$core$Platform$Cmd$none;
		};
		var adjCond = function (t) {
			return A2(
				$elm$core$List$any,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$author$project$Models$Word$tagIsPlural(t),
						$author$project$Models$Word$tagWithAdjDegree(t),
						$author$project$Models$Word$tagWithNonNomCases(t)
					]));
		};
		var filterFnc = function (_v10) {
			var srcPos = _v10.nD;
			var dstPos = _v10.ll;
			var tags = _v10.nS;
			var _v1 = _Utils_Tuple3(srcPos, dstPos, tags);
			_v1$4:
			while (true) {
				switch (_v1.a) {
					case 0:
						if (_v1.b === 30) {
							var _v2 = _v1.a;
							var _v3 = _v1.b;
							return true;
						} else {
							break _v1$4;
						}
					case 2:
						if (_v1.b === 2) {
							var _v4 = _v1.a;
							var _v5 = _v1.b;
							var ts = _v1.c;
							return A2($elm$core$List$any, nounCond, ts);
						} else {
							break _v1$4;
						}
					case 1:
						switch (_v1.b) {
							case 1:
								var _v6 = _v1.a;
								var _v7 = _v1.b;
								var ts = _v1.c;
								return A2($elm$core$List$any, adjCond, ts);
							case 30:
								var _v8 = _v1.a;
								var _v9 = _v1.b;
								var ts = _v1.c;
								return A2($elm$core$List$any, $author$project$Models$Word$tagIsParticiple, ts);
							default:
								break _v1$4;
						}
					default:
						break _v1$4;
				}
			}
			var ts = _v1.c;
			return A2($elm$core$List$any, $author$project$Models$Word$tagIsMorph, ts);
		};
		return $elm$core$Platform$Cmd$batch(
			A2(
				$elm$core$List$map,
				doLookup,
				$elm$core$Set$toList(
					$elm$core$Set$fromList(
						A2(
							$elm$core$List$map,
							function (_v0) {
								var dst = _v0.hS;
								return dst.kl;
							},
							A2(
								$elm$core$List$filter,
								filterFnc,
								A2($elm$core$List$filter, trivialFilterFnc, wls)))))));
	});
var $author$project$Models$Kaikki$AdjDep = function (a) {
	return {$: 2, a: a};
};
var $author$project$Models$Kaikki$NounDep = function (a) {
	return {$: 0, a: a};
};
var $author$project$Models$Kaikki$VerbDep = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm$core$Dict$intersect = F2(
	function (t1, t2) {
		return A2(
			$elm$core$Dict$filter,
			F2(
				function (k, _v0) {
					return A2($elm$core$Dict$member, k, t2);
				}),
			t1);
	});
var $elm$core$Set$intersect = F2(
	function (_v0, _v1) {
		var dict1 = _v0;
		var dict2 = _v1;
		return A2($elm$core$Dict$intersect, dict1, dict2);
	});
var $author$project$Util$setAinB = F2(
	function (setA, setB) {
		return _Utils_eq(
			setA,
			A2($elm$core$Set$intersect, setA, setB));
	});
var $author$project$Util$setsIntersect = F2(
	function (setA, setB) {
		return !_Utils_eq(
			$elm$core$Set$empty,
			A2($elm$core$Set$intersect, setA, setB));
	});
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $elm$core$Set$size = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$size(dict);
};
var $author$project$Models$Kaikki$filterForms = F3(
	function (tagsMust, tagsMustNot, forms) {
		var tagsCount = $elm$core$Set$size(tagsMust);
		var sortByFnc = function (_v1) {
			var tags = _v1.nS;
			return function (tc) {
				return tc - tagsCount;
			}(
				A2(
					$elm$core$Maybe$withDefault,
					0,
					A2($elm$core$Maybe$map, $elm$core$List$length, tags)));
		};
		var formHasNoNonTag = function (tagsSet) {
			return !A2($author$project$Util$setsIntersect, tagsSet, tagsMustNot);
		};
		var formHasAllTags = function (tagsSet) {
			return A2($author$project$Util$setAinB, tagsMust, tagsSet);
		};
		var conds = function (_v0) {
			var tags = _v0.nS;
			var tagsSet = A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Set$empty,
				A2($elm$core$Maybe$map, $elm$core$Set$fromList, tags));
			return formHasAllTags(tagsSet) && formHasNoNonTag(tagsSet);
		};
		return A2(
			$elm$core$List$sortBy,
			sortByFnc,
			A2($elm$core$List$filter, conds, forms));
	});
var $author$project$Models$Kaikki$getForm = function (forms) {
	return $elm$core$Set$toList(
		$elm$core$Set$fromList(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.dN;
				},
				forms)));
};
var $author$project$Models$Kaikki$Feminine = 0;
var $author$project$Models$Kaikki$Masculine = 1;
var $author$project$Models$Kaikki$Neuter = 2;
var $author$project$Util$setsUnion = function (sets) {
	return A3($elm$core$List$foldl, $elm$core$Set$union, $elm$core$Set$empty, sets);
};
var $author$project$Models$Kaikki$getNounGender = function (_v0) {
	var senses = _v0.np;
	var textFields = _v0.jT;
	var strToGender = function (s) {
		switch (s) {
			case 'feminine':
				return $elm$core$Maybe$Just(0);
			case 'masculine':
				return $elm$core$Maybe$Just(1);
			case 'neuter':
				return $elm$core$Maybe$Just(2);
			default:
				return $elm$core$Maybe$Nothing;
		}
	};
	var hasNoPlural = function (ts) {
		return !A2($elm$core$Set$member, 'plural', ts);
	};
	var tagsSet = $author$project$Util$setsUnion(
		A2(
			$elm$core$List$filter,
			hasNoPlural,
			A2(
				$elm$core$List$map,
				$elm$core$Set$fromList,
				$elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							$elm$core$List$filterMap,
							function ($) {
								return $.nS;
							},
							A2($elm$core$Maybe$withDefault, _List_Nil, senses)),
							_List_fromArray(
							[
								A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.nS;
									},
									textFields))
							])
						])))));
	var _v1 = A2(
		$elm$core$List$filterMap,
		strToGender,
		$elm$core$Set$toList(tagsSet));
	if (!_v1.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var genders = _v1;
		return $elm$core$Maybe$Just(genders);
	}
};
var $author$project$Models$Kaikki$getNounPlural = function (_v0) {
	var forms = _v0.ff;
	var removeArticle = function (form) {
		var articles = $elm$core$Set$fromList(
			_List_fromArray(
				['die', 'der', 'den']));
		var isNotArticle = function (p) {
			return !A2($elm$core$Set$member, p, articles);
		};
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filter,
				isNotArticle,
				A2($elm$core$String$split, ' ', form)));
	};
	var filterFnc = function (_v3) {
		var tags = _v3.nS;
		var tagsSet = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Set$empty,
			A2($elm$core$Maybe$map, $elm$core$Set$fromList, tags));
		return A2($elm$core$Set$member, 'plural', tagsSet);
	};
	var pluralForms = function () {
		if (!forms.$) {
			var fs = forms.a;
			return A2($elm$core$List$filter, filterFnc, fs);
		} else {
			return _List_Nil;
		}
	}();
	var pluralWOArticle = A2(
		$elm$core$List$map,
		removeArticle,
		A2(
			$elm$core$List$map,
			function ($) {
				return $.dN;
			},
			pluralForms));
	if (!pluralWOArticle.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var vs = pluralWOArticle;
		return $elm$core$Maybe$Just(
			$elm$core$Set$toList(
				$elm$core$Set$fromList(
					A2($elm$core$List$map, $elm$core$String$trim, vs))));
	}
};
var $author$project$Models$Kaikki$Irregular = 2;
var $author$project$Models$Kaikki$Strong = 1;
var $author$project$Models$Kaikki$Weak = 0;
var $author$project$Models$Kaikki$getVerbCat = function (_v0) {
	var senses = _v0.np;
	var strToCat = function (s) {
		switch (s) {
			case 'weak':
				return $elm$core$Maybe$Just(0);
			case 'strong':
				return $elm$core$Maybe$Just(1);
			case 'irregular':
				return $elm$core$Maybe$Just(2);
			default:
				return $elm$core$Maybe$Nothing;
		}
	};
	var cats = A2(
		$elm$core$List$filterMap,
		strToCat,
		$elm$core$Set$toList(
			$author$project$Util$setsUnion(
				A2(
					$elm$core$List$map,
					$elm$core$Set$fromList,
					A2(
						$elm$core$List$filterMap,
						function ($) {
							return $.nS;
						},
						A2($elm$core$Maybe$withDefault, _List_Nil, senses))))));
	return ($elm$core$List$length(cats) > 0) ? $elm$core$Maybe$Just(cats) : $elm$core$Maybe$Nothing;
};
var $author$project$Models$Kaikki$getDep = function (entity) {
	var unqCuts = function (vs) {
		return $elm$core$Set$toList(
			$elm$core$Set$fromList(
				$elm$core$List$concat(
					A2(
						$elm$core$List$map,
						$elm$core$String$split(' or '),
						vs))));
	};
	var op = F2(
		function (v1, v2) {
			return $author$project$Models$Kaikki$getForm(
				function () {
					var _v0 = entity.ff;
					if (!_v0.$) {
						var fs = _v0.a;
						return A3(
							$author$project$Models$Kaikki$filterForms,
							$elm$core$Set$fromList(v1),
							$elm$core$Set$fromList(v2),
							fs);
					} else {
						return _List_Nil;
					}
				}());
		});
	if (A2($elm$core$List$member, 'noun', entity.mO)) {
		return $elm$core$Maybe$Just(
			$author$project$Models$Kaikki$NounDep(
				{
					h4: $author$project$Models$Kaikki$getNounGender(entity),
					mM: $author$project$Models$Kaikki$getNounPlural(entity)
				}));
	} else {
		if (A2($elm$core$List$member, 'verb', entity.mO)) {
			var removePron = function (form) {
				var prons = $elm$core$Set$fromList(
					_List_fromArray(
						['er', 'sie', 'es']));
				var isNotPron = function (p) {
					return !A2($elm$core$Set$member, p, prons);
				};
				return A2(
					$elm$core$String$join,
					' ',
					A2(
						$elm$core$List$filter,
						isNotPron,
						$elm$core$List$concat(
							A2(
								$elm$core$List$map,
								$elm$core$String$split('/'),
								A2($elm$core$String$split, ' ', form)))));
			};
			return $elm$core$Maybe$Just(
				$author$project$Models$Kaikki$VerbDep(
					{
						kH: unqCuts(
							A2(
								op,
								_List_fromArray(
									['auxiliary']),
								_List_Nil)),
						kQ: $author$project$Models$Kaikki$getVerbCat(entity),
						mJ: $elm$core$List$concat(
							_List_fromArray(
								[
									A2(
									op,
									_List_fromArray(
										['participle', 'past']),
									_List_Nil),
									A2(
									op,
									_List_fromArray(
										['participle-2']),
									_List_Nil)
								])),
						i8: A2(
							$elm$core$List$map,
							removePron,
							A2(
								op,
								_List_fromArray(
									['indicative', 'perfect', 'singular', 'third-person']),
								_List_fromArray(
									['subordinate-clause']))),
						mQ: A2(
							$elm$core$List$map,
							removePron,
							A2(
								op,
								_List_fromArray(
									['indicative', 'present', 'singular', 'third-person']),
								_List_fromArray(
									['subordinate-clause', 'statal passive', 'processual passive']))),
						mS: A2(
							$elm$core$List$map,
							removePron,
							$elm$core$List$concat(
								_List_fromArray(
									[
										A2(
										op,
										_List_fromArray(
											['indicative', 'preterite', 'singular', 'third-person']),
										_List_fromArray(
											['subordinate-clause'])),
										A2(
										op,
										_List_fromArray(
											['indicative', 'past', 'singular', 'third-person']),
										_List_fromArray(
											['subordinate-clause']))
									])))
					}));
		} else {
			if (A2($elm$core$List$member, 'adj', entity.mO)) {
				return $elm$core$Maybe$Just(
					$author$project$Models$Kaikki$AdjDep(
						{
							k$: $elm$core$List$head(
								A2(
									op,
									_List_fromArray(
										['comparative']),
									_List_fromArray(
										['indefinite', 'definite', 'mix', 'singular', 'plural', 'accusative', 'dative', 'genitive', 'nominative', 'without-article']))),
							nP: $elm$core$List$head(
								A2(
									op,
									_List_fromArray(
										['superlative']),
									_List_fromArray(
										['indefinite', 'definite', 'mix', 'singular', 'plural', 'accusative', 'dative', 'genitive', 'nominative', 'without-article'])))
						}));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	}
};
var $author$project$App$Kaikki$Update$byLang = function (entities) {
	var fnc = F2(
		function (ent, dico) {
			var current = A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Dict$get, ent.iv, dico));
			var _new = A2(
				$elm$core$List$append,
				current,
				_List_fromArray(
					[
						{
						lg: $author$project$Models$Kaikki$getDep(ent),
						lv: ent
					}
					]));
			return A3($elm$core$Dict$insert, ent.iv, _new, dico);
		});
	return A3($elm$core$List$foldl, fnc, $elm$core$Dict$empty, entities);
};
var $author$project$App$Kaikki$Update$combineDicts = F2(
	function (dico, dicoNew) {
		var fnc = F2(
			function (_v0, d) {
				var k = _v0.a;
				var vs = _v0.b;
				var current = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, k, d));
				var _new = A2($elm$core$List$append, current, vs);
				return A3($elm$core$Dict$insert, k, _new, d);
			});
		return A3(
			$elm$core$List$foldl,
			fnc,
			dico,
			$elm$core$Dict$toList(dicoNew));
	});
var $author$project$Models$Kaikki$De = 0;
var $author$project$Models$Kaikki$En = 1;
var $author$project$Models$Kaikki$langFromStr = function (s) {
	switch (s) {
		case 'de':
			return $elm$core$Maybe$Just(0);
		case 'Deutsch':
			return $elm$core$Maybe$Just(0);
		case 'en':
			return $elm$core$Maybe$Just(1);
		case 'German':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Models$Kaikki$keyToLangs = function (s) {
	var _v0 = A2(
		$elm$core$List$map,
		$author$project$Models$Kaikki$langFromStr,
		A2($elm$core$String$split, ':', s));
	if ((((_v0.b && (!_v0.a.$)) && _v0.b.b) && (!_v0.b.a.$)) && (!_v0.b.b.b)) {
		var l1 = _v0.a.a;
		var _v1 = _v0.b;
		var l2 = _v1.a.a;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(l1, l2));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$App$Kaikki$Update$langUpdate = F2(
	function (ents, current) {
		var langs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			A2(
				$elm$core$List$map,
				$author$project$Models$Kaikki$keyToLangs,
				$elm$core$Dict$keys(ents)));
		var currentInSet = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (c) {
					return A2($elm$core$List$member, c, langs);
				},
				current));
		return currentInSet ? current : $elm$core$List$head(langs);
	});
var $author$project$App$Kaikki$Update$update = F2(
	function (msg, model) {
		if (!msg.$) {
			if (!msg.b.$) {
				var maybeString = msg.a;
				var ents = msg.b.a;
				var isNew = function (_v1) {
					var id = _v1.fn;
					return !A2($elm$core$Set$member, id, model.ih);
				};
				var newEnts = A2($elm$core$List$filter, isNew, ents);
				var refreshCond = ($elm$core$List$length(newEnts) > 0) && ((!_Utils_eq(maybeString, $elm$core$Maybe$Nothing)) && (!_Utils_eq(model.jC, maybeString)));
				var updateCond = $elm$core$List$length(newEnts) > 0;
				var depEntsDico = $author$project$App$Kaikki$Update$byLang(newEnts);
				if (refreshCond) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hW: depEntsDico,
								ih: $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.fn;
										},
										newEnts)),
								ix: A2($author$project$App$Kaikki$Update$langUpdate, depEntsDico, model.ix),
								jC: maybeString
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					if (updateCond) {
						var depEntsDicoUpdated = A2($author$project$App$Kaikki$Update$combineDicts, model.hW, depEntsDico);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									hW: depEntsDicoUpdated,
									ih: A2(
										$elm$core$Set$union,
										model.ih,
										$elm$core$Set$fromList(
											A2(
												$elm$core$List$map,
												function ($) {
													return $.fn;
												},
												newEnts))),
									ix: A2($author$project$App$Kaikki$Update$langUpdate, depEntsDicoUpdated, model.ix)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}
			} else {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		} else {
			var langs = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						ix: $elm$core$Maybe$Just(langs)
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$App$Search$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var kMsg = msg.a;
				var _v1 = A2($author$project$App$Kaikki$Update$update, kMsg, model.is);
				var kaikkiModel = _v1.a;
				var kaikkiCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hf: model.hf || A2($author$project$App$Search$Update$kaikkiIsRenewed, model, kaikkiModel),
							is: kaikkiModel
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$App$Search$Messages$KaikkiMsg, kaikkiCmd),
								$author$project$App$Search$Update$kaikkiOtherCmds(kMsg)
							])));
			case 1:
				if (!msg.b.$) {
					var t = msg.a;
					var wls = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								km: A3($elm$core$Dict$insert, t, wls, model.km)
							}),
						A2($author$project$App$Search$Update$lookupKaikkiForWordLink, t, wls));
				} else {
					var t = msg.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 2:
				var i = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{jy: i}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var val = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hf: val}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var y = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hO: 0,
							hP: $elm$core$Maybe$Just(y)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var y = msg.a;
				var _v2 = model.hP;
				if (!_v2.$) {
					var startY = _v2.a;
					var offset = y - startY;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hO: A2($elm$core$Basics$max, 0, offset)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				var threshold = 100;
				return (_Utils_cmp(model.hO, threshold) > 0) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{hf: false, hO: 0, hP: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{hf: true, hO: 0, hP: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$App$AppBar$SearchBar$Model$setStatusToIdle = function (model) {
	return _Utils_update(
		model,
		{gN: $author$project$App$AppBar$SearchBar$Model$Idle});
};
var $author$project$App$Update$updateAppBarUponSearch = F2(
	function (msg, model) {
		_v0$2:
		while (true) {
			switch (msg.$) {
				case 0:
					if (!msg.a.$) {
						var _v1 = msg.a;
						return _Utils_update(
							model,
							{
								jA: $author$project$App$AppBar$SearchBar$Model$setStatusToIdle(model.jA)
							});
					} else {
						break _v0$2;
					}
				case 3:
					if (!msg.a) {
						var searchBar = model.jA;
						return _Utils_update(
							model,
							{jA: searchBar});
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return model;
	});
var $author$project$App$Update$updateAppBarUponSentenceCore = F2(
	function (msg, model) {
		_v0$2:
		while (true) {
			switch (msg.$) {
				case 7:
					if ((msg.a.$ === 2) && (!msg.a.a.$)) {
						var sBModel = model.jA;
						return _Utils_update(
							model,
							{
								jA: _Utils_update(
									sBModel,
									{gC: ''})
							});
					} else {
						break _v0$2;
					}
				case 8:
					if ((msg.a.$ === 6) && (!msg.a.b.$)) {
						var _v1 = msg.a;
						var sBModel = model.jA;
						return _Utils_update(
							model,
							{
								jA: _Utils_update(
									sBModel,
									{gC: ''})
							});
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return model;
	});
var $author$project$App$Ring$Model$updateForTick = function (model) {
	return (_Utils_cmp(
		model.b9,
		$elm$core$List$length(model.dO) - 1) < 0) ? _Utils_update(
		model,
		{b9: model.b9 + 1}) : model;
};
var $author$project$App$Activity$Update$updateForTick = function (model) {
	var rings = model.js;
	var currentDate = model.hJ;
	var mapModel = function (_v0) {
		var d = _v0.a;
		var _v1 = _v0.b;
		var dAC = _v1.a;
		var m = _v1.b;
		return _Utils_update(
			model,
			{
				js: A3(
					$elm$core$Dict$insert,
					d,
					_Utils_Tuple2(
						dAC,
						$author$project$App$Ring$Model$updateForTick(m)),
					rings)
			});
	};
	var getCouple = function (d) {
		return A2(
			$elm$core$Maybe$map,
			function (p) {
				return _Utils_Tuple2(d, p);
			},
			A2($elm$core$Dict$get, d, rings));
	};
	return A2(
		$elm$core$Maybe$withDefault,
		model,
		A2(
			$elm$core$Maybe$map,
			mapModel,
			A2($elm$core$Maybe$andThen, getCouple, currentDate)));
};
var $author$project$App$Update$updateNextCounter = F2(
	function (msg, model) {
		var op = function (m) {
			var nextCounterUpdated = m.iT + 1;
			return _Utils_Tuple2(
				_Utils_update(
					m,
					{iT: nextCounterUpdated}),
				(!(nextCounterUpdated % 10)) ? $author$project$App$Commands$getTodaysActivity : $elm$core$Platform$Cmd$none);
		};
		_v0$2:
		while (true) {
			switch (msg.$) {
				case 8:
					if (msg.a.$ === 4) {
						return op(model);
					} else {
						break _v0$2;
					}
				case 7:
					if (((msg.a.$ === 2) && (msg.a.a.$ === 2)) && (!msg.a.a.a.$)) {
						return op(model);
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$App$Update$updateReviewUponAppBar = F2(
	function (msg, model) {
		_v0$2:
		while (true) {
			if (msg.$ === 4) {
				switch (msg.a.$) {
					case 1:
						var _v1 = msg.a;
						return $author$project$App$Review$Update$unhighlight(model);
					case 2:
						return $author$project$App$Review$Update$unhighlight(model);
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return model;
	});
var $author$project$App$SentenceCore$Update$highlightedForTheSameToken = F2(
	function (model, ind) {
		var getHighlightedToken = function (h) {
			return A2(
				$elm$core$Maybe$andThen,
				function (i) {
					return A2($elm$core$Dict$get, i, model.gW);
				},
				h);
		};
		var cond2 = F2(
			function (tokens, highlightInd) {
				var _v0 = _Utils_Tuple2(
					A2($elm$core$Dict$get, ind, tokens),
					getHighlightedToken(highlightInd));
				if ((!_v0.a.$) && (!_v0.b.$)) {
					var idToken = _v0.a.a;
					var highlightedToken = _v0.b.a;
					return _Utils_eq(idToken.n9, highlightedToken.n9);
				} else {
					return false;
				}
			});
		var cond1 = _Utils_eq(
			model.h9,
			$elm$core$Maybe$Just(ind));
		return cond1 || A2(cond2, model.gW, model.h9);
	});
var $author$project$App$Update$updateSearchUponSentenceCore = F3(
	function (model, msg, srchModel) {
		var sCCond = F2(
			function (id, maybeSCModel) {
				var cond = function (scm) {
					return (!model.jz.hf) && A2($author$project$App$SentenceCore$Update$highlightedForTheSameToken, scm, id);
				};
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2($elm$core$Maybe$map, cond, maybeSCModel));
			});
		_v0$2:
		while (true) {
			switch (msg.$) {
				case 7:
					if ((msg.a.$ === 2) && (!msg.a.a.$)) {
						var hId = msg.a.a.a;
						return A2(sCCond, hId, model.jI.jV) ? _Utils_update(
							srchModel,
							{hf: true}) : srchModel;
					} else {
						break _v0$2;
					}
				case 8:
					if ((msg.a.$ === 6) && (!msg.a.b.$)) {
						var _v1 = msg.a;
						var sId = _v1.a;
						var hId = _v1.b.a;
						return A2(
							sCCond,
							hId,
							A2($elm$core$Dict$get, sId, model.jq.nu)) ? _Utils_update(
							srchModel,
							{hf: true}) : srchModel;
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return srchModel;
	});
var $author$project$App$Sentence$Update$unhighlight = function (model) {
	return _Utils_update(
		model,
		{
			jV: A2($elm$core$Maybe$map, $author$project$App$SentenceCore$Update$updateModelForUnhighlight, model.jV)
		});
};
var $author$project$App$Update$updateSentenceUponAppBar = function (msg) {
	_v0$2:
	while (true) {
		if (msg.$ === 4) {
			switch (msg.a.$) {
				case 1:
					var _v1 = msg.a;
					return $author$project$App$Sentence$Update$unhighlight;
				case 2:
					return $author$project$App$Sentence$Update$unhighlight;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Basics$identity;
};
var $author$project$App$Ring$Model$updateWithNewData = F2(
	function (model, counts) {
		return _Utils_update(
			model,
			{
				eT: $elm$core$Maybe$Just(model.cL),
				cL: counts,
				b9: 0,
				dO: A3(
					$author$project$Models$Ring$makeFrames,
					model.eZ,
					$elm$core$Maybe$Just(model.cL),
					counts)
			});
	});
var $author$project$App$Activity$Update$updateWithTodaysActivity = F2(
	function (model, activity) {
		var mapFnc = function (a) {
			return _Utils_Tuple2(
				A3(
					$elm$core$Dict$insert,
					a.dE,
					_Utils_Tuple2(
						a,
						A2($author$project$App$Ring$Model$init, _List_Nil, a)),
					model.js),
				$elm$core$Maybe$Just(a.dE));
		};
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(model.js, model.hJ),
			A2($elm$core$Maybe$map, mapFnc, activity));
		var rings = _v0.a;
		var currentDate = _v0.b;
		return _Utils_update(
			model,
			{
				hJ: currentDate,
				iR: A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
					A2(
						$elm$core$Maybe$map,
						$author$project$App$Activity$Update$getNavDates(rings),
						currentDate)),
				js: rings,
				j0: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.dE;
					},
					activity)
			});
	});
var $author$project$App$Update$authUpdate = function (model) {
	var route = model.jt;
	var auth = model.hr;
	var requiresAuth = route === 1;
	var isNotLoggedIn = !$author$project$App$Auth$Model$isLoggedIn(model.hr);
	var isAuthRoute = (route === 3) || (route === 2);
	return (isNotLoggedIn && (isAuthRoute || requiresAuth)) ? A2(
		$author$project$App$Update$update,
		$author$project$App$Messages$AuthMsg($author$project$App$Auth$Messages$AuthAttempt),
		model) : _Utils_Tuple2(
		_Utils_update(
			model,
			{
				hr: A2($author$project$App$Auth$Model$update, auth, route)
			}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$App$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var url = msg.a;
				var route = $author$project$Route$parse(url);
				var modelUpdated = _Utils_update(
					model,
					{
						hr: A2($author$project$App$Auth$Model$update, model.hr, route),
						jt: route
					});
				return $author$project$App$Update$authUpdate(modelUpdated);
			case 1:
				var urlRequest = msg.a;
				if (!urlRequest.$) {
					var url = urlRequest.a;
					return _Utils_Tuple2(
						model,
						A2(
							$elm$browser$Browser$Navigation$pushUrl,
							model.it,
							$elm$url$Url$toString(url)));
				} else {
					var href = urlRequest.a;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(href));
				}
			case 2:
				var actMsg = msg.a;
				var _v2 = A2($author$project$App$Activity$Update$update, actMsg, model.hg);
				var actModel = _v2.a;
				var actCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hg: actModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$App$Messages$ActivityMsg, actCmd));
			case 3:
				var authMsg = msg.a;
				var _v3 = A2($author$project$App$Auth$Update$update, authMsg, model.hr);
				var authModel = _v3.a;
				var authCmd = _v3.b;
				var _v4 = A2(
					$author$project$App$Update$authOther,
					_Utils_update(
						model,
						{hr: authModel}),
					authMsg);
				var modelUpdated = _v4.a;
				var cmds = _v4.b;
				return _Utils_Tuple2(
					modelUpdated,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$App$Messages$AuthMsg, authCmd),
								cmds
							])));
			case 4:
				var appBarMsg = msg.a;
				var _v5 = A2($author$project$App$AppBar$Update$update, appBarMsg, model.hp);
				var appBarModel = _v5.a;
				var appBarCmd = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hp: appBarModel,
							jq: A2($author$project$App$Update$updateReviewUponAppBar, appBarMsg, model.jq),
							jI: A2($author$project$App$Update$updateSentenceUponAppBar, appBarMsg, model.jI)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$App$Messages$AppBarMsg, appBarCmd),
								A3($author$project$App$Update$appBarOtherCmds, model, appBarMsg, appBarModel)
							])));
			case 5:
				var landingMsg = msg.a;
				var _v6 = A2($author$project$App$Landing$Update$update, landingMsg, model.iu);
				var landingModel = _v6.a;
				var landingCmd = _v6.b;
				var appMsg = _v6.c;
				var modelWithUpdatedL = _Utils_update(
					model,
					{iu: landingModel});
				var defaultRes = _Utils_Tuple2(
					modelWithUpdatedL,
					A2($elm$core$Platform$Cmd$map, $author$project$App$Messages$LandingMsg, landingCmd));
				var updateWithMsg = function (m) {
					return A2($author$project$App$Update$update, m, modelWithUpdatedL);
				};
				return A2(
					$elm$core$Maybe$withDefault,
					defaultRes,
					A2($elm$core$Maybe$map, updateWithMsg, appMsg));
			case 6:
				var sMsg = msg.a;
				var _v7 = A2($author$project$App$Search$Update$update, sMsg, model.jz);
				var sModel = _v7.a;
				var sCmd = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hp: A2($author$project$App$Update$updateAppBarUponSearch, sMsg, model.hp),
							jz: sModel
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$App$Messages$SearchMsg, sCmd));
			case 7:
				var sMsg = msg.a;
				var _v8 = A2($author$project$App$Sentence$Update$update, sMsg, model.jI);
				var sModel = _v8.a;
				var sCmd = _v8.b;
				var modelUpdated = _Utils_update(
					model,
					{
						hp: A2($author$project$App$Update$updateAppBarUponSentenceCore, msg, model.hp),
						jz: A3($author$project$App$Update$updateSearchUponSentenceCore, model, msg, model.jz),
						jI: sModel
					});
				var _v9 = A2($author$project$App$Update$updateNextCounter, msg, modelUpdated);
				var modelUpdatedUpdated = _v9.a;
				var nextCounterCmd = _v9.b;
				return _Utils_Tuple2(
					modelUpdatedUpdated,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$App$Messages$SentenceMsg, sCmd),
								A4($author$project$App$Update$sentenceOtherCmds, model, sMsg, model.jI, sModel),
								nextCounterCmd
							])));
			case 8:
				var rMsg = msg.a;
				var _v10 = A2($author$project$App$Review$Update$update, rMsg, model.jq);
				var rModel = _v10.a;
				var rCmd = _v10.b;
				var modelUpdated = _Utils_update(
					model,
					{
						hp: A2($author$project$App$Update$updateAppBarUponSentenceCore, msg, model.hp),
						jq: rModel,
						jz: A3($author$project$App$Update$updateSearchUponSentenceCore, model, msg, model.jz)
					});
				var _v11 = A2($author$project$App$Update$updateNextCounter, msg, modelUpdated);
				var modelUpdatedUpdated = _v11.a;
				var nextCounterCmd = _v11.b;
				return _Utils_Tuple2(
					modelUpdatedUpdated,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$App$Messages$ReviewMsg, rCmd),
								A4($author$project$App$Update$reviewOtherCmds, model, rMsg, model.jq, rModel),
								nextCounterCmd
							])));
			case 9:
				if (!msg.a.$) {
					var summary = msg.a.a.nO;
					var modelAppBar = model.hp;
					var activity = $elm$core$List$head(summary);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hg: A2($author$project$App$Activity$Update$updateWithTodaysActivity, model.hg, activity),
								hp: _Utils_update(
									modelAppBar,
									{
										jr: function (f) {
											return A2($elm$core$Maybe$map, f, activity);
										}(
											A2(
												$elm$core$Maybe$withDefault,
												$author$project$App$Ring$Model$init(
													_List_fromArray(
														['block', 'size-8'])),
												A2($elm$core$Maybe$map, $author$project$App$Ring$Model$updateWithNewData, modelAppBar.jr)))
									}),
								j1: activity
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				var modelAppBar = model.hp;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							hg: (model.hp.iS === 1) ? $author$project$App$Activity$Update$updateForTick(model.hg) : model.hg,
							hp: _Utils_update(
								modelAppBar,
								{
									jr: A2($elm$core$Maybe$map, $author$project$App$Ring$Model$updateForTick, modelAppBar.jr)
								})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$App$Activity$Model$init = {
	hJ: $elm$core$Maybe$Nothing,
	iR: _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
	js: $elm$core$Dict$empty,
	j0: $elm$core$Maybe$Nothing
};
var $author$project$Models$Auth$General = 0;
var $author$project$App$Auth$Model$init = function (route) {
	var model = {dN: $elm$core$Maybe$Nothing, go: 0, gN: $author$project$App$Auth$Model$LoggedOut, kd: $elm$core$Maybe$Nothing};
	return _Utils_update(
		model,
		{
			dN: A2($author$project$App$Auth$Model$formByRoute, model, route)
		});
};
var $author$project$App$Landing$Model$init = {iH: false};
var $author$project$App$Review$Model$init = {iE: $elm$core$Maybe$Nothing, nu: $elm$core$Dict$empty, gN: 0, jW: $elm$core$Maybe$Nothing, jX: $elm$core$Maybe$Nothing, gW: _List_Nil, kc: _List_Nil};
var $author$project$App$Kaikki$Model$init = {hW: $elm$core$Dict$empty, ih: $elm$core$Set$empty, ix: $elm$core$Maybe$Nothing, jC: $elm$core$Maybe$Nothing};
var $author$project$App$Search$Model$init = function (withBar) {
	return {hf: false, hO: 0, hP: $elm$core$Maybe$Nothing, is: $author$project$App$Kaikki$Model$init, jy: 0, km: $elm$core$Dict$empty};
};
var $author$project$App$Sentence$Model$init = {ih: $elm$core$Set$empty, iU: _List_Nil, gN: 0, jV: $elm$core$Maybe$Nothing};
var $author$project$App$Model$init = F2(
	function (route, key) {
		return {
			hg: $author$project$App$Activity$Model$init,
			hp: $author$project$App$AppBar$Model$init,
			hr: $author$project$App$Auth$Model$init(route),
			it: key,
			iu: $author$project$App$Landing$Model$init,
			iT: 0,
			jq: $author$project$App$Review$Model$init,
			jt: route,
			jz: $author$project$App$Search$Model$init(true),
			jI: $author$project$App$Sentence$Model$init,
			j1: $elm$core$Maybe$Nothing
		};
	});
var $author$project$App$Update$init = F3(
	function (_v0, url, key) {
		var route = $author$project$Route$parse(url);
		var model = A2($author$project$App$Model$init, route, key);
		return $author$project$App$Update$authUpdate(model);
	});
var $author$project$App$Messages$Tick = function (a) {
	return {$: 10, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {je: processes, jS: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.je;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.jS);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $author$project$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 20, $author$project$App$Messages$Tick)
			]));
};
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$div = _VirtualDom_node('div');
var $author$project$Models$Core$classFromParts = function (parts) {
	return $elm$html$Html$Attributes$class(
		A2($elm$core$String$join, ' ', parts));
};
var $elm$html$Html$footer = _VirtualDom_node('footer');
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$App$AppBar$View$ftr = function (c) {
	var div2ClassParts = _List_fromArray(
		['py-2 text-center text-sm text-gray-400 sm:text-left']);
	var div1ClassParts = _List_fromArray(
		['mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8']);
	var attrs = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (s) {
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class(s)
					]);
			},
			c));
	return A2(
		$elm$html$Html$footer,
		attrs,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Models$Core$classFromParts(div1ClassParts)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Models$Core$classFromParts(div2ClassParts)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('block sm:inline')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('©2025 Nimoza Inc.')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('block sm:inline sm:ml-1')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('All rights reserved.')
									]))
							]))
					]))
			]));
};
var $author$project$App$View$ftr = $author$project$App$AppBar$View$ftr(
	$elm$core$Maybe$Just('hidden md:block border-t border-gray-200'));
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$Models$Core$default = A2($elm$html$Html$div, _List_Nil, _List_Nil);
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $tesk9$accessible_html$Accessibility$Aria$labelledBy = $elm$html$Html$Attributes$attribute('aria-labelledby');
var $author$project$App$View$loading = function () {
	var div4_2 = $elm$html$Html$div(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('col-span-1 h-2 rounded bg-gray-200')
			]));
	var div4_1 = $elm$html$Html$div(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('col-span-2 h-2 rounded bg-gray-200')
			]));
	var div3_2 = $elm$html$Html$div(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('h-2 rounded bg-gray-200')
			]));
	var div3_1 = $elm$html$Html$div(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('grid grid-cols-3 gap-4')
			]));
	var div2_2 = $elm$html$Html$div(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('space-y-3')
			]));
	var div2_1 = $elm$html$Html$div(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('h-2 rounded bg-gray-200')
			]));
	var div1 = $elm$html$Html$div(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex-1 space-y-6 py-1')
			]));
	var div0 = $elm$html$Html$div(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex animate-pulse space-x-4')
			]));
	return div0(
		_List_fromArray(
			[
				div1(
				_List_fromArray(
					[
						div2_1(_List_Nil),
						div2_2(
						_List_fromArray(
							[
								div3_1(
								_List_fromArray(
									[
										div4_1(_List_Nil),
										div4_2(_List_Nil)
									])),
								div3_2(_List_Nil)
							]))
					]))
			]));
}();
var $elm$html$Html$main_ = _VirtualDom_node('main');
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$App$Activity$Messages$ChooseDate = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $tesk9$accessible_html$Accessibility$Utils$aria = A2(
	$elm$core$Basics$composeL,
	$elm$html$Html$Attributes$attribute,
	$elm$core$Basics$append('aria-'));
var $tesk9$accessible_html$Accessibility$Aria$label = $tesk9$accessible_html$Accessibility$Utils$aria('label');
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$Attributes$clipRule = _VirtualDom_attribute('clip-rule');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$Attributes$fillRule = _VirtualDom_attribute('fill-rule');
var $tesk9$accessible_html$Accessibility$Utils$toBoolString = function (bool) {
	return bool ? 'true' : 'false';
};
var $tesk9$accessible_html$Accessibility$Aria$hidden = A2(
	$elm$core$Basics$composeL,
	$tesk9$accessible_html$Accessibility$Utils$aria('hidden'),
	$tesk9$accessible_html$Accessibility$Utils$toBoolString);
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $author$project$Icon$next = function () {
	var dParts = _List_fromArray(
		['M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75', '0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94', '10 8.22 6.28a.75.75 0 0 1 0-1.06Z']);
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class('size-5'),
				$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$tesk9$accessible_html$Accessibility$Aria$hidden(true)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d(
						A2($elm$core$String$join, ' ', dParts))
					]),
				_List_Nil)
			]));
}();
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Icon$previous = function () {
	var dParts = _List_fromArray(
		['M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72', '3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75', '0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z']);
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class('size-5'),
				$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$tesk9$accessible_html$Accessibility$Aria$hidden(true)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d(
						A2($elm$core$String$join, ' ', dParts))
					]),
				_List_Nil)
			]));
}();
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$App$Activity$View$navbar = function (_v0) {
	var prevDate = _v0.a;
	var nextDate = _v0.b;
	var prev = function (date) {
		var baseAttr = _List_fromArray(
			[
				$author$project$Models$Core$classFromParts(
				_List_fromArray(
					['relative inline-flex items-center rounded-l-md px-2 py-2', 'text-gray-400 ring-1 ring-gray-300 ring-inset', 'hover:bg-gray-50 focus:z-20 focus:outline-offset-0', 'disabled:opacity-50 disabled:pointer-events-none'])),
				$elm$html$Html$Attributes$type_('button'),
				$elm$html$Html$Attributes$disabled(
				_Utils_eq(date, $elm$core$Maybe$Nothing))
			]);
		var attr = A2(
			$elm$core$List$append,
			baseAttr,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (d) {
						return _List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$App$Activity$Messages$ChooseDate(d))
							]);
					},
					date)));
		return A2(
			$elm$html$Html$button,
			attr,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sr-only')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Previous')
						])),
					$author$project$Icon$previous
				]));
	};
	var next = function (date) {
		var baseAttr = _List_fromArray(
			[
				$author$project$Models$Core$classFromParts(
				_List_fromArray(
					['relative inline-flex items-center rounded-r-md px-2 py-2', 'text-gray-400 ring-1 ring-gray-300 ring-inset', 'hover:bg-gray-50 focus:z-20 focus:outline-offset-0', 'disabled:opacity-50 disabled:pointer-events-none'])),
				$elm$html$Html$Attributes$type_('button'),
				$elm$html$Html$Attributes$disabled(
				_Utils_eq(date, $elm$core$Maybe$Nothing))
			]);
		var attr = A2(
			$elm$core$List$append,
			baseAttr,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (d) {
						return _List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$App$Activity$Messages$ChooseDate(d))
							]);
					},
					date)));
		return A2(
			$elm$html$Html$button,
			attr,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sr-only')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Next')
						])),
					$author$project$Icon$next
				]));
	};
	return A2(
		$elm$html$Html$nav,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('px-1 py-1 flex flex-1 justify-between'),
				$tesk9$accessible_html$Accessibility$Aria$label('Pagination')
			]),
		_List_fromArray(
			[
				prev(prevDate),
				next(nextDate)
			]));
};
var $author$project$App$Activity$View$viewNumbers = F2(
	function (model, counts) {
		var textFromInts = F2(
			function (some, total) {
				return $elm$core$String$fromInt(some) + (' / ' + $elm$core$String$fromInt(total));
			});
		var makeDataDiv = F2(
			function (title, data) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex justify-between gap-x-4 py-3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gray-500')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-gray-700')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(data)
								]))
						]));
			});
		var dateString = function () {
			var fnc = function (today) {
				return _Utils_eq(counts.dE, today) ? 'today' : counts.dE;
			};
			return A2(
				$elm$core$Maybe$withDefault,
				counts.dE,
				A2($elm$core$Maybe$map, fnc, model.j0));
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('-my-3 divide-y divide-gray-100 px-6 py-4 text-sm/6')
				]),
			_List_fromArray(
				[
					A2(makeDataDiv, 'date', dateString),
					A2(
					makeDataDiv,
					'sentences',
					A2(textFromInts, counts.nv, counts.lG)),
					A2(
					makeDataDiv,
					'words reviewed',
					A2(textFromInts, counts.oh, counts.of))
				]));
	});
var $author$project$App$Activity$Messages$RingMsg = {$: 3};
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $author$project$App$Ring$View$view = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		A2($elm_community$typed_svg$TypedSvg$svg, _List_Nil, _List_Nil),
		A2($elm_community$list_extra$List$Extra$getAt, model.b9, model.dO));
};
var $author$project$App$Activity$View$viewRing = function (rmodel) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center gap-x-4 p-6')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				function (_v0) {
					return $author$project$App$Activity$Messages$RingMsg;
				},
				$author$project$App$Ring$View$view(rmodel))
			]));
};
var $author$project$App$Activity$View$card = F3(
	function (model, counts, rmodel) {
		var content = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('px-4 py-5 sm:p-6')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('overflow-hidden rounded-xl')
						]),
					_List_fromArray(
						[
							$author$project$App$Activity$View$viewRing(rmodel),
							A2($author$project$App$Activity$View$viewNumbers, model, counts)
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Models$Core$classFromParts(
					_List_fromArray(
						['overflow-hidden rounded-lg bg-white', 'ring-1 ring-gray-300']))
				]),
			_List_fromArray(
				[
					content,
					$author$project$App$Activity$View$navbar(model.iR)
				]));
	});
var $author$project$App$Activity$View$view = function (model) {
	var rings = model.js;
	var currentDate = model.hJ;
	return A2(
		$elm$core$Maybe$withDefault,
		A2($elm$html$Html$div, _List_Nil, _List_Nil),
		A2(
			$elm$core$Maybe$map,
			function (_v0) {
				var d = _v0.a;
				var m = _v0.b;
				return A3($author$project$App$Activity$View$card, model, d, m);
			},
			A2(
				$elm$core$Maybe$andThen,
				function (k) {
					return A2($elm$core$Dict$get, k, rings);
				},
				currentDate)));
};
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$Models$Core$fillerMessage = F2(
	function (l1, l2) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-2 text-sm font-semibold text-gray-900')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(l1)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-1 text-sm text-gray-500')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(l2)
						]))
				]));
	});
var $author$project$App$Auth$Messages$SubmitForm = {$: 5};
var $elm$html$Html$form = _VirtualDom_node('form');
var $author$project$Models$Auth$Email = 0;
var $author$project$Models$Auth$Name = 1;
var $author$project$Models$Auth$SentCount = 3;
var $author$project$Models$Auth$formToFieldPairs = function (form) {
	switch (form.$) {
		case 0:
			var email = form.a.ls;
			return _List_fromArray(
				[
					_Utils_Tuple2(0, email)
				]);
		case 1:
			var email = form.a.ls;
			return _List_fromArray(
				[
					_Utils_Tuple2(0, email)
				]);
		case 2:
			var email = form.a.ls;
			var name = form.a.mn;
			return _List_fromArray(
				[
					_Utils_Tuple2(0, email),
					_Utils_Tuple2(1, name)
				]);
		default:
			var words = form.a.oH;
			var sents = form.a.nu;
			return _List_fromArray(
				[
					_Utils_Tuple2(3, sents)
				]);
	}
};
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $author$project$Models$Auth$unchangedDailyGoal = F2(
	function (p, _v0) {
		var words = _v0.oH;
		var sents = _v0.nu;
		return _Utils_eq(
			p.oH,
			$elm$core$String$fromInt(words)) && _Utils_eq(
			p.nu,
			$elm$core$String$fromInt(sents));
	});
var $author$project$App$Auth$View$isDisabledButton = function (_v0) {
	var form = _v0.dN;
	var user = _v0.kd;
	_v1$0:
	while (true) {
		_v1$3:
		while (true) {
			if (!form.$) {
				switch (form.a.a.$) {
					case 2:
						if (form.a.b.$ === 1) {
							break _v1$0;
						} else {
							var _v3 = form.a;
							var f = _v3.a.a;
							return A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									function (n) {
										return _Utils_eq(n, f.mn);
									},
									A2(
										$elm$core$Maybe$andThen,
										function ($) {
											return $.mn;
										},
										user)));
						}
					case 3:
						if (form.a.b.$ === 1) {
							break _v1$0;
						} else {
							var _v4 = form.a;
							var f = _v4.a.a;
							return A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									$author$project$Models$Auth$unchangedDailyGoal(f),
									A2(
										$elm$core$Maybe$andThen,
										function ($) {
											return $.k6;
										},
										user)));
						}
					default:
						if (form.a.b.$ === 1) {
							break _v1$0;
						} else {
							break _v1$3;
						}
				}
			} else {
				break _v1$3;
			}
		}
		return false;
	}
	var _v2 = form.a;
	return true;
};
var $author$project$App$Auth$View$viewButton = function (model) {
	var txt = function () {
		var _v0 = model.dN;
		_v0$2:
		while (true) {
			if (!_v0.$) {
				switch (_v0.a.a.$) {
					case 2:
						var _v1 = _v0.a;
						return 'Update';
					case 3:
						var _v2 = _v0.a;
						return 'Update';
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return 'Next';
	}();
	var classParts = _List_fromArray(
		['flex w-full justify-center rounded-md bg-teal-600 px-3 py-1.5', 'text-sm font-semibold leading-6 text-white shadow-sm', 'hover:bg-teal-500 focus-visible:outline focus-visible:outline-2', 'focus-visible:outline-offset-2 focus-visible:outline-teal-600', 'disabled:opacity-50 disabled:pointer-events-none']);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$author$project$Models$Core$classFromParts(classParts),
						$elm$html$Html$Attributes$type_('submit'),
						$elm$html$Html$Attributes$disabled(
						$author$project$App$Auth$View$isDisabledButton(model))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(txt)
					]))
			]));
};
var $author$project$App$Auth$Messages$UpdateField = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Models$Auth$fieldToString = function (f) {
	switch (f) {
		case 0:
			return 'email';
		case 1:
			return 'full name';
		case 2:
			return 'new words per day';
		default:
			return 'sentencens per day';
	}
};
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $elm$html$Html$input = _VirtualDom_node('input');
var $author$project$App$Auth$View$isDisabledForm = function (_v0) {
	var form = _v0.dN;
	var user = _v0.kd;
	if ((!form.$) && (form.a.b.$ === 1)) {
		var _v2 = form.a;
		return true;
	} else {
		return false;
	}
};
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$App$Auth$View$viewField = F2(
	function (model, _v0) {
		var field = _v0.a;
		var fValue = _v0.b;
		var textFieldType = function () {
			switch (field) {
				case 0:
					return 'email';
				case 1:
					return 'text';
				default:
					return 'number';
			}
		}();
		var placeHolder = function () {
			switch (field) {
				case 0:
					return 'Email';
				case 1:
					return 'Full name';
				case 2:
					return 'Words per day';
				default:
					return 'Sentences per day';
			}
		}();
		var fieldStr = $author$project$Models$Auth$fieldToString(field);
		var fieldROClass = _List_fromArray(
			['bg-gray-100 cursor-not-allowed']);
		var fieldIsRO = function () {
			var _v1 = _Utils_Tuple2(field, model.dN);
			if (((!_v1.a) && (!_v1.b.$)) && (_v1.b.a.a.$ === 2)) {
				var _v2 = _v1.a;
				var _v3 = _v1.b.a;
				return true;
			} else {
				return false;
			}
		}();
		var inputClassParts = A2(
			$elm$core$List$append,
			_List_fromArray(
				['block w-full rounded-md border-0 px-3 py-1.5 text-base text-gray-900', 'outline-1 -outline-offset-1 outline-gray-300', 'placeholder:text-gray-400', 'focus:outline-2 focus:-outline-offset-2 focus:outline-teal-600', 'sm:text-sm/6']),
			fieldIsRO ? fieldROClass : _List_Nil);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(fieldStr),
							$elm$html$Html$Attributes$class('block text-sm font-medium leading-6 text-gray-900')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(placeHolder)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id(fieldStr),
									$elm$html$Html$Attributes$name(fieldStr),
									$elm$html$Html$Attributes$type_(textFieldType),
									$author$project$Models$Core$classFromParts(inputClassParts),
									$elm$html$Html$Events$onInput(
									$author$project$App$Auth$Messages$UpdateField(field)),
									$elm$html$Html$Attributes$disabled(
									fieldIsRO || $author$project$App$Auth$View$isDisabledForm(model)),
									$elm$html$Html$Attributes$value(fValue)
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$App$Auth$View$viewForm = function (model) {
	var fields = A2(
		$elm$core$List$map,
		$author$project$App$Auth$View$viewField(model),
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$author$project$Models$Auth$formToFieldPairs,
				A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.dN))));
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('space-y-6'),
				$elm$html$Html$Events$onSubmit($author$project$App$Auth$Messages$SubmitForm)
			]),
		A2(
			$elm$core$List$append,
			fields,
			_List_fromArray(
				[
					$author$project$App$Auth$View$viewButton(model)
				])));
};
var $author$project$App$Auth$Messages$ChoseProfileSetting = function (a) {
	return {$: 9, a: a};
};
var $author$project$Models$Auth$Goal = 1;
var $tesk9$accessible_html$Accessibility$Aria$currentPage = A2($tesk9$accessible_html$Accessibility$Utils$aria, 'current', 'page');
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$html$Html$select = _VirtualDom_node('select');
var $author$project$App$Auth$View$viewTabs = function (model) {
	var selectClassParts = _List_fromArray(
		['block w-full rounded-md border-gray-300', 'focus:border-teal-500 focus:ring-teal-500']);
	var profileSettingText = function (pS) {
		if (!pS) {
			return 'General';
		} else {
			return 'Daily goal';
		}
	};
	var makeOption = function (pS) {
		return A2(
			$elm$html$Html$option,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					profileSettingText(pS))
				]));
	};
	var makeNavItem = function (pS) {
		var classParts = _List_fromArray(
			['w-1/2 border-b-2 px-1 py-2', 'text-center text-sm font-medium uppercase']);
		var _v0 = _Utils_eq(model.go, pS) ? _Utils_Tuple2(
			_List_fromArray(
				['border-teal-500 text-teal-600']),
			_List_fromArray(
				[$tesk9$accessible_html$Accessibility$Aria$currentPage])) : _Utils_Tuple2(
			_List_fromArray(
				['border-transparent text-gray-500', 'hover:border-gray-300 hover:text-gray-700']),
			_List_Nil);
		var classPartsOther = _v0.a;
		var attrsOther = _v0.b;
		var c = $author$project$Models$Core$classFromParts(
			A2($elm$core$List$append, classParts, classPartsOther));
		var attrs = A2(
			$elm$core$List$cons,
			c,
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Events$onClick(
						$author$project$App$Auth$Messages$ChoseProfileSetting(pS))
					]),
				attrsOther));
		return A2(
			$elm$html$Html$button,
			attrs,
			_List_fromArray(
				[
					$elm$html$Html$text(
					profileSettingText(pS))
				]));
	};
	return (!$author$project$App$Auth$Model$isLoggedIn(model)) ? A2($elm$html$Html$div, _List_Nil, _List_Nil) : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pb-6 uppercase')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hidden')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for('tabs'),
								$elm$html$Html$Attributes$class('sr-only')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Select a tab')
							])),
						A2(
						$elm$html$Html$select,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('tabs'),
								$elm$html$Html$Attributes$name('tabs'),
								$author$project$Models$Core$classFromParts(selectClassParts)
							]),
						A2(
							$elm$core$List$map,
							makeOption,
							_List_fromArray(
								[0, 1])))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('border-b border-gray-200')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$nav,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('-mb-px flex justify-around'),
										$tesk9$accessible_html$Accessibility$Aria$label('Tabs')
									]),
								A2(
									$elm$core$List$map,
									makeNavItem,
									_List_fromArray(
										[0, 1])))
							]))
					]))
			]));
};
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$strokeLinecap = _VirtualDom_attribute('stroke-linecap');
var $elm$svg$Svg$Attributes$strokeLinejoin = _VirtualDom_attribute('stroke-linejoin');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $author$project$Icon$lang = function () {
	var dParts = _List_fromArray(
		['m10.5 21 5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474', '48.474 0 0 1 6-.371m0 0c1.12 0 2.233.038 3.334.114M9', '5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3', '17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589', '8.495a18.023 18.023 0 0 1-3.827-5.802']);
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class('block size-8'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$strokeWidth('1.5'),
				$elm$svg$Svg$Attributes$stroke('currentColor'),
				$tesk9$accessible_html$Accessibility$Aria$hidden(true)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$d(
						A2($elm$core$String$join, ' ', dParts))
					]),
				_List_Nil)
			]));
}();
var $author$project$App$Auth$View$viewTitle = function (_v0) {
	var form = _v0.dN;
	var logo = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mx-auto size-10 text-teal-600')
			]),
		_List_fromArray(
			[$author$project$Icon$lang]));
	var hClassParts = _List_fromArray(
		['mt-6 text-center text-2xl font-bold', 'leading-9 tracking-tight text-gray-900']);
	var _v1 = function () {
		_v2$2:
		while (true) {
			if (!form.$) {
				switch (form.a.a.$) {
					case 0:
						var _v3 = form.a;
						return _Utils_Tuple2('Sign up', true);
					case 1:
						var _v4 = form.a;
						return _Utils_Tuple2('Log in', true);
					default:
						break _v2$2;
				}
			} else {
				break _v2$2;
			}
		}
		return _Utils_Tuple2('', false);
	}();
	var title = _v1.a;
	var withLogo = _v1.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sm:mx-auto sm:w-full sm:max-w-md')
			]),
		_List_fromArray(
			[
				withLogo ? logo : A2($elm$html$Html$div, _List_Nil, _List_Nil),
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						$author$project$Models$Core$classFromParts(hClassParts)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(title)
					]))
			]));
};
var $author$project$App$Auth$View$view = function (model) {
	var borderClass = $author$project$App$Auth$Model$isLoggedIn(model) ? 'ring-1 ring-gray-300' : 'shadow';
	var div0 = function (cmp) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white px-6 py-12 shadow sm:rounded-lg sm:px-12'),
					$elm$html$Html$Attributes$class(borderClass)
				]),
			_List_fromArray(
				[cmp]));
	};
	var card = function () {
		var _v1 = model.dN;
		if (!_v1.$) {
			if (!_v1.a.b.$) {
				var _v2 = _v1.a;
				var _v3 = _v2.b;
				return div0(
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$App$Auth$View$viewTabs(model),
								$author$project$App$Auth$View$viewForm(model)
							])));
			} else {
				if (_v1.a.b.a.$ === 1) {
					var _v4 = _v1.a;
					var _v5 = _v4.b.a;
					return div0(
						A2($author$project$Models$Core$fillerMessage, 'Check your email', 'We have sent you a magic link!'));
				} else {
					var _v6 = _v1.a;
					var e = _v6.b.a.a;
					return div0(
						A2($author$project$Models$Core$fillerMessage, 'Oops...', 'Something is not working. :|'));
				}
			}
		} else {
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		}
	}();
	var _v0 = $author$project$App$Auth$Model$isLoggedIn(model) ? _Utils_Tuple2('flex min-h-full flex-col justify-center sm:px-6 lg:px-8', 'sm:mx-auto sm:w-full sm:max-w-[480px]') : _Utils_Tuple2('flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8', 'mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]');
	var div0C = _v0.a;
	var div1C = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(div0C)
			]),
		_List_fromArray(
			[
				$author$project$App$Auth$Model$isLoggedIn(model) ? A2($elm$html$Html$div, _List_Nil, _List_Nil) : $author$project$App$Auth$View$viewTitle(model),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(div1C)
					]),
				_List_fromArray(
					[card]))
			]));
};
var $author$project$App$Review$Messages$Lookup = function (a) {
	return {$: 3, a: a};
};
var $author$project$App$Review$Messages$Next = function (a) {
	return {$: 4, a: a};
};
var $author$project$App$Review$View$highlightClass = F2(
	function (model, token) {
		return _Utils_eq(
			model.iE,
			$elm$core$Maybe$Just(token)) ? 'underline decoration-2' : 'no-underline';
	});
var $author$project$App$Review$View$loading = function () {
	var div4_2 = $elm$html$Html$div(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('col-span-1 h-2 rounded bg-gray-200')
			]));
	var div4_1 = $elm$html$Html$div(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('col-span-2 h-2 rounded bg-gray-200')
			]));
	var div3_2 = $elm$html$Html$div(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('h-2 rounded bg-gray-200')
			]));
	var div3_1 = $elm$html$Html$div(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('grid grid-cols-3 gap-4')
			]));
	var div2_2 = $elm$html$Html$div(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('space-y-3')
			]));
	var div2_1 = $elm$html$Html$div(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('h-2 rounded bg-gray-200')
			]));
	var div1 = $elm$html$Html$div(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex-1 space-y-6 py-1')
			]));
	var div0 = $elm$html$Html$div(
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex animate-pulse space-x-4')
			]));
	return div0(
		_List_fromArray(
			[
				div1(
				_List_fromArray(
					[
						div2_1(_List_Nil),
						div2_2(
						_List_fromArray(
							[
								div3_1(
								_List_fromArray(
									[
										div4_1(_List_Nil),
										div4_2(_List_Nil)
									])),
								div3_2(_List_Nil)
							]))
					]))
			]));
}();
var $elm$html$Html$dl = _VirtualDom_node('dl');
var $author$project$App$Review$View$rootPoSStandardize = F2(
	function (root, pos) {
		var _v0 = _Utils_Tuple2(root, pos);
		_v0$3:
		while (true) {
			switch (_v0.b) {
				case 'Noun':
					if (_v0.a === 'Du') {
						return _Utils_Tuple2('Pronouns', false);
					} else {
						break _v0$3;
					}
				case 'Pron':
					return _Utils_Tuple2('Pronouns', false);
				case 'Det':
					if (_v0.a === 'sein') {
						return _Utils_Tuple2('Possessive pronouns', false);
					} else {
						break _v0$3;
					}
				default:
					break _v0$3;
			}
		}
		return _Utils_Tuple2(root, true);
	});
var $elm$html$Html$dd = _VirtualDom_node('dd');
var $author$project$App$SentenceCore$View$groupShowTokens = function (pairs) {
	var foldFn = F2(
		function (_v2, acc) {
			var i = _v2.a;
			var st = _v2.b;
			var _v0 = _Utils_Tuple2(acc, st.h1);
			if (!_v0.a.b) {
				return A2(
					$elm$core$List$cons,
					_List_fromArray(
						[
							_Utils_Tuple2(i, st)
						]),
					acc);
			} else {
				if (_v0.b) {
					return A2(
						$elm$core$List$cons,
						_List_fromArray(
							[
								_Utils_Tuple2(i, st)
							]),
						acc);
				} else {
					var _v1 = _v0.a;
					var lastST = _v1.a;
					var restSTs = _v1.b;
					return A2(
						$elm$core$List$cons,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(i, st),
							lastST),
						restSTs);
				}
			}
		});
	return A3($elm$core$List$foldr, foldFn, _List_Nil, pairs);
};
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$App$SentenceCore$Messages$Highlight = function (a) {
	return {$: 0, a: a};
};
var $author$project$App$SentenceCore$View$viewToken = function (_v0) {
	var ind = _v0.a;
	var t = _v0.b;
	var highlightClass = t.h9 ? 'underline decoration-2' : 'no-underline';
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$App$SentenceCore$Messages$Highlight(ind)),
				A2($elm$html$Html$Attributes$style, 'margin-bottom', '3px'),
				$elm$html$Html$Attributes$class(highlightClass)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(t.n9)
			]));
};
var $author$project$App$SentenceCore$View$viewTokens = function (pairs) {
	var spaceSpan = A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('\u00A0')
			]));
	var foldFn = F2(
		function (_v1, acc) {
			var i = _v1.a;
			var st = _v1.b;
			var tokenSpan = $author$project$App$SentenceCore$View$viewToken(
				_Utils_Tuple2(i, st));
			var _v0 = _Utils_Tuple2(acc, st.h1);
			if ((!_v0.a.b) && _v0.b) {
				return A2(
					$elm$core$List$cons,
					tokenSpan,
					A2($elm$core$List$cons, spaceSpan, acc));
			} else {
				return A2($elm$core$List$cons, tokenSpan, acc);
			}
		});
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'white-space', 'nowrap')
			]),
		A3($elm$core$List$foldr, foldFn, _List_Nil, pairs));
};
var $author$project$App$SentenceCore$View$view = function (_v0) {
	var tokens = _v0.gW;
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-base font-light'),
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'flex-wrap', 'wrap')
			]),
		A2(
			$elm$core$List$map,
			$author$project$App$SentenceCore$View$viewTokens,
			$author$project$App$SentenceCore$View$groupShowTokens(
				$elm$core$Dict$toList(tokens))));
};
var $author$project$App$Review$View$viewUseCase = F3(
	function (model, token, tokenPair) {
		var tokenOther = _Utils_eq(tokenPair.hF.n9, token) ? tokenPair.mU : tokenPair.hF;
		var makeItem = function (s) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Models$Core$classFromParts(
						_List_fromArray(
							['px-4 py-3 sm:grid sm:grid-cols-8', 'sm:gap-4 sm:px-0']))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$dd,
						_List_fromArray(
							[
								$author$project$Models$Core$classFromParts(
								_List_fromArray(
									['mt-1 text-sm/6 text-gray-700', 'sm:col-span-7 sm:mt-0']))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$App$Review$Messages$SentenceCoreMsg(s.nr.fn),
								$author$project$App$SentenceCore$View$view(s))
							]))
					]));
		};
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Models$Core$default,
			A2(
				$elm$core$Maybe$map,
				makeItem,
				A2(
					$elm$core$Maybe$andThen,
					function (id) {
						return A2($elm$core$Dict$get, id, model.nu);
					},
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.fn;
						},
						$elm$core$List$head(tokenPair.nu)))));
	});
var $author$project$App$Review$View$viewUseCaseGroup = F3(
	function (model, token, _v0) {
		var _v1 = _v0.a;
		var root = _v1.a;
		var pos = _v1.b;
		var tokenPairs = _v0.b;
		var _v2 = A2($author$project$App$Review$View$rootPoSStandardize, root, pos);
		var secondWord = _v2.a;
		var isClickable = _v2.b;
		var secondWordAttr = function () {
			var baseClassParts = _List_fromArray(
				['text-base/7 font-normal text-gray-900']);
			return isClickable ? _List_fromArray(
				[
					$author$project$Models$Core$classFromParts(
					A2(
						$elm$core$List$cons,
						A2($author$project$App$Review$View$highlightClass, model, secondWord),
						baseClassParts)),
					$elm$html$Html$Events$onClick(
					$author$project$App$Review$Messages$Lookup(secondWord))
				]) : _List_fromArray(
				[
					$author$project$Models$Core$classFromParts(baseClassParts)
				]);
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-base font-light')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('px-4 sm:px-0')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-base/7 font-thin text-gray-900')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Commonly used with: ')
								])),
							A2(
							$elm$html$Html$span,
							secondWordAttr,
							_List_fromArray(
								[
									$elm$html$Html$text(secondWord)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$dl,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A2($author$project$App$Review$View$viewUseCase, model, token),
								tokenPairs))
						]))
				]));
	});
var $author$project$App$Review$View$card = F3(
	function (model, _v0, mUC) {
		var token = _v0.n9;
		var header = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('border-b border-gray-200 bg-white px-4 py-5 sm:px-6')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$author$project$Models$Core$classFromParts(
							_List_fromArray(
								[
									'text-base font-semibold text-gray-900',
									A2($author$project$App$Review$View$highlightClass, model, token)
								])),
							$elm$html$Html$Events$onClick(
							$author$project$App$Review$Messages$Lookup(token))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(token)
						]))
				]));
		var content = function () {
			var c = (!(!model.gN)) ? $author$project$App$Review$View$loading : A2(
				$elm$core$Maybe$withDefault,
				$author$project$Models$Core$default,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$App$Review$View$viewUseCaseGroup, model, token),
					mUC));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('px-4 py-5 sm:p-6')
					]),
				_List_fromArray(
					[c]));
		}();
		var actions = function () {
			var _v1 = _Utils_eq(model.kc, _List_Nil) ? _Utils_Tuple2(
				$author$project$App$Review$Messages$Next(
					$elm$core$Maybe$Just(token)),
				'next') : _Utils_Tuple2(
				$author$project$App$Review$Messages$Next($elm$core$Maybe$Nothing),
				'next use case group');
			var action = _v1.a;
			var actionTxt = _v1.b;
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$author$project$Models$Core$classFromParts(
						_List_fromArray(
							['rounded-md bg-white px-3 py-1.5', 'text-sm font-semibold text-gray-900', 'shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-50', 'disabled:opacity-50 disabled:pointer-events-none disabled:hidden'])),
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Events$onClick(action),
						$elm$html$Html$Attributes$disabled(!(!model.gN))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(actionTxt)
					]));
		}();
		var navbar = function () {
			var classParts = _List_fromArray(
				['flex items-center justify-between', 'bg-white px-4 pb-5 sm:px-6']);
			return A2(
				$elm$html$Html$nav,
				_List_fromArray(
					[
						$author$project$Models$Core$classFromParts(classParts),
						$tesk9$accessible_html$Accessibility$Aria$label('Pagination')
					]),
				_List_fromArray(
					[actions]));
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('overflow-hidden rounded-lg bg-white ring-1 ring-gray-300')
				]),
			_List_fromArray(
				[header, content, navbar]));
	});
var $author$project$App$Review$View$view = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Models$Core$default,
		A2(
			$elm$core$Maybe$map,
			function (t) {
				return A3($author$project$App$Review$View$card, model, t, model.jX);
			},
			model.jW));
};
var $author$project$App$Search$Messages$Toggle = function (a) {
	return {$: 3, a: a};
};
var $author$project$App$Search$View$overlay = function (active) {
	return active ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fixed inset-0 bg-black/20 md:hidden'),
				$elm$html$Html$Events$onClick(
				$author$project$App$Search$Messages$Toggle(false))
			]),
		_List_Nil) : A2($elm$html$Html$div, _List_Nil, _List_Nil);
};
var $author$project$App$Search$Messages$Scrolled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Models$Core$onScroll = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'scroll',
		A2(
			$elm$json$Json$Decode$map,
			tagger,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['target', 'scrollTop']),
				$elm$json$Json$Decode$int)));
};
var $author$project$Models$Kaikki$keyFromLangs = function (langs) {
	if (!langs.a) {
		if (langs.b === 1) {
			var _v1 = langs.a;
			var _v2 = langs.b;
			return $elm$core$Maybe$Just('de:German');
		} else {
			var _v3 = langs.a;
			var _v4 = langs.b;
			return $elm$core$Maybe$Just('de:Deutsch');
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $aforemny$material_components_web_elm$Material$Typography$body1 = $elm$html$Html$Attributes$class('mdc-typography--body1');
var $aforemny$material_components_web_elm$Material$Typography$caption = $elm$html$Html$Attributes$class('mdc-typography--caption');
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $aforemny$material_components_web_elm$Material$Typography$body2 = $elm$html$Html$Attributes$class('mdc-typography--body2');
var $author$project$Util$brackets = F2(
	function (c, s) {
		switch (c) {
			case '(':
				return '(' + (s + ')');
			case '{':
				return '{' + (s + '}');
			case '[':
				return '[' + (s + ']');
			case '<':
				return '<' + (s + '>');
			default:
				return s;
		}
	});
var $author$project$App$Kaikki$View$viewExamples = function (examples) {
	var makeRef = function (ref) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'color', '#a0a0a0'),
					A2($elm$html$Html$Attributes$style, 'margin-left', '3px')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Util$brackets, '(', ref))
				]));
	};
	var makeMain = function (example) {
		return $elm$core$Maybe$Just(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'font-weight', '300')
					]),
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$Maybe$Just(
							$elm$html$Html$text(example.nW)),
							A2($elm$core$Maybe$map, makeRef, example.m3)
						]))));
	};
	var makeLangHeader = A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'font-weight', '400'),
				A2($elm$html$Html$Attributes$style, 'margin-right', '2px'),
				$aforemny$material_components_web_elm$Material$Typography$caption
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('+')
			]));
	var makeEnglish = function (example) {
		var _v0 = example.lu;
		if (!_v0.$) {
			var eng = _v0.a;
			return $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'font-weight', '100')
						]),
					_List_fromArray(
						[
							makeLangHeader,
							$elm$html$Html$text(eng)
						])));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	var makeExample = function (example) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'list-style-type', 'circle'),
					$aforemny$material_components_web_elm$Material$Typography$body2
				]),
			A2(
				$elm$core$List$filterMap,
				function (fnc) {
					return fnc(example);
				},
				_List_fromArray(
					[makeMain, makeEnglish])));
	};
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'padding-left', '25px')
					]),
				A2($elm$core$List$map, makeExample, examples))
			]));
};
var $author$project$App$Kaikki$View$viewGloss = function (_v0) {
	var qualifier = _v0.mY;
	var glosses = _v0.lF;
	var rawGlosses = _v0.m$;
	var qualifierPart = function () {
		if (!qualifier.$) {
			var q = qualifier.a;
			return $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$aforemny$material_components_web_elm$Material$Typography$body2,
							A2($elm$html$Html$Attributes$style, 'margin-right', '3px'),
							A2($elm$html$Html$Attributes$style, 'font-weight', '300')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(q + ': ')
						])));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var makeBase = function (gs) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[$aforemny$material_components_web_elm$Material$Typography$body2]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($elm$core$String$join, '; ', gs))
				]));
	};
	var _v1 = _Utils_Tuple2(glosses, rawGlosses);
	if (!_v1.b.$) {
		var rg = _v1.b.a;
		return $elm$core$Maybe$Just(
			makeBase(rg));
	} else {
		if (!_v1.a.$) {
			var g = _v1.a.a;
			return $elm$core$Maybe$Just(
				A2(
					$elm$html$Html$span,
					_List_Nil,
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								qualifierPart,
								$elm$core$Maybe$Just(
								makeBase(g))
							]))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$App$Kaikki$View$viewRelationships = F3(
	function (model, title, rels) {
		var viewRel = function (_v1) {
			var word = _v1.kl;
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$aforemny$material_components_web_elm$Material$Typography$body2,
						A2($elm$html$Html$Attributes$style, 'word-wrap', 'normal'),
						A2($elm$html$Html$Attributes$style, 'white-space', 'normal')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(word)
					]));
		};
		var separator = A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(', ')
				]));
		var filterFnc = function (_v0) {
			var word = _v0.kl;
			return word !== ';';
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					title,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-left', '10px')
						]),
					A2(
						$elm$core$List$intersperse,
						separator,
						A2(
							$elm$core$List$map,
							viewRel,
							A2(
								$elm$core$List$sortBy,
								function ($) {
									return $.kl;
								},
								A2($elm$core$List$filter, filterFnc, rels)))))
				]));
	});
var $aforemny$material_components_web_elm$Material$Typography$overline = $elm$html$Html$Attributes$class('mdc-typography--overline');
var $author$project$App$Kaikki$View$viewSenseSubTitle = function (title) {
	var spanConfig = _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
			A2($elm$html$Html$Attributes$style, 'z-index', '1'),
			A2($elm$html$Html$Attributes$style, 'top', '0'),
			A2($elm$html$Html$Attributes$style, 'left', '-19px'),
			A2($elm$html$Html$Attributes$style, 'margin-top', '-5px'),
			A2($elm$html$Html$Attributes$style, 'display', 'flex'),
			A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
			A2($elm$html$Html$Attributes$style, 'background', 'white'),
			A2($elm$html$Html$Attributes$style, 'display', 'block'),
			A2($elm$html$Html$Attributes$style, 'font-size', '7px')
		]);
	var divConfig = _List_fromArray(
		[
			$aforemny$material_components_web_elm$Material$Typography$overline,
			A2($elm$html$Html$Attributes$style, 'font-weight', '100'),
			A2($elm$html$Html$Attributes$style, 'position', 'relative')
		]);
	return A2(
		$elm$html$Html$div,
		divConfig,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				spanConfig,
				_List_fromArray(
					[
						$elm$html$Html$text(title)
					]))
			]));
};
var $author$project$App$Kaikki$View$viewBody = F2(
	function (model, entity) {
		var viewRel = function (t) {
			return A2(
				$author$project$App$Kaikki$View$viewRelationships,
				model,
				$author$project$App$Kaikki$View$viewSenseSubTitle(t));
		};
		var makeItemBase = function (elems) {
			return A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'list-style-type', 'decimal'),
						$aforemny$material_components_web_elm$Material$Typography$caption,
						A2($elm$html$Html$Attributes$style, 'font-size', '10px')
					]),
				_List_fromArray(
					[
						A2($elm$html$Html$div, _List_Nil, elems)
					]));
		};
		var makeItem = function (s) {
			return makeItemBase(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$author$project$App$Kaikki$View$viewGloss(s),
							A2($elm$core$Maybe$map, $author$project$App$Kaikki$View$viewExamples, s.ly),
							A2(
							$elm$core$Maybe$map,
							viewRel('Syn'),
							s.jR),
							A2(
							$elm$core$Maybe$map,
							viewRel('Ant'),
							s.ho)
						])));
		};
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'padding-left', '20px')
				]),
			A2(
				$elm$core$List$map,
				makeItem,
				A2($elm$core$Maybe$withDefault, _List_Nil, entity.np)));
	});
var $elm$core$String$append = _String_append;
var $author$project$App$Kaikki$View$formatAdjDeps = function (_v0) {
	var comparative = _v0.k$;
	var superlative = _v0.nP;
	var op = $elm$core$Maybe$map(
		$elm$core$String$append('| '));
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					op(comparative),
					op(superlative)
				])));
};
var $author$project$Models$Kaikki$formatGenders = function (genders) {
	var formatGender = function (g) {
		switch (g) {
			case 0:
				return 'f';
			case 1:
				return 'm';
			default:
				return 'n';
		}
	};
	return A2(
		$author$project$Util$brackets,
		'{',
		A2(
			$elm$core$String$join,
			',',
			A2($elm$core$List$map, formatGender, genders)));
};
var $author$project$Models$Kaikki$formatPlurals = function (plurals) {
	return A2($elm$core$String$join, ' or ', plurals);
};
var $author$project$App$Kaikki$View$formatNounDeps = function (_v0) {
	var gender = _v0.h4;
	var plural = _v0.mM;
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2($elm$core$Maybe$map, $author$project$Models$Kaikki$formatGenders, gender),
					A2($elm$core$Maybe$map, $author$project$Models$Kaikki$formatPlurals, plural)
				])));
};
var $author$project$Models$Kaikki$formatVerbCat = function (cat) {
	switch (cat) {
		case 0:
			return 'weak';
		case 1:
			return 'strong';
		default:
			return 'irregular';
	}
};
var $author$project$Models$Kaikki$formatVerbCats = function (cats) {
	return A2(
		$elm$core$String$join,
		',',
		A2($elm$core$List$map, $author$project$Models$Kaikki$formatVerbCat, cats));
};
var $author$project$App$Kaikki$View$formatVerbDeps = function (_v0) {
	var category = _v0.kQ;
	var present3S = _v0.mQ;
	var preterite = _v0.mS;
	var pastParticiple = _v0.mJ;
	var auxiliaryVerb = _v0.kH;
	var cond = function (s) {
		return $elm$core$List$length(
			A2($elm$core$String$split, ' ', s)) <= 2;
	};
	var conjParts = A2(
		$elm$core$List$filter,
		cond,
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$List$head(present3S),
					$elm$core$List$head(preterite),
					$elm$core$List$head(pastParticiple)
				])));
	var conjStr = ($elm$core$List$length(conjParts) > 0) ? $elm$core$Maybe$Just(
		A2($elm$core$String$join, ', ', conjParts)) : $elm$core$Maybe$Nothing;
	var catStr = A2($elm$core$Maybe$map, $author$project$Models$Kaikki$formatVerbCats, category);
	var catConjSep = function () {
		var _v1 = _Utils_Tuple2(catStr, conjStr);
		if ((!_v1.a.$) && (!_v1.b.$)) {
			return $elm$core$Maybe$Just(': ');
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var auxStr = ($elm$core$List$length(auxiliaryVerb) > 0) ? $elm$core$Maybe$Just(
		A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					'mit',
					A2($elm$core$String$join, '/', auxiliaryVerb)
				]))) : $elm$core$Maybe$Nothing;
	return A2(
		$elm$core$String$join,
		'',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					$author$project$Util$brackets('('),
					auxStr),
					$elm$core$Maybe$Just(' '),
					catStr,
					catConjSep,
					conjStr
				])));
};
var $author$project$App$Kaikki$View$formatHeadline = function (wdep) {
	if (!wdep.$) {
		switch (wdep.a.$) {
			case 0:
				var deps = wdep.a.a;
				return $author$project$App$Kaikki$View$formatNounDeps(deps);
			case 1:
				var deps = wdep.a.a;
				return $author$project$App$Kaikki$View$formatVerbDeps(deps);
			default:
				var deps = wdep.a.a;
				return $author$project$App$Kaikki$View$formatAdjDeps(deps);
		}
	} else {
		return '';
	}
};
var $author$project$Models$Kaikki$gendersToColor = function (gs) {
	var colorMapping = function (g) {
		switch (g) {
			case 0:
				return 'rgb(254, 244, 168)';
			case 1:
				return 'rgb(235, 193, 84)';
			default:
				return 'rgb(175, 212, 171)';
		}
	};
	if (gs.b && (!gs.b.b)) {
		var g = gs.a;
		return colorMapping(g);
	} else {
		return 'white';
	}
};
var $author$project$App$Kaikki$View$wordBgColor = function (dep) {
	if ((!dep.$) && (!dep.a.$)) {
		var gender = dep.a.a.h4;
		return A2(
			$elm$core$Maybe$withDefault,
			'transparent',
			A2($elm$core$Maybe$map, $author$project$Models$Kaikki$gendersToColor, gender));
	} else {
		return 'transparent';
	}
};
var $author$project$App$Kaikki$View$viewTitle = F2(
	function (word, dep) {
		var main = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$style,
					'background-color',
					$author$project$App$Kaikki$View$wordBgColor(dep)),
					A2($elm$html$Html$Attributes$style, 'font-size', '18px'),
					$aforemny$material_components_web_elm$Material$Typography$body1,
					A2($elm$html$Html$Attributes$style, 'margin-right', '5px'),
					A2($elm$html$Html$Attributes$style, 'font-weight', '500')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(word)
				]));
		var headline = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$aforemny$material_components_web_elm$Material$Typography$body1,
					A2($elm$html$Html$Attributes$style, 'color', '#a0a0a0'),
					A2($elm$html$Html$Attributes$style, 'font-weight', '400')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$App$Kaikki$View$formatHeadline(dep))
				]));
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'position', 'relative'),
					A2($elm$html$Html$Attributes$style, 'z-index', '2')
				]),
			_List_fromArray(
				[main, headline]));
	});
var $author$project$App$Kaikki$View$viewCard = F2(
	function (model, depEntity) {
		var dep = depEntity.lg;
		var entity = depEntity.lv;
		var makeTitle = function (t) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$aforemny$material_components_web_elm$Material$Typography$body1,
						A2($elm$html$Html$Attributes$style, 'font-size', '14px'),
						A2($elm$html$Html$Attributes$style, 'margin-right', '5px'),
						A2($elm$html$Html$Attributes$style, 'font-weight', '300')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('[ ' + (t + ' ]'))
					]));
		};
		var viewRel = function (t) {
			return A2(
				$author$project$App$Kaikki$View$viewRelationships,
				model,
				makeTitle(t));
		};
		var content = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('px-2 py-1')
				]),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						A2($author$project$App$Kaikki$View$viewTitle, entity.kl, dep)),
						$elm$core$Maybe$Just(
						A2($author$project$App$Kaikki$View$viewBody, model, entity)),
						A2(
						$elm$core$Maybe$map,
						viewRel('Synonyms'),
						entity.jR),
						A2(
						$elm$core$Maybe$map,
						viewRel('Antonyms'),
						entity.ho),
						A2(
						$elm$core$Maybe$map,
						viewRel('Related'),
						entity.m5),
						A2(
						$elm$core$Maybe$map,
						viewRel('Derived'),
						entity.li)
					])));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('divide-y divide-gray-200 overflow-hidden rounded-lg bg-white'),
					$elm$html$Html$Attributes$class('ring-1 ring-gray-300')
				]),
			_List_fromArray(
				[content]));
	});
var $author$project$App$Kaikki$View$viewPos = function (poss) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$aforemny$material_components_web_elm$Material$Typography$overline,
				A2($elm$html$Html$Attributes$style, 'font-weight', '100'),
				A2($elm$html$Html$Attributes$style, 'position', 'relative')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($elm$core$String$join, ', ', poss))
					]))
			]));
};
var $author$project$App$Kaikki$Messages$ChoseLang = function (a) {
	return {$: 1, a: a};
};
var $author$project$App$Kaikki$View$viewTabs = function (model) {
	var txt = function (langs) {
		if (!langs.b) {
			var _v2 = langs.b;
			return 'de';
		} else {
			var _v3 = langs.b;
			return 'en';
		}
	};
	var selectClassParts = _List_fromArray(
		['block w-full rounded-md border-gray-300', 'focus:border-teal-500 focus:ring-teal-500']);
	var makeOption = function (langs) {
		return A2(
			$elm$html$Html$option,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					txt(langs))
				]));
	};
	var makeNavItem = function (langs) {
		var classParts = _List_fromArray(
			['w-1/4 border-b-2 px-1 py-4', 'text-center text-sm font-medium uppercase']);
		var _v0 = _Utils_eq(
			model.ix,
			$elm$core$Maybe$Just(langs)) ? _Utils_Tuple2(
			_List_fromArray(
				['border-teal-500 text-teal-600']),
			_List_fromArray(
				[$tesk9$accessible_html$Accessibility$Aria$currentPage])) : _Utils_Tuple2(
			_List_fromArray(
				['border-transparent text-gray-500', 'hover:border-gray-300 hover:text-gray-700']),
			_List_Nil);
		var classPartsOther = _v0.a;
		var attrsOther = _v0.b;
		var c = $author$project$Models$Core$classFromParts(
			A2($elm$core$List$append, classParts, classPartsOther));
		var attrs = A2(
			$elm$core$List$cons,
			c,
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Events$onClick(
						$author$project$App$Kaikki$Messages$ChoseLang(langs))
					]),
				attrsOther));
		return A2(
			$elm$html$Html$button,
			attrs,
			_List_fromArray(
				[
					$elm$html$Html$text(
					txt(langs))
				]));
	};
	var availableLangs = A2(
		$elm$core$List$filterMap,
		$author$project$Models$Kaikki$keyToLangs,
		$elm$core$Dict$keys(model.hW));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('py-2 uppercase')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hidden')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for('tabs'),
								$elm$html$Html$Attributes$class('sr-only')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Select a tab')
							])),
						A2(
						$elm$html$Html$select,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('tabs'),
								$elm$html$Html$Attributes$name('tabs'),
								$author$project$Models$Core$classFromParts(selectClassParts)
							]),
						A2($elm$core$List$map, makeOption, availableLangs))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('border-b border-gray-200')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$nav,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('-mb-px flex justify-around'),
										$tesk9$accessible_html$Accessibility$Aria$label('Tabs')
									]),
								A2($elm$core$List$map, makeNavItem, availableLangs))
							]))
					]))
			]));
};
var $author$project$App$Kaikki$View$view = function (model) {
	var posedCard = function (depEnt) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$App$Kaikki$View$viewPos(depEnt.lv.mO),
					A2($author$project$App$Kaikki$View$viewCard, model, depEnt)
				]));
	};
	var withTabs = function (k) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$App$Kaikki$View$viewTabs(model),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							$elm$core$List$map(posedCard),
							A2($elm$core$Dict$get, k, model.hW))))
				]));
	};
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Models$Core$default,
		A2(
			$elm$core$Maybe$map,
			withTabs,
			A2($elm$core$Maybe$andThen, $author$project$Models$Kaikki$keyFromLangs, model.ix)));
};
var $author$project$App$Search$View$panelContent = function (_v0) {
	var kaikki = _v0.is;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Models$Core$classFromParts(
				_List_fromArray(
					['absolute top-0 right-0 left-0', 'overflow-y-auto p-4 pb-8 h-full'])),
				A2($elm$html$Html$Attributes$style, '-webkit-overflow-scrolling', 'touch'),
				A2($elm$html$Html$Attributes$style, 'overscroll-behavior', 'contain'),
				$author$project$Models$Core$onScroll($author$project$App$Search$Messages$Scrolled)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$App$Search$Messages$KaikkiMsg,
				$author$project$App$Kaikki$View$view(kaikki))
			]));
};
var $author$project$Icon$menuOpen = function (open) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(
				open ? 'block' : 'hidden'),
				$elm$svg$Svg$Attributes$class('size-6'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$strokeWidth('1.5'),
				$elm$svg$Svg$Attributes$stroke('currentColor'),
				$tesk9$accessible_html$Accessibility$Aria$hidden(true)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$d('M6 18L18 6M6 6l12 12')
					]),
				_List_Nil)
			]));
};
var $author$project$App$Search$View$scrollToShadow = function (s) {
	return (s < 25) ? '' : 'shadow-md';
};
var $author$project$App$Search$View$panelHeader = function (model) {
	var kaikki = model.is;
	var scrollTop = model.jy;
	var condAttr = model.hf ? _List_fromArray(
		[
			$author$project$Models$Core$classFromParts(
			_List_fromArray(
				[
					'pointer-events-none',
					$author$project$App$Search$View$scrollToShadow(scrollTop)
				]))
		]) : _List_fromArray(
		[
			$elm$html$Html$Events$onClick(
			$author$project$App$Search$Messages$Toggle(true)),
			A2($elm$html$Html$Attributes$style, 'box-shadow', '0 -4px 10px rgba(0, 0, 0, 0.1)'),
			$elm$html$Html$Attributes$class('ring-1')
		]);
	var baseAttr = $author$project$Models$Core$classFromParts(
		_List_fromArray(
			['relative -translate-y-full z-50 flex bg-white max-w-3xl', 'items-center justify-center px-4 py-5 rounded-t-lg']));
	var attrs = A2($elm$core$List$cons, baseAttr, condAttr);
	return A2(
		$elm$html$Html$div,
		attrs,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('absolute w-8 left-0')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('absolute shrink-0 text-center font-semibold text-md')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($elm$core$Maybe$withDefault, '', kaikki.jC))
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$author$project$Models$Core$classFromParts(
						_List_fromArray(
							['absolute right-0 px-2 shrink-0 text-gray-500', 'hover:text-gray-700 focus:outline-none'])),
						$elm$html$Html$Attributes$type_('button'),
						$elm$html$Html$Events$onClick(
						$author$project$App$Search$Messages$Toggle(false)),
						A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Close panel')
					]),
				_List_fromArray(
					[
						$author$project$Icon$menuOpen(model.hf)
					]))
			]));
};
var $author$project$App$Search$View$slidablePanel = function (model) {
	var dragOffsetY = model.hO;
	var active = model.hf;
	var dragTransform = active ? 'translate-y-0' : 'translate-y-full';
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Models$Core$classFromParts(
				_List_fromArray(
					['fixed bg-white right-0 bottom-0 z-40', 'transform transition ease-in-out duration-500 sm:duration-700', 'w-full h-[80dvh] shadow-md md:hidden', dragTransform]))
			]),
		_List_fromArray(
			[
				$author$project$App$Search$View$panelHeader(model),
				$author$project$App$Search$View$panelContent(model)
			]));
};
var $author$project$App$Search$View$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('relative z-10 md:hidden')
					]),
				_List_fromArray(
					[
						$author$project$App$Search$View$overlay(model.hf),
						$author$project$App$Search$View$slidablePanel(model)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('hidden overflow-hidden rounded-lg bg-white shadow-sm md:block')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('p-6')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$App$Search$Messages$KaikkiMsg,
								$author$project$App$Kaikki$View$view(model.is))
							]))
					]))
			]));
};
var $author$project$App$SentenceCore$Messages$PostExposure = function (a) {
	return {$: 1, a: a};
};
var $author$project$App$Sentence$View$view = function (model) {
	var content = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('px-4 py-5 sm:p-6')
			]),
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					$elm$html$Html$map($author$project$App$Sentence$Messages$SentenceCoreMsg),
					A2($elm$core$Maybe$map, $author$project$App$SentenceCore$View$view, model.jV))
				])));
	var actions = function (thisSent) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$author$project$Models$Core$classFromParts(
					_List_fromArray(
						['rounded-md bg-white px-3 py-1.5', 'text-sm font-semibold text-gray-900', 'shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-50'])),
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Events$onClick(
					$author$project$App$Sentence$Messages$SentenceCoreMsg(
						$author$project$App$SentenceCore$Messages$PostExposure(thisSent.fn)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('next')
				]));
	};
	var navbar = function () {
		var classParts = _List_fromArray(
			['flex items-center justify-between', 'bg-white px-4 pb-5 sm:px-6']);
		return A2(
			$elm$html$Html$nav,
			_List_fromArray(
				[
					$author$project$Models$Core$classFromParts(classParts),
					$tesk9$accessible_html$Accessibility$Aria$label('Pagination')
				]),
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					$author$project$Models$Core$default,
					A2(
						$elm$core$Maybe$map,
						actions,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.nr;
							},
							model.jV)))
				]));
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Models$Core$classFromParts(
				_List_fromArray(
					['overflow-hidden rounded-lg bg-white', 'ring-1 ring-gray-300']))
			]),
		_List_fromArray(
			[content, navbar]));
};
var $author$project$App$View$mn = function (model) {
	var withSearchResults = !_Utils_eq(model.jz.is.hW, $elm$core$Dict$empty);
	var searchIsVisible = !model.hp.iS;
	var right = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('grid grid-cols-1 gap-4 lg:col-span-2'),
				searchIsVisible ? $elm$html$Html$Attributes$class('block') : $elm$html$Html$Attributes$class('hidden')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$tesk9$accessible_html$Accessibility$Aria$labelledBy('section-2-title')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sr-only'),
								$elm$html$Html$Attributes$id('section-2-title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Section title')
							])),
						A2(
						$elm$html$Html$map,
						$author$project$App$Messages$SearchMsg,
						$author$project$App$Search$View$view(model.jz))
					]))
			]));
	var makeDiv = function (comp) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('overflow-hidden rounded-lg bg-white shadow-sm')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('p-6')
						]),
					_List_fromArray(
						[comp]))
				]));
	};
	var contentByNav = function () {
		var _v0 = model.hp.iS;
		switch (_v0) {
			case 0:
				return (!_Utils_eq(model.jq.jW, $elm$core$Maybe$Nothing)) ? A2(
					$elm$html$Html$map,
					$author$project$App$Messages$ReviewMsg,
					$author$project$App$Review$View$view(model.jq)) : ((!_Utils_eq(model.jI.jV, $elm$core$Maybe$Nothing)) ? A2(
					$elm$html$Html$map,
					$author$project$App$Messages$SentenceMsg,
					$author$project$App$Sentence$View$view(model.jI)) : $author$project$App$View$loading);
			case 2:
				return A2(
					$elm$html$Html$map,
					$author$project$App$Messages$AuthMsg,
					$author$project$App$Auth$View$view(model.hr));
			default:
				return A2(
					$elm$html$Html$map,
					$author$project$App$Messages$ActivityMsg,
					$author$project$App$Activity$View$view(model.hg));
		}
	}();
	var left = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('grid grid-cols-1 gap-4 lg:col-span-2')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$tesk9$accessible_html$Accessibility$Aria$labelledBy('section-1-title')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sr-only'),
								$elm$html$Html$Attributes$id('section-1-title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Section title')
							])),
						makeDiv(contentByNav)
					]))
			]));
	return A2(
		$elm$html$Html$main_,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('-mt-24 pb-8')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sr-only')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Page title')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('grid grid-cols-1 items-start gap-4 lg:grid-cols-4 lg:gap-8')
							]),
						_List_fromArray(
							[
								left,
								withSearchResults ? right : $author$project$Models$Core$default
							]))
					]))
			]));
};
var $author$project$Models$Core$Desktop = 0;
var $author$project$Models$Core$Mobile = 1;
var $author$project$App$AppBar$Messages$NotificationsMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$App$AppBar$Messages$ChoseNavItem = function (a) {
	return {$: 0, a: a};
};
var $author$project$App$AppBar$Model$Profile = 2;
var $author$project$App$AppBar$Messages$SignOut = {$: 3};
var $author$project$App$AppBar$Messages$ToggleDropDown = {$: 2};
var $elm$html$Html$a = _VirtualDom_node('a');
var $author$project$Icon$person = function () {
	var dParts = _List_fromArray(
		['M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004', '15c4.904 0 9.26 2.354 11.996 5.993zM16.002', '8.999a4 4 0 11-8 0 4 4 0 018 0z']);
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class('size-full text-gray-400'),
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d(
						A2($elm$core$String$join, ' ', dParts))
					]),
				_List_Nil)
			]));
}();
var $author$project$App$AppBar$View$avatar = function (device) {
	var sizeClass = function () {
		if (device === 1) {
			return 'size-10';
		} else {
			return 'size-8';
		}
	}();
	var span1ClassParts = _List_fromArray(
		['inline-block', sizeClass, 'overflow-hidden', 'rounded-full']);
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$author$project$Models$Core$classFromParts(span1ClassParts)
			]),
		_List_fromArray(
			[$author$project$Icon$person]));
};
var $tesk9$accessible_html$Accessibility$Aria$expanded = A2(
	$elm$core$Basics$composeL,
	$tesk9$accessible_html$Accessibility$Utils$aria('expanded'),
	$tesk9$accessible_html$Accessibility$Utils$toBoolString);
var $tesk9$accessible_html$Accessibility$Aria$hasMenuPopUp = A2($tesk9$accessible_html$Accessibility$Utils$aria, 'haspopup', 'menu');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $tesk9$accessible_html$Accessibility$Utils$role = function (role_) {
	return A2($elm$html$Html$Attributes$attribute, 'role', role_);
};
var $tesk9$accessible_html$Accessibility$Role$menu = $tesk9$accessible_html$Accessibility$Utils$role('menu');
var $tesk9$accessible_html$Accessibility$Role$menuItem = $tesk9$accessible_html$Accessibility$Utils$role('menuitem');
var $tesk9$accessible_html$Accessibility$Aria$orientationVertical = A2($tesk9$accessible_html$Accessibility$Utils$aria, 'orientation', 'vertical');
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $author$project$App$AppBar$View$profileDropDown = function (model) {
	var menuBackdrop = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Models$Core$classFromParts(
				_List_fromArray(
					[
						'fixed inset-0 bg-black/5',
						model.hR ? 'z-20' : '',
						(!model.hR) ? 'hidden' : ''
					])),
				$tesk9$accessible_html$Accessibility$Aria$hidden(true),
				$elm$html$Html$Events$onClick($author$project$App$AppBar$Messages$ToggleDropDown)
			]),
		_List_Nil);
	var ddContent = function () {
		var makeItem = function (_v0) {
			var t = _v0.a;
			var msg = _v0.b;
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href('#'),
						$elm$html$Html$Attributes$class('block px-4 py-2 text-sm text-gray-700'),
						$elm$html$Html$Attributes$class('z-50'),
						$tesk9$accessible_html$Accessibility$Role$menuItem,
						$elm$html$Html$Attributes$tabindex(-1),
						$elm$html$Html$Attributes$id('user-menu-item-0'),
						$elm$html$Html$Events$onClick(msg)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(t)
					]));
		};
		var condParts = model.hR ? _List_fromArray(
			['ease-in opacity-100 scale-100']) : _List_fromArray(
			['ease-out opacity-0 scale-95']);
		var baseParts = _List_fromArray(
			['absolute -right-2 z-20 mt-2 w-48 origin-top-right', 'rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5', 'focus:outline-hidden transition duration-75 transform']);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Models$Core$classFromParts(
					A2($elm$core$List$append, baseParts, condParts)),
					$elm$html$Html$Attributes$class('z-50'),
					$tesk9$accessible_html$Accessibility$Role$menu,
					$tesk9$accessible_html$Accessibility$Aria$orientationVertical,
					$tesk9$accessible_html$Accessibility$Aria$labelledBy('user-menu-button'),
					$elm$html$Html$Attributes$tabindex(-1)
				]),
			A2(
				$elm$core$List$map,
				makeItem,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'Profile',
						$author$project$App$AppBar$Messages$ChoseNavItem(2)),
						_Utils_Tuple2('Sign Out', $author$project$App$AppBar$Messages$SignOut)
					])));
	}();
	var ddButton = function () {
		var classParts = _List_fromArray(
			['relative flex rounded-full bg-white text-sm', 'ring-2 ring-white/20', 'focus:ring-white focus:outline-hidden']);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$author$project$Models$Core$classFromParts(classParts),
							$elm$html$Html$Attributes$class('z-30'),
							$elm$html$Html$Attributes$id('user-menu-button'),
							$tesk9$accessible_html$Accessibility$Aria$expanded(false),
							$tesk9$accessible_html$Accessibility$Aria$hasMenuPopUp,
							$elm$html$Html$Events$onClick($author$project$App$AppBar$Messages$ToggleDropDown)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('absolute -inset-1.5')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sr-only')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Open user menu')
								])),
							$author$project$App$AppBar$View$avatar(0)
						]))
				]));
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('relative ml-4 shrink-0')
			]),
		_List_fromArray(
			[menuBackdrop, ddButton, ddContent]));
};
var $author$project$Icon$notification = function () {
	var dParts = _List_fromArray(
		['M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967', '8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967', '0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714', '0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0']);
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class('size-6'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$strokeWidth('1.5'),
				$elm$svg$Svg$Attributes$stroke('currentColor'),
				$tesk9$accessible_html$Accessibility$Aria$hidden(true)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$d(
						A2($elm$core$String$join, ' ', dParts))
					]),
				_List_Nil)
			]));
}();
var $author$project$App$AppBar$Notifications$View$view = function (device) {
	var condParts = function () {
		if (!device) {
			return _List_fromArray(
				['text-teal-200', 'hover:bg-white/10 hover:text-white', 'focus:ring-white']);
		} else {
			return _List_fromArray(
				['bg-white ml-auto text-gray-400', 'hover:text-gray-500 focus:ring-teal-600', 'focus:ring-offset-2']);
		}
	}();
	var baseParts = _List_fromArray(
		['relative shrink-0 rounded-full p-1', 'focus:ring-2 focus:outline-hidden']);
	var classParts = A2($elm$core$List$append, baseParts, condParts);
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('button'),
				$author$project$Models$Core$classFromParts(classParts)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('absolute -inset-1.5')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sr-only')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('View notifications')
					])),
				$author$project$Icon$notification
			]));
};
var $author$project$App$AppBar$View$desktopRight = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('hidden lg:ml-4 lg:flex lg:items-center lg:pr-0.5')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$App$AppBar$Messages$NotificationsMsg,
				$author$project$App$AppBar$Notifications$View$view(0)),
				$author$project$App$AppBar$View$profileDropDown(model)
			]));
};
var $author$project$App$AppBar$Messages$RingMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$App$AppBar$View$logo = function (model) {
	var makeRing = function (r) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$App$AppBar$Messages$ChoseNavItem(1))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$App$AppBar$Messages$RingMsg,
					$author$project$App$Ring$View$view(r))
				]));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('absolute left-0 shrink-0 lg:static text-white')
			]),
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Icon$lang,
				A2($elm$core$Maybe$map, makeRing, model.jr))
			]));
};
var $author$project$App$AppBar$Messages$ToggleMenu = {$: 1};
var $author$project$Icon$menuClosed = function (closed) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class(
				closed ? 'block' : 'hidden'),
				$elm$svg$Svg$Attributes$class('size-6'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$strokeWidth('1.5'),
				$elm$svg$Svg$Attributes$stroke('currentColor'),
				$tesk9$accessible_html$Accessibility$Aria$hidden(true)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$d('M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5')
					]),
				_List_Nil)
			]));
};
var $author$project$App$AppBar$View$menuButton = function (_v0) {
	var menu = _v0.iH;
	var condParts = menu ? _List_fromArray(
		['bg-white text-gray-400', 'hover:bg-gray-100 hover:text-gray-500', 'focus:ring-teal-500 focus:ring-inset']) : _List_fromArray(
		['bg-transparent text-white/70', 'hover:bg-white/10 hover:text-white focus:ring-white']);
	var baseParts = _List_fromArray(
		['relative inline-flex items-center justify-center', 'rounded-md p-2 focus:ring-2 focus:outline-hidden']);
	var classParts = A2($elm$core$List$append, baseParts, condParts);
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('button'),
				$elm$html$Html$Events$onClick($author$project$App$AppBar$Messages$ToggleMenu),
				$author$project$Models$Core$classFromParts(classParts),
				$tesk9$accessible_html$Accessibility$Aria$expanded(false)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('absolute -inset-0.5')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sr-only')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Open main menu')
					])),
				$author$project$Icon$menuClosed(!menu),
				$author$project$Icon$menuOpen(menu)
			]));
};
var $author$project$App$AppBar$SearchBar$Messages$DisableMenu = {$: 4};
var $author$project$App$AppBar$SearchBar$Messages$Clear = {$: 3};
var $author$project$App$AppBar$SearchBar$View$clearButton = function (model) {
	var condPart = (model.gC === '') ? 'hidden' : 'block';
	var baseParts = _List_fromArray(
		['absolute inset-y-0 right-0 pr-3', 'text-gray-400 hover:text-gray-600']);
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$App$AppBar$SearchBar$Messages$Clear),
				$author$project$Models$Core$classFromParts(
				A2($elm$core$List$cons, condPart, baseParts)),
				$elm$html$Html$Attributes$type_('button')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('✕')
			]));
};
var $elm$html$Html$Attributes$hidden = $elm$html$Html$Attributes$boolProperty('hidden');
var $author$project$Icon$search = function () {
	var dParts = _List_fromArray(
		['M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2', '9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0', '11-1.06 1.06l-3.329-3.328A7 7 0 012 9z']);
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class('h-5 w-5'),
				$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$tesk9$accessible_html$Accessibility$Aria$hidden(true)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$d(
						A2($elm$core$String$join, ' ', dParts)),
						$elm$svg$Svg$Attributes$clipRule('evenodd')
					]),
				_List_Nil)
			]));
}();
var $author$project$App$AppBar$SearchBar$Messages$SearchForTerm = {$: 1};
var $author$project$App$AppBar$SearchBar$Messages$SetSearchTerm = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $author$project$App$AppBar$SearchBar$View$searchForm = F3(
	function (device, identifier, model) {
		var condPart = function () {
			if (!device) {
				return 'text-sm/6';
			} else {
				return 'text-base sm:text-sm/6';
			}
		}();
		var baseParts = _List_fromArray(
			['peer col-start-1 row-start-1 block w-full', 'rounded-md bg-white/20 py-1.5 pr-3 pl-10', 'text-white outline-hidden placeholder:text-white', 'focus:bg-white focus:text-gray-900', 'focus:outline-2 focus:outline-offset-2', 'focus:outline-white/40 focus:placeholder:text-gray-400']);
		return A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Events$onSubmit($author$project$App$AppBar$SearchBar$Messages$SearchForTerm),
					A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'off')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(identifier),
							$author$project$Models$Core$classFromParts(
							A2($elm$core$List$cons, condPart, baseParts)),
							$elm$html$Html$Attributes$placeholder('Search'),
							$elm$html$Html$Attributes$autocomplete(false),
							A2($elm$html$Html$Attributes$attribute, 'autocorrect', 'off'),
							A2($elm$html$Html$Attributes$attribute, 'autocapitalize', 'off'),
							A2($elm$html$Html$Attributes$attribute, 'spellcheck', 'false'),
							$elm$html$Html$Attributes$type_('search'),
							$elm$html$Html$Attributes$name('srch'),
							$elm$html$Html$Events$onInput($author$project$App$AppBar$SearchBar$Messages$SetSearchTerm),
							$elm$html$Html$Attributes$value(model.gC),
							$elm$html$Html$Attributes$disabled(
							_Utils_eq(model.gN, $author$project$App$AppBar$SearchBar$Model$LoadingSearch))
						]),
					_List_Nil)
				]));
	});
var $author$project$App$AppBar$SearchBar$Messages$SearchForChoice = function (a) {
	return {$: 2, a: a};
};
var $author$project$Models$Search$catsFromSuggestion = function (_v0) {
	var pos = _v0.mO;
	return A2($elm$core$String$join, ', ', pos);
};
var $tesk9$accessible_html$Accessibility$Role$listBox = $tesk9$accessible_html$Accessibility$Utils$role('listbox');
var $tesk9$accessible_html$Accessibility$Role$option = $tesk9$accessible_html$Accessibility$Utils$role('option');
var $author$project$App$AppBar$SearchBar$View$suggestionsDropdown = function (model) {
	var ulClassParts = _List_fromArray(
		['max-h-72 scroll-py-2 overflow-y-auto py-2', 'text-sm text-gray-800 z-20']);
	var makeLi = F2(
		function (ind, s) {
			var word = A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(s.kl)
					]));
			var pos = function () {
				var possString = $author$project$Models$Search$catsFromSuggestion(s);
				return ($elm$core$String$length(possString) > 0) ? A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-gray-400 text-xs')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(' (' + (possString + ')'))
						])) : A2($elm$html$Html$span, _List_Nil, _List_Nil);
			}();
			return A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('cursor-default select-none px-4 py-2'),
						$elm$html$Html$Attributes$id(
						'option-' + $elm$core$String$fromInt(ind + 1)),
						$elm$html$Html$Attributes$tabindex(-1),
						$tesk9$accessible_html$Accessibility$Role$option,
						$elm$html$Html$Events$onClick(
						$author$project$App$AppBar$SearchBar$Messages$SearchForChoice(s.kl))
					]),
				_List_fromArray(
					[word, pos]));
		});
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('absolute w-full bg-white rounded-md shadow-md mt-1')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$author$project$Models$Core$classFromParts(ulClassParts),
						$elm$html$Html$Attributes$id('options'),
						$tesk9$accessible_html$Accessibility$Role$listBox,
						$elm$html$Html$Attributes$hidden(!model.iI)
					]),
				A2($elm$core$List$indexedMap, makeLi, model.jP))
			]));
};
var $author$project$App$AppBar$SearchBar$View$searchBarCore = F3(
	function (device, identifier, model) {
		var overlay = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fixed inset-0 z-20 bg-black/25'),
					$elm$html$Html$Attributes$hidden(!model.iI),
					$tesk9$accessible_html$Accessibility$Aria$hidden(true),
					$elm$html$Html$Events$onClick($author$project$App$AppBar$SearchBar$Messages$DisableMenu)
				]),
			_List_Nil);
		var div2ClassParts = _List_fromArray(
			['pointer-events-none absolute inset-y-0 left-0', 'flex items-center pl-3']);
		var div1ClassParts = _List_fromArray(
			['relative text-white focus-within:text-gray-600 z-30']);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$for(identifier),
						$elm$html$Html$Attributes$class('sr-only')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Search')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Models$Core$classFromParts(div1ClassParts)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Models$Core$classFromParts(div2ClassParts)
							]),
						_List_fromArray(
							[$author$project$Icon$search])),
						A3($author$project$App$AppBar$SearchBar$View$searchForm, device, identifier, model),
						$author$project$App$AppBar$SearchBar$View$clearButton(model),
						$author$project$App$AppBar$SearchBar$View$suggestionsDropdown(model)
					])),
				overlay
			]);
	});
var $author$project$App$AppBar$SearchBar$View$view = F2(
	function (device, model) {
		var core = A3($author$project$App$AppBar$SearchBar$View$searchBarCore, device, 'search', model);
		var condClass = function () {
			if (device === 1) {
				return 'mx-auto grid w-full max-w-xs grid-cols-1';
			} else {
				return 'mx-auto grid w-full grid-cols-1 lg:col-span-2';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(condClass)
				]),
			core);
	});
var $author$project$App$AppBar$View$searchBar = F2(
	function (device, model) {
		return A2(
			$elm$html$Html$map,
			$author$project$App$AppBar$Messages$SearchBarMsg,
			A2($author$project$App$AppBar$SearchBar$View$view, device, model.jA));
	});
var $author$project$App$AppBar$Model$navToString = function (n) {
	switch (n) {
		case 0:
			return 'Home';
		case 1:
			return 'Activity';
		default:
			return 'Profile';
	}
};
var $author$project$App$AppBar$View$viewNavigation = F2(
	function (device, _v0) {
		var isActive = _v0.io;
		var navigation = _v0.iS;
		var navItemIsDisabled = function (n) {
			return !A2(
				$elm$core$Maybe$withDefault,
				true,
				A2(
					$elm$core$Dict$get,
					$author$project$App$AppBar$Model$navToString(n),
					isActive));
		};
		var itemPairs = _List_fromArray(
			[
				_Utils_Tuple2(0, 'Home'),
				_Utils_Tuple2(1, 'Activity')
			]);
		var attrsBase = F2(
			function (n, ss) {
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$href('#'),
						$author$project$Models$Core$classFromParts(ss),
						$elm$html$Html$Events$onClick(
						$author$project$App$AppBar$Messages$ChoseNavItem(n))
					]);
			});
		if (device === 1) {
			var condAttr = function (n) {
				return _Utils_eq(navigation, n) ? 'text-gray-800 bg-gray-100 pointer-events-none' : (navItemIsDisabled(n) ? 'text-gray-900 opacity-50 pointer-events-none' : 'text-gray-900 hover:bg-gray-100 hover:text-gray-800');
			};
			var makeItem = function (_v2) {
				var n = _v2.a;
				var t = _v2.b;
				var attrs = A2(
					attrsBase,
					n,
					_List_fromArray(
						[
							'block rounded-md px-3 py-2 text-base font-medium',
							condAttr(n)
						]));
				return A2(
					$elm$html$Html$a,
					attrs,
					_List_fromArray(
						[
							$elm$html$Html$text(t)
						]));
			};
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mt-3 space-y-1 px-2')
					]),
				A2($elm$core$List$map, makeItem, itemPairs));
		} else {
			var condPart = function (n) {
				return _Utils_eq(navigation, n) ? 'text-white pointer-events-none' : (navItemIsDisabled(n) ? 'opacity-50 pointer-events-none' : 'text-teal-100');
			};
			var basePart = 'rounded-md px-3 py-2 text-sm font-medium hover:bg-white/10';
			var attrOther = function (n) {
				return _Utils_eq(n, navigation) ? _List_fromArray(
					[$tesk9$accessible_html$Accessibility$Aria$currentPage]) : _List_Nil;
			};
			var attrs = function (n) {
				return $elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							attrsBase,
							n,
							_List_fromArray(
								[
									basePart,
									condPart(n)
								])),
							attrOther(n)
						]));
			};
			var makeItem = function (_v3) {
				var n = _v3.a;
				var t = _v3.b;
				return A2(
					$elm$html$Html$a,
					attrs(n),
					_List_fromArray(
						[
							$elm$html$Html$text(t)
						]));
			};
			return A2(
				$elm$html$Html$nav,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex space-x-4')
					]),
				A2($elm$core$List$map, makeItem, itemPairs));
		}
	});
var $author$project$App$AppBar$View$appBarLines = function (model) {
	var lineTwo = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('hidden border-t border-white/20 py-5 lg:block')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('grid grid-cols-4 items-center gap-8')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('col-span-2')
							]),
						_List_fromArray(
							[
								A2($author$project$App$AppBar$View$viewNavigation, 0, model)
							])),
						A2($author$project$App$AppBar$View$searchBar, 0, model)
					]))
			]));
	var lineOne = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Models$Core$classFromParts(
				_List_fromArray(
					['relative flex items-center justify-center py-5 lg:justify-between']))
			]),
		_List_fromArray(
			[
				$author$project$App$AppBar$View$logo(model),
				$author$project$App$AppBar$View$desktopRight(model),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('min-w-0 flex-1 px-12 lg:hidden')
					]),
				_List_fromArray(
					[
						A2($author$project$App$AppBar$View$searchBar, 1, model)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('absolute right-0 shrink-0 lg:hidden')
					]),
				_List_fromArray(
					[
						$author$project$App$AppBar$View$menuButton(model)
					]))
			]));
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[lineOne, lineTwo]));
};
var $elm$html$Html$header = _VirtualDom_node('header');
var $author$project$App$AppBar$View$mobileMenuBottom = function (model) {
	var navigation = model.iS;
	var menu = model.iH;
	var userName = function () {
		var name = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.mn;
				},
				model.kd));
		var email = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ls;
				},
				model.kd));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ml-3 min-w-0 flex-1')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('truncate text-base font-medium text-gray-800')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('truncate text-sm font-medium text-gray-500')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(email)
						]))
				]));
	}();
	var userAvatar = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('shrink-0')
			]),
		_List_fromArray(
			[
				$author$project$App$AppBar$View$avatar(1)
			]));
	var partTwo = function () {
		var nIsNav = function (n) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (nav) {
						return _Utils_eq(nav, navigation);
					},
					n));
		};
		var itemClassParts = function (n) {
			var base = 'block rounded-md px-3 py-2 text-base font-medium';
			return nIsNav(n) ? _List_fromArray(
				[base, 'bg-gray-100 text-gray-800 pointer-events-none']) : _List_fromArray(
				[base, 'text-gray-900 hover:bg-gray-100 hover:text-gray-800']);
		};
		var makeItem = function (_v0) {
			var t = _v0.a;
			var maybeNav = _v0.b;
			var msg = _v0.c;
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href('#'),
						$author$project$Models$Core$classFromParts(
						itemClassParts(maybeNav)),
						$elm$html$Html$Events$onClick(msg)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(t)
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-3 space-y-1 px-2')
				]),
			A2(
				$elm$core$List$map,
				makeItem,
				_List_fromArray(
					[
						_Utils_Tuple3(
						'Profile',
						$elm$core$Maybe$Just(2),
						$author$project$App$AppBar$Messages$ChoseNavItem(2)),
						_Utils_Tuple3('Sign out', $elm$core$Maybe$Nothing, $author$project$App$AppBar$Messages$SignOut)
					])));
	}();
	var partOne = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center px-5')
			]),
		_List_fromArray(
			[
				userAvatar,
				userName,
				A2(
				$elm$html$Html$map,
				$author$project$App$AppBar$Messages$NotificationsMsg,
				$author$project$App$AppBar$Notifications$View$view(1))
			]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pt-4 pb-2')
			]),
		_List_fromArray(
			[partOne, partTwo]));
};
var $author$project$App$AppBar$View$mobileMenuTop = function (model) {
	var topP1 = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center justify-between px-4')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[$author$project$Icon$lang])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('-mr-2')
					]),
				_List_fromArray(
					[
						$author$project$App$AppBar$View$menuButton(model)
					]))
			]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('pt-3 pb-2')
			]),
		_List_fromArray(
			[
				topP1,
				A2($author$project$App$AppBar$View$viewNavigation, 1, model)
			]));
};
var $author$project$App$AppBar$View$mobileMenu = function (model) {
	var navigation = model.iS;
	var menu = model.iH;
	var overlay = function () {
		var condAttr = menu ? 'z-20 ease-out opacity-100' : 'ease-in opacity-0 hidden';
		var attrs = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					$author$project$Models$Core$classFromParts(
						_List_fromArray(
							['fixed inset-0 bg-black/25 duration-150', condAttr]))),
					$elm$core$Maybe$Just(
					$tesk9$accessible_html$Accessibility$Aria$hidden(true)),
					menu ? $elm$core$Maybe$Just(
					$elm$html$Html$Events$onClick($author$project$App$AppBar$Messages$ToggleMenu)) : $elm$core$Maybe$Nothing
				]));
		return A2($elm$html$Html$div, attrs, _List_Nil);
	}();
	var innerPart = function () {
		var condAttr = menu ? 'duration-150 ease-in opacity-100 scale-100 block' : 'duration-150 ease-out opacity-0 scale-95 hidden';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Models$Core$classFromParts(
					_List_fromArray(
						['absolute inset-x-0 top-0 z-30 mx-auto w-full max-w-3xl', 'origin-top transform p-2 transition', condAttr]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Models$Core$classFromParts(
							_List_fromArray(
								['divide-y divide-gray-200 rounded-lg bg-white', 'shadow-lg ring-1 ring-black/5']))
						]),
					_List_fromArray(
						[
							$author$project$App$AppBar$View$mobileMenuTop(model),
							$author$project$App$AppBar$View$mobileMenuBottom(model),
							$author$project$App$AppBar$View$ftr($elm$core$Maybe$Nothing)
						]))
				]));
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('lg:hidden')
			]),
		_List_fromArray(
			[overlay, innerPart]));
};
var $author$project$App$AppBar$View$view = function (model) {
	return A2(
		$elm$html$Html$header,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-teal-600 pb-24')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8')
					]),
				_List_fromArray(
					[
						$author$project$App$AppBar$View$appBarLines(model),
						$author$project$App$AppBar$View$mobileMenu(model)
					]))
			]));
};
var $author$project$App$Landing$View$ftr = $author$project$App$AppBar$View$ftr(
	$elm$core$Maybe$Just('py-8 border-t border-gray-200'));
var $author$project$App$Landing$Messages$ToggleMenu = function (a) {
	return {$: 0, a: a};
};
var $author$project$App$Landing$View$logo = A2(
	$elm$html$Html$a,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$href('#'),
			$elm$html$Html$Attributes$class('-m-1.5 p-1.5')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sr-only')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Nimoza')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('h-10 w-auto text-teal-600')
				]),
			_List_fromArray(
				[$author$project$Icon$lang]))
		]));
var $author$project$App$Landing$View$navigation = F2(
	function (device, model) {
		var navItems = _List_Nil;
		if (!device) {
			var makeNavItem = function (t) {
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('#'),
							$elm$html$Html$Attributes$class('text-sm font-semibold leading-6 text-gray-900')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(t)
						]));
			};
			return _Utils_Tuple2(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hidden lg:flex lg:gap-x-12')
						]),
					A2($elm$core$List$map, makeNavItem, navItems)),
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hidden lg:flex lg:flex-1 lg:justify-end')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(
									$author$project$Route$toString(3)),
									$elm$html$Html$Attributes$class('text-sm font-semibold leading-6 text-gray-900')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Log in'),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$tesk9$accessible_html$Accessibility$Aria$hidden(true)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('→')
										]))
								]))
						])));
		} else {
			var makeNavItem = function (t) {
				var classParts = _List_fromArray(
					['-mx-3 block rounded-lg px-3 py-2', 'text-base font-semibold', 'leading-7 text-gray-900 hover:bg-gray-50']);
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('#'),
							$author$project$Models$Core$classFromParts(classParts)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(t)
						]));
			};
			var loginAClassParts = _List_fromArray(
				['-mx-3 block rounded-lg px-3 py-2.5', 'text-base font-semibold', 'leading-7 text-gray-900 hover:bg-gray-50']);
			return _Utils_Tuple2(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('space-y-2 py-6')
						]),
					A2($elm$core$List$map, makeNavItem, navItems)),
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('py-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(
									$author$project$Route$toString(3)),
									$author$project$Models$Core$classFromParts(loginAClassParts)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Log in')
								]))
						])));
		}
	});
var $author$project$App$Landing$View$hdrNav = function (model) {
	var menuButton = function () {
		var classParts = _List_fromArray(
			['-m-2.5 inline-flex items-center justify-center', 'rounded-md p-2.5 text-gray-700']);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex lg:hidden')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('button'),
							$author$project$Models$Core$classFromParts(classParts),
							$elm$html$Html$Events$onClick(
							$author$project$App$Landing$Messages$ToggleMenu(!model.iH))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sr-only')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Open menu')
								])),
							$author$project$Icon$menuClosed(!model.iH)
						]))
				]));
	}();
	var logoDiv = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex lg:flex-1')
			]),
		_List_fromArray(
			[$author$project$App$Landing$View$logo]));
	var _v0 = A2($author$project$App$Landing$View$navigation, 0, model);
	var navig = _v0.a;
	var loginButton = _v0.b;
	return A2(
		$elm$html$Html$nav,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex items-center justify-between p-6 lg:px-8'),
				$tesk9$accessible_html$Accessibility$Aria$label('Global')
			]),
		_List_fromArray(
			[logoDiv, menuButton, navig, loginButton]));
};
var $author$project$Icon$close = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$class('h-6 w-6'),
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$tesk9$accessible_html$Accessibility$Aria$hidden(true)
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M6 18L18 6M6 6l12 12')
				]),
			_List_Nil)
		]));
var $tesk9$accessible_html$Accessibility$Role$dialog = $tesk9$accessible_html$Accessibility$Utils$role('dialog');
var $tesk9$accessible_html$Accessibility$Aria$modal = A2(
	$elm$core$Basics$composeL,
	$tesk9$accessible_html$Accessibility$Utils$aria('modal'),
	$tesk9$accessible_html$Accessibility$Utils$toBoolString);
var $author$project$App$Landing$View$mobileMenu = function (model) {
	var menuCloseButton = A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('button'),
				$elm$html$Html$Attributes$class('-m-2.5 rounded-md p-2.5 text-gray-700'),
				$elm$html$Html$Events$onClick(
				$author$project$App$Landing$Messages$ToggleMenu(false))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sr-only')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Close menu')
					])),
				$author$project$Icon$close
			]));
	var div2ClassParts = _List_fromArray(
		['fixed inset-y-0 right-0 z-50 w-full overflow-y-auto', 'bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10']);
	var backDrop = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fixed inset-0 z-50'),
				$elm$html$Html$Events$onClick(
				$author$project$App$Landing$Messages$ToggleMenu(false))
			]),
		_List_Nil);
	var _v0 = A2($author$project$App$Landing$View$navigation, 1, model);
	var navig = _v0.a;
	var loginButton = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('lg:hidden'),
				$tesk9$accessible_html$Accessibility$Role$dialog,
				$tesk9$accessible_html$Accessibility$Aria$modal(true),
				$elm$html$Html$Attributes$hidden(!model.iH)
			]),
		_List_fromArray(
			[
				backDrop,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Models$Core$classFromParts(div2ClassParts)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex items-center justify-between')
							]),
						_List_fromArray(
							[$author$project$App$Landing$View$logo, menuCloseButton])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mt-6 flow-root')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('-my-6 divide-y divide-gray-500/10')
									]),
								_List_fromArray(
									[navig, loginButton]))
							]))
					]))
			]));
};
var $author$project$App$Landing$View$hdr = function (model) {
	return A2(
		$elm$html$Html$header,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('absolute inset-x-0 top-0 z-50')
			]),
		_List_fromArray(
			[
				$author$project$App$Landing$View$hdrNav(model),
				$author$project$App$Landing$View$mobileMenu(model)
			]));
};
var $elm$html$Html$br = _VirtualDom_node('br');
var $author$project$App$Landing$View$cta = function () {
	var gradientClass = 'from-[#0891b2] to-[#16a34a]';
	var content = function () {
		var a1ClassParts = _List_fromArray(
			['rounded-md bg-teal-600 px-3.5 py-2.5', 'text-sm font-semibold text-white shadow-sm', 'hover:bg-teal-500 focus-visible:outline', 'focus-visible:outline-2 focus-visible:outline-offset-2', 'focus-visible:outline-teal-600']);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mx-auto max-w-2xl text-center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Boost your productivity.'),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							$elm$html$Html$text('Start using our app as early as today.')
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mx-auto mt-6 max-w-xl text-lg leading-8 text-gray-600')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									['At this time, we are onboarding users with strict learning', 'goals. If you are taking classes or are preparing to pass a', 'test, we would love to contribute to the optimal advancing', 'of your goals.'])))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-10 flex items-center justify-center gap-x-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(
									$author$project$Route$toString(2)),
									$author$project$Models$Core$classFromParts(a1ClassParts)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Get Started')
								]))
						]))
				]));
	}();
	var bgH2 = function () {
		var div2ClassParts = _List_fromArray(
			['aspect-1155/678 w-288.75 bg-linear-to-tr', gradientClass, 'opacity-30']);
		var div1ClassParts = _List_fromArray(
			['absolute left-1/2 right-0 top-full -z-10 hidden', '-translate-y-1/2 transform-gpu overflow-hidden blur-3xl', 'sm:block']);
		var clipPathValParts = _List_Nil;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Models$Core$classFromParts(div1ClassParts),
					$tesk9$accessible_html$Accessibility$Aria$hidden(true)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Models$Core$classFromParts(div2ClassParts),
							A2(
							$elm$html$Html$Attributes$style,
							'clip-path',
							A2($elm$core$String$join, ', ', clipPathValParts))
						]),
					_List_Nil)
				]));
	}();
	var bgH1 = function () {
		var div2ClassParts = _List_fromArray(
			['aspect-1108/632 w-277 flex-none bg-linear-to-r', gradientClass, 'opacity-25']);
		var div1ClassParts = _List_fromArray(
			['absolute inset-x-0 top-1/2 -z-10 flex -translate-y-1/2', 'transform-gpu justify-center overflow-hidden blur-3xl', 'sm:bottom-0 sm:right-[calc(50%-6rem)] sm:top-auto', 'sm:translate-y-0 sm:transform-gpu sm:justify-end']);
		var clipPathValParts = _List_fromArray(
			['polygon(73.6% 48.6%, 91.7% 88.5%, 100% 53.9%, 97.4% 18.1%', '92.5% 15.4%, 75.7% 36.3%, 55.3% 52.8%, 46.5% 50.9%', '45% 37.4%, 50.3% 13.1%, 21.3% 36.2%, 0.1% 0.1%, 5.4% 49.1%', '21.4% 36.4%, 58.9% 100%, 73.6% 48.6%)']);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Models$Core$classFromParts(div1ClassParts),
					$tesk9$accessible_html$Accessibility$Aria$hidden(true)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Models$Core$classFromParts(div2ClassParts),
							A2(
							$elm$html$Html$Attributes$style,
							'clip-path',
							A2($elm$core$String$join, ', ', clipPathValParts))
						]),
					_List_Nil)
				]));
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('relative -z-10 mt-32 px-6 lg:px-8 mb-10')
			]),
		_List_fromArray(
			[bgH1, content]));
}();
var $elm$html$Html$dt = _VirtualDom_node('dt');
var $author$project$Icon$iconWithPath = function (dParts) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$class('h-6 w-6 text-white'),
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$strokeWidth('1.5'),
				$elm$svg$Svg$Attributes$stroke('currentColor'),
				$tesk9$accessible_html$Accessibility$Aria$hidden(true)
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$d(
						A2($elm$core$String$join, ' ', dParts))
					]),
				_List_Nil)
			]));
};
var $author$project$App$Landing$View$features = function () {
	var top = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mx-auto max-w-2xl lg:text-center')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-base font-semibold leading-7 text-teal-600')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Get good at it with confidence')
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Learning can be enjoyable')
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mt-6 text-lg leading-8 text-gray-600')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$String$join,
							' ',
							_List_fromArray(
								['Once we know that every minute spent', 'would optimally get us closer,', 'in long- and short-term,', 'to mastery of the language,', 'we can enjoy the process'])))
					]))
			]));
	var defList = function () {
		var makeItem = function (_v0) {
			var dParts = _v0.a;
			var title = _v0.b;
			var contentParts = _v0.c;
			var divClassParts = _List_fromArray(
				['absolute left-0 top-0 flex h-10 w-10', 'items-center justify-center rounded-lg', 'bg-teal-600']);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('relative pl-16')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$dt,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-base font-semibold leading-7 text-gray-900')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Models$Core$classFromParts(divClassParts)
									]),
								_List_fromArray(
									[
										$author$project$Icon$iconWithPath(dParts)
									])),
								$elm$html$Html$text(title)
							])),
						A2(
						$elm$html$Html$dd,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mt-2 text-base leading-7 text-gray-600')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($elm$core$String$join, ' ', contentParts))
							]))
					]));
		};
		var dlClassParts = _List_fromArray(
			['grid max-w-xl grid-cols-1 gap-x-8 gap-y-10', 'lg:max-w-none lg:grid-cols-2 lg:gap-y-16']);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$dl,
					_List_fromArray(
						[
							$author$project$Models$Core$classFromParts(dlClassParts)
						]),
					A2(
						$elm$core$List$map,
						makeItem,
						_List_fromArray(
							[
								_Utils_Tuple3(
								_List_fromArray(
									['M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25', '12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5', '4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09', '3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0', '0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0', '2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456', '2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456', '2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25', '0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0', '1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423', '1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z']),
								'New way of learning',
								_List_fromArray(
									['Conversing with others and reading in German can be satisfying', 'once we reach higher levels. To get there more efficiently and', 'enjoyably, we curate sentences that fit your very own learning', 'journey.'])),
								_Utils_Tuple3(
								_List_fromArray(
									['M6.75 2.994v2.25m10.5-2.25v2.25m-14.252 13.5V7.491a2.25', '2.25 0 0 1 2.25-2.25h13.5a2.25 2.25 0 0 1 2.25', '2.25v11.251m-18 0a2.25 2.25 0 0 0 2.25 2.25h13.5a2.25', '2.25 0 0 0 2.25-2.25m-18 0v-7.5a2.25 2.25 0 0 1', '2.25-2.25h13.5a2.25 2.25 0 0 1 2.25 2.25v7.5m-6.75-6h2.25m-9', '2.25h4.5m.002-2.25h.005v.006H12v-.006Zm-.001', '4.5h.006v.006h-.006v-.005Zm-2.25.001h.005v.006H9.75v-.006Zm-2.25', '0h.005v.005h-.006v-.005Zm6.75-2.247h.005v.005h-.005v-.005Zm0', '2.247h.006v.006h-.006v-.006Zm2.25-2.248h.006V15H16.5v-.005Z']),
								'Timely exercises',
								_List_fromArray(
									['We use spaced repetition method to make sure that words and', 'structures are remembered and are reachable when you need them in', 'near future, as well as in the long term.'])),
								_Utils_Tuple3(
								_List_fromArray(
									['M12 3v17.25m0 0c-1.472 0-2.882.265-4.185.75M12 20.25c1.472', '0 2.882.265 4.185.75M18.75 4.97A48.416 48.416 0 0 0 12', '4.5c-2.291 0-4.545.16-6.75.47m13.5 0c1.01.143 2.01.317', '3 .52m-3-.52 2.62 10.726c.122.499-.106 1.028-.589', '1.202a5.988 5.988 0 0 1-2.031.352 5.988 5.988 0 0', '1-2.031-.352c-.483-.174-.711-.703-.59-1.202L18.75', '4.971Zm-16.5.52c.99-.203 1.99-.377 3-.52m0 0 2.62', '10.726c.122.499-.106 1.028-.589 1.202a5.989 5.989', '0 0 1-2.031.352 5.989 5.989 0 0', '1-2.031-.352c-.483-.174-.711-.703-.59-1.202L5.25 4.971Z']),
								'New words and phrases',
								_List_fromArray(
									['While prioritizing exercises of what you have so far learned,', 'we make sure that you learn new words and phrases that are', 'commonly used, so you feel more comfortable more quickly.'])),
								_Utils_Tuple3(
								_List_fromArray(
									['M12 18v-5.25m0 0a6.01 6.01 0 0 0 1.5-.189m-1.5.189a6.01', '6.01 0 0 1-1.5-.189m3.75 7.478a12.06 12.06 0 0 1-4.5', '0m3.75 2.383a14.406 14.406 0 0 1-3 0M14.25', '18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 1', '0-7.517 0c.85.493 1.509 1.333 1.509 2.316V18']),
								'Prioritized goals',
								_List_fromArray(
									['We make sure that you master each word that you look up,', 'while prioritizing the ones that are more commonly used.']))
							])))
				]));
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mx-auto mt-32 max-w-7xl px-6 sm:mt-56 lg:px-8')
			]),
		_List_fromArray(
			[top, defList]));
}();
var $elm$html$Html$img = _VirtualDom_node('img');
var $author$project$App$Landing$View$hero = function () {
	var gradientClass = 'bg-linear-to-tr from-[#0891b2] to-[#16a34a]';
	var contentPart2 = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mt-16 flow-root sm:mt-24')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($elm$html$Html$img, _List_Nil, _List_Nil)
					]))
			]));
	var contentPart1 = function () {
		var aClassParts = _List_fromArray(
			['rounded-md bg-teal-600 px-3.5 py-2.5', 'text-sm font-semibold text-white shadow-sm', 'hover:bg-teal-500 focus-visible:outline', 'focus-visible:outline-2 focus-visible:outline-offset-2', 'focus-visible:outline-teal-600']);
		var c2a = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-10 flex items-center justify-center gap-x-6')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(
							$author$project$Route$toString(2)),
							$author$project$Models$Core$classFromParts(aClassParts)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Get Started')
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mx-auto max-w-2xl text-center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Your self-populating todo list for mastering the German language')
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-6 text-lg leading-8 text-gray-600')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Checking off todos is often straightforward.')
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-lg leading-8 text-gray-600')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('The hardest part about learning a language is')
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-lg leading-8 text-gray-600')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('coming up with the next best things to do')
						])),
					c2a
				]));
	}();
	var clipPathValParts = _List_fromArray(
		['polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%', '80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%', '45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%', '76.1% 97.7%, 74.1% 44.1%)']);
	var bgH2 = function () {
		var div2ClassParts = _List_fromArray(
			['relative left-[calc(50%+3rem)] aspect-1155/678 w-144.5', '-translate-x-1/2', gradientClass, 'opacity-30 sm:left-[calc(50%+36rem)] sm:w-288.75']);
		var div1ClassParts = _List_fromArray(
			['absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu', 'overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]']);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Models$Core$classFromParts(div1ClassParts),
					$tesk9$accessible_html$Accessibility$Aria$hidden(true)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Models$Core$classFromParts(div2ClassParts),
							A2(
							$elm$html$Html$Attributes$style,
							'clip-path',
							A2($elm$core$String$join, ', ', clipPathValParts))
						]),
					_List_Nil)
				]));
	}();
	var bgH1 = function () {
		var div2ClassParts = _List_fromArray(
			['relative left-[calc(50%-11rem)] aspect-1155/678', 'w-144.5 -translate-x-1/2 rotate-30', gradientClass, 'opacity-30 sm:left-[calc(50%-30rem)] sm:w-288.75']);
		var div1ClassParts = _List_fromArray(
			['absolute inset-x-0 -top-40 -z-10 transform-gpu', 'overflow-hidden blur-3xl sm:-top-80']);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Models$Core$classFromParts(div1ClassParts),
					$tesk9$accessible_html$Accessibility$Aria$hidden(true)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Models$Core$classFromParts(div2ClassParts),
							A2(
							$elm$html$Html$Attributes$style,
							'clip-path',
							A2($elm$core$String$join, ', ', clipPathValParts))
						]),
					_List_Nil)
				]));
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('relative pt-14')
			]),
		_List_fromArray(
			[
				bgH1,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('py-24 sm:py-32')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mx-auto max-w-7xl px-6 lg:px-8')
							]),
						_List_fromArray(
							[contentPart1, contentPart2]))
					])),
				bgH2
			]));
}();
var $author$project$App$Landing$View$mn = function (model) {
	return A2(
		$elm$html$Html$main_,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('isolate')
			]),
		_List_fromArray(
			[$author$project$App$Landing$View$hero, $author$project$App$Landing$View$features, $author$project$App$Landing$View$cta]));
};
var $author$project$App$Landing$View$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('bg-white')
			]),
		_List_fromArray(
			[
				$author$project$App$Landing$View$hdr(model),
				$author$project$App$Landing$View$mn(model),
				$author$project$App$Landing$View$ftr
			]));
};
var $author$project$App$View$view = function (model) {
	var _v0 = _Utils_Tuple2(
		model.jt,
		$author$project$App$Auth$Model$isLoggedIn(model.hr));
	if (!_v0.a) {
		var _v1 = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$App$Messages$LandingMsg,
			$author$project$App$Landing$View$view(model.iu));
	} else {
		if (_v0.b) {
			var attrs = model.jz.hf ? _List_fromArray(
				[
					$elm$html$Html$Attributes$class('min-h-full overflow-hidden'),
					A2($elm$html$Html$Attributes$style, 'touch-action', 'pan-y')
				]) : _List_fromArray(
				[
					$elm$html$Html$Attributes$class('min-h-full'),
					A2($elm$html$Html$Attributes$style, 'touch-action', 'pan-y')
				]);
			return A2(
				$elm$html$Html$div,
				attrs,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$App$Messages$AppBarMsg,
						$author$project$App$AppBar$View$view(model.hp)),
						$author$project$App$View$mn(model),
						$author$project$App$View$ftr
					]));
		} else {
			return A2(
				$elm$html$Html$map,
				$author$project$App$Messages$AuthMsg,
				$author$project$App$Auth$View$view(model.hr));
		}
	}
};
var $author$project$Main$view = function (model) {
	return {
		hy: _List_fromArray(
			[
				$author$project$App$View$view(model)
			]),
		n$: 'nimoza'
	};
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{lY: $author$project$App$Update$init, my: $author$project$App$Messages$UrlChanged, mz: $author$project$App$Messages$LinkClicked, nN: $author$project$Main$subscriptions, or: $author$project$App$Update$update, oA: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	$elm$json$Json$Decode$succeed(0))(0)}});}(this));